/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 6493:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 7679:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// addapted from the document.currentScript polyfill by Adam Miller
// MIT license
// source: https://github.com/amiller-gh/currentScript-polyfill

// added support for Firefox https://bugzilla.mozilla.org/show_bug.cgi?id=1620505

(function (root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
}(typeof self !== 'undefined' ? self : this, function () {
  function getCurrentScript () {
    var descriptor = Object.getOwnPropertyDescriptor(document, 'currentScript')
    // for chrome
    if (!descriptor && 'currentScript' in document && document.currentScript) {
      return document.currentScript
    }

    // for other browsers with native support for currentScript
    if (descriptor && descriptor.get !== getCurrentScript && document.currentScript) {
      return document.currentScript
    }
  
    // IE 8-10 support script readyState
    // IE 11+ & Firefox support stack trace
    try {
      throw new Error();
    }
    catch (err) {
      // Find the second match for the "at" string to get file src url from stack.
      var ieStackRegExp = /.*at [^(]*\((.*):(.+):(.+)\)$/ig,
        ffStackRegExp = /@([^@]*):(\d+):(\d+)\s*$/ig,
        stackDetails = ieStackRegExp.exec(err.stack) || ffStackRegExp.exec(err.stack),
        scriptLocation = (stackDetails && stackDetails[1]) || false,
        line = (stackDetails && stackDetails[2]) || false,
        currentLocation = document.location.href.replace(document.location.hash, ''),
        pageSource,
        inlineScriptSourceRegExp,
        inlineScriptSource,
        scripts = document.getElementsByTagName('script'); // Live NodeList collection
  
      if (scriptLocation === currentLocation) {
        pageSource = document.documentElement.outerHTML;
        inlineScriptSourceRegExp = new RegExp('(?:[^\\n]+?\\n){0,' + (line - 2) + '}[^<]*<script>([\\d\\D]*?)<\\/script>[\\d\\D]*', 'i');
        inlineScriptSource = pageSource.replace(inlineScriptSourceRegExp, '$1').trim();
      }
  
      for (var i = 0; i < scripts.length; i++) {
        // If ready state is interactive, return the script tag
        if (scripts[i].readyState === 'interactive') {
          return scripts[i];
        }
  
        // If src matches, return the script tag
        if (scripts[i].src === scriptLocation) {
          return scripts[i];
        }
  
        // If inline source matches, return the script tag
        if (
          scriptLocation === currentLocation &&
          scripts[i].innerHTML &&
          scripts[i].innerHTML.trim() === inlineScriptSource
        ) {
          return scripts[i];
        }
      }
  
      // If no match, return null
      return null;
    }
  };

  return getCurrentScript
}));


/***/ }),

/***/ 9662:
/***/ (function(module, __unused_webpack_exports, __nested_webpack_require_3366__) {

var isCallable = __nested_webpack_require_3366__(614);
var tryToString = __nested_webpack_require_3366__(6330);

var $TypeError = TypeError;

// `Assert: IsCallable(argument) is true`
module.exports = function (argument) {
  if (isCallable(argument)) return argument;
  throw $TypeError(tryToString(argument) + ' is not a function');
};


/***/ }),

/***/ 1223:
/***/ (function(module, __unused_webpack_exports, __nested_webpack_require_3778__) {

var wellKnownSymbol = __nested_webpack_require_3778__(5112);
var create = __nested_webpack_require_3778__(30);
var defineProperty = (__nested_webpack_require_3778__(3070).f);

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  defineProperty(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create(null)
  });
}

// add a key to Array.prototype[@@unscopables]
module.exports = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ 9670:
/***/ (function(module, __unused_webpack_exports, __nested_webpack_require_4482__) {

var isObject = __nested_webpack_require_4482__(111);

var $String = String;
var $TypeError = TypeError;

// `Assert: Type(argument) is Object`
module.exports = function (argument) {
  if (isObject(argument)) return argument;
  throw $TypeError($String(argument) + ' is not an object');
};


/***/ }),

/***/ 8533:
/***/ (function(module, __unused_webpack_exports, __nested_webpack_require_4858__) {

"use strict";

var $forEach = (__nested_webpack_require_4858__(2092).forEach);
var arrayMethodIsStrict = __nested_webpack_require_4858__(9341);

var STRICT_METHOD = arrayMethodIsStrict('forEach');

// `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach
module.exports = !STRICT_METHOD ? function forEach(callbackfn /* , thisArg */) {
  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
} : [].forEach;


/***/ }),

/***/ 1318:
/***/ (function(module, __unused_webpack_exports, __nested_webpack_require_5487__) {

var toIndexedObject = __nested_webpack_require_5487__(5656);
var toAbsoluteIndex = __nested_webpack_require_5487__(1400);
var lengthOfArrayLike = __nested_webpack_require_5487__(6244);

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = lengthOfArrayLike(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),

/***/ 2092:
/***/ (function(module, __unused_webpack_exports, __nested_webpack_require_6852__) {

var bind = __nested_webpack_require_6852__(9974);
var uncurryThis = __nested_webpack_require_6852__(1702);
var IndexedObject = __nested_webpack_require_6852__(8361);
var toObject = __nested_webpack_require_6852__(7908);
var lengthOfArrayLike = __nested_webpack_require_6852__(6244);
var arraySpeciesCreate = __nested_webpack_require_6852__(5417);

var push = uncurryThis([].push);

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var createMethod = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var IS_FILTER_REJECT = TYPE == 7;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var boundFunction = bind(callbackfn, that);
    var length = lengthOfArrayLike(self);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push(target, value);      // filter
        } else switch (TYPE) {
          case 4: return false;             // every
          case 7: push(target, value);      // filterReject
        }
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

module.exports = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod(6),
  // `Array.prototype.filterReject` method
  // https://github.com/tc39/proposal-array-filtering
  filterReject: createMethod(7)
};


/***/ }),

/***/ 1194:
/***/ (function(module, __unused_webpack_exports, __nested_webpack_require_9761__) {

var fails = __nested_webpack_require_9761__(7293);
var wellKnownSymbol = __nested_webpack_require_9761__(5112);
var V8_VERSION = __nested_webpack_require_9761__(7392);

var SPECIES = wellKnownSymbol('species');

module.exports = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return V8_VERSION >= 51 || !fails(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};


/***/ }),

/***/ 9341:
/***/ (function(module, __unused_webpack_exports, __nested_webpack_require_10497__) {

"use strict";

var fails = __nested_webpack_require_10497__(7293);

module.exports = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call -- required for testing
    method.call(null, argument || function () { return 1; }, 1);
  });
};


/***/ }),

/***/ 3658:
/***/ (function(module, __unused_webpack_exports, __nested_webpack_require_10922__) {

"use strict";

var DESCRIPTORS = __nested_webpack_require_10922__(9781);
var isArray = __nested_webpack_require_10922__(3157);

var $TypeError = TypeError;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Safari < 13 does not throw an error in this case
var SILENT_ON_NON_WRITABLE_LENGTH_SET = DESCRIPTORS && !function () {
  // makes no sense without proper strict mode support
  if (this !== undefined) return true;
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', { writable: false }).length = 1;
  } catch (error) {
    return error instanceof TypeError;
  }
}();

module.exports = SILENT_ON_NON_WRITABLE_LENGTH_SET ? function (O, length) {
  if (isArray(O) && !getOwnPropertyDescriptor(O, 'length').writable) {
    throw $TypeError('Cannot set read only .length');
  } return O.length = length;
} : function (O, length) {
  return O.length = length;
};


/***/ }),

/***/ 7475:
/***/ (function(module, __unused_webpack_exports, __nested_webpack_require_12013__) {

var isArray = __nested_webpack_require_12013__(3157);
var isConstructor = __nested_webpack_require_12013__(4411);
var isObject = __nested_webpack_require_12013__(111);
var wellKnownSymbol = __nested_webpack_require_12013__(5112);

var SPECIES = wellKnownSymbol('species');
var $Array = Array;

// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (isConstructor(C) && (C === $Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? $Array : C;
};


/***/ }),

/***/ 5417:
/***/ (function(module, __unused_webpack_exports, __nested_webpack_require_12826__) {

var arraySpeciesConstructor = __nested_webpack_require_12826__(7475);

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray, length) {
  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};


/***/ }),

/***/ 4326:
/***/ (function(module, __unused_webpack_exports, __nested_webpack_require_13214__) {

var uncurryThis = __nested_webpack_require_13214__(1702);

var toString = uncurryThis({}.toString);
var stringSlice = uncurryThis(''.slice);

module.exports = function (it) {
  return stringSlice(toString(it), 8, -1);
};


/***/ }),

/***/ 648:
/***/ (function(module, __unused_webpack_exports, __nested_webpack_require_13520__) {

var TO_STRING_TAG_SUPPORT = __nested_webpack_require_13520__(1694);
var isCallable = __nested_webpack_require_13520__(614);
var classofRaw = __nested_webpack_require_13520__(4326);
var wellKnownSymbol = __nested_webpack_require_13520__(5112);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var $Object = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && isCallable(O.callee) ? 'Arguments' : result;
};


/***/ }),

/***/ 9920:
/***/ (function(module, __unused_webpack_exports, __nested_webpack_require_14640__) {

var hasOwn = __nested_webpack_require_14640__(2597);
var ownKeys = __nested_webpack_require_14640__(3887);
var getOwnPropertyDescriptorModule = __nested_webpack_require_14640__(1236);
var definePropertyModule = __nested_webpack_require_14640__(3070);

module.exports = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};


/***/ }),

/***/ 8880:
/***/ (function(module, __unused_webpack_exports, __nested_webpack_require_15368__) {

var DESCRIPTORS = __nested_webpack_require_15368__(9781);
var definePropertyModule = __nested_webpack_require_15368__(3070);
var createPropertyDescriptor = __nested_webpack_require_15368__(9114);

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ 9114:
/***/ (function(module) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ 6135:
/***/ (function(module, __unused_webpack_exports, __nested_webpack_require_16074__) {

"use strict";

var toPropertyKey = __nested_webpack_require_16074__(4948);
var definePropertyModule = __nested_webpack_require_16074__(3070);
var createPropertyDescriptor = __nested_webpack_require_16074__(9114);

module.exports = function (object, key, value) {
  var propertyKey = toPropertyKey(key);
  if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};


/***/ }),

/***/ 7045:
/***/ (function(module, __unused_webpack_exports, __nested_webpack_require_16586__) {

var makeBuiltIn = __nested_webpack_require_16586__(6339);
var defineProperty = __nested_webpack_require_16586__(3070);

module.exports = function (target, name, descriptor) {
  if (descriptor.get) makeBuiltIn(descriptor.get, name, { getter: true });
  if (descriptor.set) makeBuiltIn(descriptor.set, name, { setter: true });
  return defineProperty.f(target, name, descriptor);
};


/***/ }),

/***/ 8052:
/***/ (function(module, __unused_webpack_exports, __nested_webpack_require_17040__) {

var isCallable = __nested_webpack_require_17040__(614);
var definePropertyModule = __nested_webpack_require_17040__(3070);
var makeBuiltIn = __nested_webpack_require_17040__(6339);
var defineGlobalProperty = __nested_webpack_require_17040__(3072);

module.exports = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable(value)) makeBuiltIn(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else definePropertyModule.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};


/***/ }),

/***/ 3072:
/***/ (function(module, __unused_webpack_exports, __nested_webpack_require_18039__) {

var global = __nested_webpack_require_18039__(7854);

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;

module.exports = function (key, value) {
  try {
    defineProperty(global, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),

/***/ 9781:
/***/ (function(module, __unused_webpack_exports, __nested_webpack_require_18490__) {

var fails = __nested_webpack_require_18490__(7293);

// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});


/***/ }),

/***/ 4154:
/***/ (function(module) {

var documentAll = typeof document == 'object' && document.all;

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var IS_HTMLDDA = typeof documentAll == 'undefined' && documentAll !== undefined;

module.exports = {
  all: documentAll,
  IS_HTMLDDA: IS_HTMLDDA
};


/***/ }),

/***/ 317:
/***/ (function(module, __unused_webpack_exports, __nested_webpack_require_19293__) {

var global = __nested_webpack_require_19293__(7854);
var isObject = __nested_webpack_require_19293__(111);

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),

/***/ 7207:
/***/ (function(module) {

var $TypeError = TypeError;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991

module.exports = function (it) {
  if (it > MAX_SAFE_INTEGER) throw $TypeError('Maximum allowed index exceeded');
  return it;
};


/***/ }),

/***/ 8324:
/***/ (function(module) {

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};


/***/ }),

/***/ 8509:
/***/ (function(module, __unused_webpack_exports, __nested_webpack_require_20810__) {

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = __nested_webpack_require_20810__(317);

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype = classList && classList.constructor && classList.constructor.prototype;

module.exports = DOMTokenListPrototype === Object.prototype ? undefined : DOMTokenListPrototype;


/***/ }),

/***/ 8113:
/***/ (function(module) {

module.exports = typeof navigator != 'undefined' && String(navigator.userAgent) || '';


/***/ }),

/***/ 7392:
/***/ (function(module, __unused_webpack_exports, __nested_webpack_require_21448__) {

var global = __nested_webpack_require_21448__(7854);
var userAgent = __nested_webpack_require_21448__(8113);

var process = global.process;
var Deno = global.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

module.exports = version;


/***/ }),

/***/ 748:
/***/ (function(module) {

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),

/***/ 2109:
/***/ (function(module, __unused_webpack_exports, __nested_webpack_require_22605__) {

var global = __nested_webpack_require_22605__(7854);
var getOwnPropertyDescriptor = (__nested_webpack_require_22605__(1236).f);
var createNonEnumerableProperty = __nested_webpack_require_22605__(8880);
var defineBuiltIn = __nested_webpack_require_22605__(8052);
var defineGlobalProperty = __nested_webpack_require_22605__(3072);
var copyConstructorProperties = __nested_webpack_require_22605__(9920);
var isForced = __nested_webpack_require_22605__(4705);

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    defineBuiltIn(target, key, sourceProperty, options);
  }
};


/***/ }),

/***/ 7293:
/***/ (function(module) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),

/***/ 9974:
/***/ (function(module, __unused_webpack_exports, __nested_webpack_require_25399__) {

var uncurryThis = __nested_webpack_require_25399__(1470);
var aCallable = __nested_webpack_require_25399__(9662);
var NATIVE_BIND = __nested_webpack_require_25399__(4374);

var bind = uncurryThis(uncurryThis.bind);

// optional / simple context binding
module.exports = function (fn, that) {
  aCallable(fn);
  return that === undefined ? fn : NATIVE_BIND ? bind(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ 4374:
/***/ (function(module, __unused_webpack_exports, __nested_webpack_require_25907__) {

var fails = __nested_webpack_require_25907__(7293);

module.exports = !fails(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});


/***/ }),

/***/ 6916:
/***/ (function(module, __unused_webpack_exports, __nested_webpack_require_26339__) {

var NATIVE_BIND = __nested_webpack_require_26339__(4374);

var call = Function.prototype.call;

module.exports = NATIVE_BIND ? call.bind(call) : function () {
  return call.apply(call, arguments);
};


/***/ }),

/***/ 6530:
/***/ (function(module, __unused_webpack_exports, __nested_webpack_require_26625__) {

var DESCRIPTORS = __nested_webpack_require_26625__(9781);
var hasOwn = __nested_webpack_require_26625__(2597);

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS || (DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable));

module.exports = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};


/***/ }),

/***/ 1470:
/***/ (function(module, __unused_webpack_exports, __nested_webpack_require_27410__) {

var classofRaw = __nested_webpack_require_27410__(4326);
var uncurryThis = __nested_webpack_require_27410__(1702);

module.exports = function (fn) {
  // Nashorn bug:
  //   https://github.com/zloirock/core-js/issues/1128
  //   https://github.com/zloirock/core-js/issues/1130
  if (classofRaw(fn) === 'Function') return uncurryThis(fn);
};


/***/ }),

/***/ 1702:
/***/ (function(module, __unused_webpack_exports, __nested_webpack_require_27824__) {

var NATIVE_BIND = __nested_webpack_require_27824__(4374);

var FunctionPrototype = Function.prototype;
var call = FunctionPrototype.call;
var uncurryThisWithBind = NATIVE_BIND && FunctionPrototype.bind.bind(call, call);

module.exports = NATIVE_BIND ? uncurryThisWithBind : function (fn) {
  return function () {
    return call.apply(fn, arguments);
  };
};


/***/ }),

/***/ 5005:
/***/ (function(module, __unused_webpack_exports, __nested_webpack_require_28269__) {

var global = __nested_webpack_require_28269__(7854);
var isCallable = __nested_webpack_require_28269__(614);

var aFunction = function (argument) {
  return isCallable(argument) ? argument : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global[namespace]) : global[namespace] && global[namespace][method];
};


/***/ }),

/***/ 8173:
/***/ (function(module, __unused_webpack_exports, __nested_webpack_require_28710__) {

var aCallable = __nested_webpack_require_28710__(9662);
var isNullOrUndefined = __nested_webpack_require_28710__(8554);

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function (V, P) {
  var func = V[P];
  return isNullOrUndefined(func) ? undefined : aCallable(func);
};


/***/ }),

/***/ 7854:
/***/ (function(module, __unused_webpack_exports, __nested_webpack_require_29101__) {

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof __nested_webpack_require_29101__.g == 'object' && __nested_webpack_require_29101__.g) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || this || Function('return this')();


/***/ }),

/***/ 2597:
/***/ (function(module, __unused_webpack_exports, __nested_webpack_require_29828__) {

var uncurryThis = __nested_webpack_require_29828__(1702);
var toObject = __nested_webpack_require_29828__(7908);

var hasOwnProperty = uncurryThis({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
module.exports = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject(it), key);
};


/***/ }),

/***/ 3501:
/***/ (function(module) {

module.exports = {};


/***/ }),

/***/ 490:
/***/ (function(module, __unused_webpack_exports, __nested_webpack_require_30391__) {

var getBuiltIn = __nested_webpack_require_30391__(5005);

module.exports = getBuiltIn('document', 'documentElement');


/***/ }),

/***/ 4664:
/***/ (function(module, __unused_webpack_exports, __nested_webpack_require_30595__) {

var DESCRIPTORS = __nested_webpack_require_30595__(9781);
var fails = __nested_webpack_require_30595__(7293);
var createElement = __nested_webpack_require_30595__(317);

// Thanks to IE8 for its funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


/***/ }),

/***/ 8361:
/***/ (function(module, __unused_webpack_exports, __nested_webpack_require_31119__) {

var uncurryThis = __nested_webpack_require_31119__(1702);
var fails = __nested_webpack_require_31119__(7293);
var classof = __nested_webpack_require_31119__(4326);

var $Object = Object;
var split = uncurryThis(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split(it, '') : $Object(it);
} : $Object;


/***/ }),

/***/ 2788:
/***/ (function(module, __unused_webpack_exports, __nested_webpack_require_31793__) {

var uncurryThis = __nested_webpack_require_31793__(1702);
var isCallable = __nested_webpack_require_31793__(614);
var store = __nested_webpack_require_31793__(5465);

var functionToString = uncurryThis(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable(store.inspectSource)) {
  store.inspectSource = function (it) {
    return functionToString(it);
  };
}

module.exports = store.inspectSource;


/***/ }),

/***/ 9909:
/***/ (function(module, __unused_webpack_exports, __nested_webpack_require_32315__) {

var NATIVE_WEAK_MAP = __nested_webpack_require_32315__(4811);
var global = __nested_webpack_require_32315__(7854);
var isObject = __nested_webpack_require_32315__(111);
var createNonEnumerableProperty = __nested_webpack_require_32315__(8880);
var hasOwn = __nested_webpack_require_32315__(2597);
var shared = __nested_webpack_require_32315__(5465);
var sharedKey = __nested_webpack_require_32315__(6200);
var hiddenKeys = __nested_webpack_require_32315__(3501);

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError = global.TypeError;
var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  /* eslint-disable no-self-assign -- prototype methods protection */
  store.get = store.get;
  store.has = store.has;
  store.set = store.set;
  /* eslint-enable no-self-assign -- prototype methods protection */
  set = function (it, metadata) {
    if (store.has(it)) throw TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store.set(it, metadata);
    return metadata;
  };
  get = function (it) {
    return store.get(it) || {};
  };
  has = function (it) {
    return store.has(it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn(it, STATE)) throw TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),

/***/ 3157:
/***/ (function(module, __unused_webpack_exports, __nested_webpack_require_34366__) {

var classof = __nested_webpack_require_34366__(4326);

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
module.exports = Array.isArray || function isArray(argument) {
  return classof(argument) == 'Array';
};


/***/ }),

/***/ 614:
/***/ (function(module, __unused_webpack_exports, __nested_webpack_require_34739__) {

var $documentAll = __nested_webpack_require_34739__(4154);

var documentAll = $documentAll.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
module.exports = $documentAll.IS_HTMLDDA ? function (argument) {
  return typeof argument == 'function' || argument === documentAll;
} : function (argument) {
  return typeof argument == 'function';
};


/***/ }),

/***/ 4411:
/***/ (function(module, __unused_webpack_exports, __nested_webpack_require_35202__) {

var uncurryThis = __nested_webpack_require_35202__(1702);
var fails = __nested_webpack_require_35202__(7293);
var isCallable = __nested_webpack_require_35202__(614);
var classof = __nested_webpack_require_35202__(648);
var getBuiltIn = __nested_webpack_require_35202__(5005);
var inspectSource = __nested_webpack_require_35202__(2788);

var noop = function () { /* empty */ };
var empty = [];
var construct = getBuiltIn('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec = uncurryThis(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.exec(noop);

var isConstructorModern = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  try {
    construct(noop, empty, argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  switch (classof(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
  }
  try {
    // we can't check .prototype since constructors produced by .bind haven't it
    // `Function#toString` throws on some built-it function in some legacy engines
    // (for example, `DOMQuad` and similar in FF41-)
    return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource(argument));
  } catch (error) {
    return true;
  }
};

isConstructorLegacy.sham = true;

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
module.exports = !construct || fails(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;


/***/ }),

/***/ 4705:
/***/ (function(module, __unused_webpack_exports, __nested_webpack_require_37036__) {

var fails = __nested_webpack_require_37036__(7293);
var isCallable = __nested_webpack_require_37036__(614);

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable(detection) ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),

/***/ 8554:
/***/ (function(module) {

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
module.exports = function (it) {
  return it === null || it === undefined;
};


/***/ }),

/***/ 111:
/***/ (function(module, __unused_webpack_exports, __nested_webpack_require_37998__) {

var isCallable = __nested_webpack_require_37998__(614);
var $documentAll = __nested_webpack_require_37998__(4154);

var documentAll = $documentAll.all;

module.exports = $documentAll.IS_HTMLDDA ? function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it) || it === documentAll;
} : function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it);
};


/***/ }),

/***/ 1913:
/***/ (function(module) {

module.exports = false;


/***/ }),

/***/ 2190:
/***/ (function(module, __unused_webpack_exports, __nested_webpack_require_38530__) {

var getBuiltIn = __nested_webpack_require_38530__(5005);
var isCallable = __nested_webpack_require_38530__(614);
var isPrototypeOf = __nested_webpack_require_38530__(7976);
var USE_SYMBOL_AS_UID = __nested_webpack_require_38530__(3307);

var $Object = Object;

module.exports = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn('Symbol');
  return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, $Object(it));
};


/***/ }),

/***/ 6244:
/***/ (function(module, __unused_webpack_exports, __nested_webpack_require_39063__) {

var toLength = __nested_webpack_require_39063__(7466);

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
module.exports = function (obj) {
  return toLength(obj.length);
};


/***/ }),

/***/ 6339:
/***/ (function(module, __unused_webpack_exports, __nested_webpack_require_39365__) {

var uncurryThis = __nested_webpack_require_39365__(1702);
var fails = __nested_webpack_require_39365__(7293);
var isCallable = __nested_webpack_require_39365__(614);
var hasOwn = __nested_webpack_require_39365__(2597);
var DESCRIPTORS = __nested_webpack_require_39365__(9781);
var CONFIGURABLE_FUNCTION_NAME = (__nested_webpack_require_39365__(6530).CONFIGURABLE);
var inspectSource = __nested_webpack_require_39365__(2788);
var InternalStateModule = __nested_webpack_require_39365__(9909);

var enforceInternalState = InternalStateModule.enforce;
var getInternalState = InternalStateModule.get;
var $String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;
var stringSlice = uncurryThis(''.slice);
var replace = uncurryThis(''.replace);
var join = uncurryThis([].join);

var CONFIGURABLE_LENGTH = DESCRIPTORS && !fails(function () {
  return defineProperty(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn = module.exports = function (value, name, options) {
  if (stringSlice($String(name), 0, 7) === 'Symbol(') {
    name = '[' + replace($String(name), /^Symbol\(([^)]*)\)/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
    if (DESCRIPTORS) defineProperty(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn(options, 'arity') && value.length !== options.arity) {
    defineProperty(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS) defineProperty(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState(value);
  if (!hasOwn(state, 'source')) {
    state.source = join(TEMPLATE, typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn(function toString() {
  return isCallable(this) && getInternalState(this).source || inspectSource(this);
}, 'toString');


/***/ }),

/***/ 4758:
/***/ (function(module) {

var ceil = Math.ceil;
var floor = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
module.exports = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor : ceil)(n);
};


/***/ }),

/***/ 30:
/***/ (function(module, __unused_webpack_exports, __nested_webpack_require_42281__) {

/* global ActiveXObject -- old IE, WSH */
var anObject = __nested_webpack_require_42281__(9670);
var definePropertiesModule = __nested_webpack_require_42281__(6048);
var enumBugKeys = __nested_webpack_require_42281__(748);
var hiddenKeys = __nested_webpack_require_42281__(3501);
var html = __nested_webpack_require_42281__(490);
var documentCreateElement = __nested_webpack_require_42281__(317);
var sharedKey = __nested_webpack_require_42281__(6200);

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};


/***/ }),

/***/ 6048:
/***/ (function(__unused_webpack_module, exports, __nested_webpack_require_45361__) {

var DESCRIPTORS = __nested_webpack_require_45361__(9781);
var V8_PROTOTYPE_DEFINE_BUG = __nested_webpack_require_45361__(3353);
var definePropertyModule = __nested_webpack_require_45361__(3070);
var anObject = __nested_webpack_require_45361__(9670);
var toIndexedObject = __nested_webpack_require_45361__(5656);
var objectKeys = __nested_webpack_require_45361__(1956);

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
exports.f = DESCRIPTORS && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var props = toIndexedObject(Properties);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], props[key]);
  return O;
};


/***/ }),

/***/ 3070:
/***/ (function(__unused_webpack_module, exports, __nested_webpack_require_46284__) {

var DESCRIPTORS = __nested_webpack_require_46284__(9781);
var IE8_DOM_DEFINE = __nested_webpack_require_46284__(4664);
var V8_PROTOTYPE_DEFINE_BUG = __nested_webpack_require_46284__(3353);
var anObject = __nested_webpack_require_46284__(9670);
var toPropertyKey = __nested_webpack_require_46284__(4948);

var $TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE in Attributes ? Attributes[CONFIGURABLE] : current[CONFIGURABLE],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw $TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ 1236:
/***/ (function(__unused_webpack_module, exports, __nested_webpack_require_48193__) {

var DESCRIPTORS = __nested_webpack_require_48193__(9781);
var call = __nested_webpack_require_48193__(6916);
var propertyIsEnumerableModule = __nested_webpack_require_48193__(5296);
var createPropertyDescriptor = __nested_webpack_require_48193__(9114);
var toIndexedObject = __nested_webpack_require_48193__(5656);
var toPropertyKey = __nested_webpack_require_48193__(4948);
var hasOwn = __nested_webpack_require_48193__(2597);
var IE8_DOM_DEFINE = __nested_webpack_require_48193__(4664);

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPropertyKey(P);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
};


/***/ }),

/***/ 8006:
/***/ (function(__unused_webpack_module, exports, __nested_webpack_require_49283__) {

var internalObjectKeys = __nested_webpack_require_49283__(6324);
var enumBugKeys = __nested_webpack_require_49283__(748);

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),

/***/ 5181:
/***/ (function(__unused_webpack_module, exports) {

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ 7976:
/***/ (function(module, __unused_webpack_exports, __nested_webpack_require_50021__) {

var uncurryThis = __nested_webpack_require_50021__(1702);

module.exports = uncurryThis({}.isPrototypeOf);


/***/ }),

/***/ 6324:
/***/ (function(module, __unused_webpack_exports, __nested_webpack_require_50214__) {

var uncurryThis = __nested_webpack_require_50214__(1702);
var hasOwn = __nested_webpack_require_50214__(2597);
var toIndexedObject = __nested_webpack_require_50214__(5656);
var indexOf = (__nested_webpack_require_50214__(1318).indexOf);
var hiddenKeys = __nested_webpack_require_50214__(3501);

var push = uncurryThis([].push);

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn(O, key = names[i++])) {
    ~indexOf(result, key) || push(result, key);
  }
  return result;
};


/***/ }),

/***/ 1956:
/***/ (function(module, __unused_webpack_exports, __nested_webpack_require_50949__) {

var internalObjectKeys = __nested_webpack_require_50949__(6324);
var enumBugKeys = __nested_webpack_require_50949__(748);

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),

/***/ 5296:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;


/***/ }),

/***/ 288:
/***/ (function(module, __unused_webpack_exports, __nested_webpack_require_52086__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __nested_webpack_require_52086__(1694);
var classof = __nested_webpack_require_52086__(648);

// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};


/***/ }),

/***/ 2140:
/***/ (function(module, __unused_webpack_exports, __nested_webpack_require_52530__) {

var call = __nested_webpack_require_52530__(6916);
var isCallable = __nested_webpack_require_52530__(614);
var isObject = __nested_webpack_require_52530__(111);

var $TypeError = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  throw $TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ 3887:
/***/ (function(module, __unused_webpack_exports, __nested_webpack_require_53302__) {

var getBuiltIn = __nested_webpack_require_53302__(5005);
var uncurryThis = __nested_webpack_require_53302__(1702);
var getOwnPropertyNamesModule = __nested_webpack_require_53302__(8006);
var getOwnPropertySymbolsModule = __nested_webpack_require_53302__(5181);
var anObject = __nested_webpack_require_53302__(9670);

var concat = uncurryThis([].concat);

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
};


/***/ }),

/***/ 4488:
/***/ (function(module, __unused_webpack_exports, __nested_webpack_require_54024__) {

var isNullOrUndefined = __nested_webpack_require_54024__(8554);

var $TypeError = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (isNullOrUndefined(it)) throw $TypeError("Can't call method on " + it);
  return it;
};


/***/ }),

/***/ 6200:
/***/ (function(module, __unused_webpack_exports, __nested_webpack_require_54432__) {

var shared = __nested_webpack_require_54432__(2309);
var uid = __nested_webpack_require_54432__(9711);

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),

/***/ 5465:
/***/ (function(module, __unused_webpack_exports, __nested_webpack_require_54720__) {

var global = __nested_webpack_require_54720__(7854);
var defineGlobalProperty = __nested_webpack_require_54720__(3072);

var SHARED = '__core-js_shared__';
var store = global[SHARED] || defineGlobalProperty(SHARED, {});

module.exports = store;


/***/ }),

/***/ 2309:
/***/ (function(module, __unused_webpack_exports, __nested_webpack_require_55038__) {

var IS_PURE = __nested_webpack_require_55038__(1913);
var store = __nested_webpack_require_55038__(5465);

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.30.2',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2014-2023 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.30.2/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});


/***/ }),

/***/ 6293:
/***/ (function(module, __unused_webpack_exports, __nested_webpack_require_55597__) {

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION = __nested_webpack_require_55597__(7392);
var fails = __nested_webpack_require_55597__(7293);
var global = __nested_webpack_require_55597__(7854);

var $String = global.String;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
  // of course, fail.
  return !$String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});


/***/ }),

/***/ 1400:
/***/ (function(module, __unused_webpack_exports, __nested_webpack_require_56578__) {

var toIntegerOrInfinity = __nested_webpack_require_56578__(9303);

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toIntegerOrInfinity(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),

/***/ 5656:
/***/ (function(module, __unused_webpack_exports, __nested_webpack_require_57127__) {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __nested_webpack_require_57127__(8361);
var requireObjectCoercible = __nested_webpack_require_57127__(4488);

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),

/***/ 9303:
/***/ (function(module, __unused_webpack_exports, __nested_webpack_require_57475__) {

var trunc = __nested_webpack_require_57475__(4758);

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
module.exports = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};


/***/ }),

/***/ 7466:
/***/ (function(module, __unused_webpack_exports, __nested_webpack_require_57901__) {

var toIntegerOrInfinity = __nested_webpack_require_57901__(9303);

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),

/***/ 7908:
/***/ (function(module, __unused_webpack_exports, __nested_webpack_require_58308__) {

var requireObjectCoercible = __nested_webpack_require_58308__(4488);

var $Object = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function (argument) {
  return $Object(requireObjectCoercible(argument));
};


/***/ }),

/***/ 7593:
/***/ (function(module, __unused_webpack_exports, __nested_webpack_require_58655__) {

var call = __nested_webpack_require_58655__(6916);
var isObject = __nested_webpack_require_58655__(111);
var isSymbol = __nested_webpack_require_58655__(2190);
var getMethod = __nested_webpack_require_58655__(8173);
var ordinaryToPrimitive = __nested_webpack_require_58655__(2140);
var wellKnownSymbol = __nested_webpack_require_58655__(5112);

var $TypeError = TypeError;
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function (input, pref) {
  if (!isObject(input) || isSymbol(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call(exoticToPrim, input, pref);
    if (!isObject(result) || isSymbol(result)) return result;
    throw $TypeError("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};


/***/ }),

/***/ 4948:
/***/ (function(module, __unused_webpack_exports, __nested_webpack_require_59681__) {

var toPrimitive = __nested_webpack_require_59681__(7593);
var isSymbol = __nested_webpack_require_59681__(2190);

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};


/***/ }),

/***/ 1694:
/***/ (function(module, __unused_webpack_exports, __nested_webpack_require_60080__) {

var wellKnownSymbol = __nested_webpack_require_60080__(5112);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),

/***/ 6330:
/***/ (function(module) {

var $String = String;

module.exports = function (argument) {
  try {
    return $String(argument);
  } catch (error) {
    return 'Object';
  }
};


/***/ }),

/***/ 9711:
/***/ (function(module, __unused_webpack_exports, __nested_webpack_require_60573__) {

var uncurryThis = __nested_webpack_require_60573__(1702);

var id = 0;
var postfix = Math.random();
var toString = uncurryThis(1.0.toString);

module.exports = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
};


/***/ }),

/***/ 3307:
/***/ (function(module, __unused_webpack_exports, __nested_webpack_require_60930__) {

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL = __nested_webpack_require_60930__(6293);

module.exports = NATIVE_SYMBOL
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';


/***/ }),

/***/ 3353:
/***/ (function(module, __unused_webpack_exports, __nested_webpack_require_61225__) {

var DESCRIPTORS = __nested_webpack_require_61225__(9781);
var fails = __nested_webpack_require_61225__(7293);

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
module.exports = DESCRIPTORS && fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype != 42;
});


/***/ }),

/***/ 4811:
/***/ (function(module, __unused_webpack_exports, __nested_webpack_require_61754__) {

var global = __nested_webpack_require_61754__(7854);
var isCallable = __nested_webpack_require_61754__(614);

var WeakMap = global.WeakMap;

module.exports = isCallable(WeakMap) && /native code/.test(String(WeakMap));


/***/ }),

/***/ 5112:
/***/ (function(module, __unused_webpack_exports, __nested_webpack_require_62045__) {

var global = __nested_webpack_require_62045__(7854);
var shared = __nested_webpack_require_62045__(2309);
var hasOwn = __nested_webpack_require_62045__(2597);
var uid = __nested_webpack_require_62045__(9711);
var NATIVE_SYMBOL = __nested_webpack_require_62045__(6293);
var USE_SYMBOL_AS_UID = __nested_webpack_require_62045__(3307);

var Symbol = global.Symbol;
var WellKnownSymbolsStore = shared('wks');
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol['for'] || Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!hasOwn(WellKnownSymbolsStore, name)) {
    WellKnownSymbolsStore[name] = NATIVE_SYMBOL && hasOwn(Symbol, name)
      ? Symbol[name]
      : createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};


/***/ }),

/***/ 2222:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __nested_webpack_require_62868__) {

"use strict";

var $ = __nested_webpack_require_62868__(2109);
var fails = __nested_webpack_require_62868__(7293);
var isArray = __nested_webpack_require_62868__(3157);
var isObject = __nested_webpack_require_62868__(111);
var toObject = __nested_webpack_require_62868__(7908);
var lengthOfArrayLike = __nested_webpack_require_62868__(6244);
var doesNotExceedSafeInteger = __nested_webpack_require_62868__(7207);
var createProperty = __nested_webpack_require_62868__(6135);
var arraySpeciesCreate = __nested_webpack_require_62868__(5417);
var arrayMethodHasSpeciesSupport = __nested_webpack_require_62868__(1194);
var wellKnownSymbol = __nested_webpack_require_62868__(5112);
var V8_VERSION = __nested_webpack_require_62868__(7392);

var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');

// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});

var isConcatSpreadable = function (O) {
  if (!isObject(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray(O);
};

var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !arrayMethodHasSpeciesSupport('concat');

// `Array.prototype.concat` method
// https://tc39.es/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$({ target: 'Array', proto: true, arity: 1, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  concat: function concat(arg) {
    var O = toObject(this);
    var A = arraySpeciesCreate(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable(E)) {
        len = lengthOfArrayLike(E);
        doesNotExceedSafeInteger(n + len);
        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
      } else {
        doesNotExceedSafeInteger(n + 1);
        createProperty(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});


/***/ }),

/***/ 9826:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __nested_webpack_require_65113__) {

"use strict";

var $ = __nested_webpack_require_65113__(2109);
var $find = (__nested_webpack_require_65113__(2092).find);
var addToUnscopables = __nested_webpack_require_65113__(1223);

var FIND = 'find';
var SKIPS_HOLES = true;

// Shouldn't skip holes
// eslint-disable-next-line es/no-array-prototype-find -- testing
if (FIND in []) Array(1)[FIND](function () { SKIPS_HOLES = false; });

// `Array.prototype.find` method
// https://tc39.es/ecma262/#sec-array.prototype.find
$({ target: 'Array', proto: true, forced: SKIPS_HOLES }, {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND);


/***/ }),

/***/ 7658:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __nested_webpack_require_65967__) {

"use strict";

var $ = __nested_webpack_require_65967__(2109);
var toObject = __nested_webpack_require_65967__(7908);
var lengthOfArrayLike = __nested_webpack_require_65967__(6244);
var setArrayLength = __nested_webpack_require_65967__(3658);
var doesNotExceedSafeInteger = __nested_webpack_require_65967__(7207);
var fails = __nested_webpack_require_65967__(7293);

var INCORRECT_TO_LENGTH = fails(function () {
  return [].push.call({ length: 0x100000000 }, 1) !== 4294967297;
});

// V8 and Safari <= 15.4, FF < 23 throws InternalError
// https://bugs.chromium.org/p/v8/issues/detail?id=12681
var properErrorOnNonWritableLength = function () {
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', { writable: false }).push();
  } catch (error) {
    return error instanceof TypeError;
  }
};

var FORCED = INCORRECT_TO_LENGTH || !properErrorOnNonWritableLength();

// `Array.prototype.push` method
// https://tc39.es/ecma262/#sec-array.prototype.push
$({ target: 'Array', proto: true, arity: 1, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  push: function push(item) {
    var O = toObject(this);
    var len = lengthOfArrayLike(O);
    var argCount = arguments.length;
    doesNotExceedSafeInteger(len + argCount);
    for (var i = 0; i < argCount; i++) {
      O[len] = arguments[i];
      len++;
    }
    setArrayLength(O, len);
    return len;
  }
});


/***/ }),

/***/ 8309:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __nested_webpack_require_67475__) {

var DESCRIPTORS = __nested_webpack_require_67475__(9781);
var FUNCTION_NAME_EXISTS = (__nested_webpack_require_67475__(6530).EXISTS);
var uncurryThis = __nested_webpack_require_67475__(1702);
var defineBuiltInAccessor = __nested_webpack_require_67475__(7045);

var FunctionPrototype = Function.prototype;
var functionToString = uncurryThis(FunctionPrototype.toString);
var nameRE = /function\b(?:\s|\/\*[\S\s]*?\*\/|\/\/[^\n\r]*[\n\r]+)*([^\s(/]*)/;
var regExpExec = uncurryThis(nameRE.exec);
var NAME = 'name';

// Function instances `.name` property
// https://tc39.es/ecma262/#sec-function-instances-name
if (DESCRIPTORS && !FUNCTION_NAME_EXISTS) {
  defineBuiltInAccessor(FunctionPrototype, NAME, {
    configurable: true,
    get: function () {
      try {
        return regExpExec(nameRE, functionToString(this))[1];
      } catch (error) {
        return '';
      }
    }
  });
}


/***/ }),

/***/ 7941:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __nested_webpack_require_68428__) {

var $ = __nested_webpack_require_68428__(2109);
var toObject = __nested_webpack_require_68428__(7908);
var nativeKeys = __nested_webpack_require_68428__(1956);
var fails = __nested_webpack_require_68428__(7293);

var FAILS_ON_PRIMITIVES = fails(function () { nativeKeys(1); });

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  keys: function keys(it) {
    return nativeKeys(toObject(it));
  }
});


/***/ }),

/***/ 1539:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __nested_webpack_require_68979__) {

var TO_STRING_TAG_SUPPORT = __nested_webpack_require_68979__(1694);
var defineBuiltIn = __nested_webpack_require_68979__(8052);
var toString = __nested_webpack_require_68979__(288);

// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!TO_STRING_TAG_SUPPORT) {
  defineBuiltIn(Object.prototype, 'toString', toString, { unsafe: true });
}


/***/ }),

/***/ 4747:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __nested_webpack_require_69442__) {

var global = __nested_webpack_require_69442__(7854);
var DOMIterables = __nested_webpack_require_69442__(8324);
var DOMTokenListPrototype = __nested_webpack_require_69442__(8509);
var forEach = __nested_webpack_require_69442__(8533);
var createNonEnumerableProperty = __nested_webpack_require_69442__(8880);

var handlePrototype = function (CollectionPrototype) {
  // some Chrome versions have non-configurable methods on DOMTokenList
  if (CollectionPrototype && CollectionPrototype.forEach !== forEach) try {
    createNonEnumerableProperty(CollectionPrototype, 'forEach', forEach);
  } catch (error) {
    CollectionPrototype.forEach = forEach;
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  if (DOMIterables[COLLECTION_NAME]) {
    handlePrototype(global[COLLECTION_NAME] && global[COLLECTION_NAME].prototype);
  }
}

handlePrototype(DOMTokenListPrototype);


/***/ }),

/***/ 3744:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
// runtime helper for setting properties on components
// in a tree-shakable way
exports.Z = (sfc, props) => {
    const target = sfc.__vccOpts || sfc;
    for (const [key, val] of props) {
        target[key] = val;
    }
    return target;
};


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __nested_webpack_require_70918__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __nested_webpack_require_70918__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__nested_webpack_require_70918__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__nested_webpack_require_70918__.o(definition, key) && !__nested_webpack_require_70918__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	!function() {
/******/ 		__nested_webpack_require_70918__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__nested_webpack_require_70918__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__nested_webpack_require_70918__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	!function() {
/******/ 		__nested_webpack_require_70918__.p = "";
/******/ 	}();
/******/ 	
/************************************************************************/
var __nested_webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
!function() {
"use strict";
// ESM COMPAT FLAG
__nested_webpack_require_70918__.r(__nested_webpack_exports__);

// EXPORTS
__nested_webpack_require_70918__.d(__nested_webpack_exports__, {
  "ColoredIcon": function() { return /* reexport */ ColoredIcon; },
  "default": function() { return /* binding */ entry_lib; }
});

;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
/* eslint-disable no-var */
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (true) {
    var getCurrentScript = __nested_webpack_require_70918__(7679)
    currentScript = getCurrentScript()

    // for backward compatibility, because previously we directly included the polyfill
    if (!('currentScript' in document)) {
      Object.defineProperty(document, 'currentScript', { get: getCurrentScript })
    }
  }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __nested_webpack_require_70918__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __nested_webpack_require_70918__(2222);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __nested_webpack_require_70918__(8309);
;// CONCATENATED MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject = __webpack_require__(3797);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/ColoredIcon.vue?vue&type=template&id=e2d8f7e6&scoped=true&ts=true



var _withScopeId = function _withScopeId(n) {
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.pushScopeId)("data-v-e2d8f7e6"), n = n(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.popScopeId)(), n;
};
var _hoisted_1 = {
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 30 30",
  style: {
    "enable-background": "new 0 0 30 30",
    "width": "100%",
    "height": "100%"
  },
  "xml:space": "preserve"
};
var _hoisted_2 = ["id"];
var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementVNode)("stop", {
    class: "grSolid"
  }, null, -1);
});
var _hoisted_4 = [_hoisted_3];
var _hoisted_5 = ["innerHTML", "transform"];
var _hoisted_6 = ["innerHTML", "transform"];
function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementBlock)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.normalizeClass)(["coloredSolidIcons", "".concat(_ctx.color, " ").concat(_ctx.classes)])
  }, [((0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementBlock)("svg", _hoisted_1, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementVNode)("defs", null, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementVNode)("linearGradient", {
    id: 'id_' + _ctx.name + _ctx.idPostFix,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, _hoisted_4, 8, _hoisted_2)]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementVNode)("g", null, [_ctx.getOpaque ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementBlock)("circle", {
    key: 0,
    style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.normalizeStyle)("fill: url(#id_".concat(_ctx.name + _ctx.idPostFix, ");")),
    cx: "15",
    cy: "15",
    r: "15"
  }, null, 4)) : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementBlock)("circle", {
    key: 1,
    style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.normalizeStyle)("stroke: url(#id_".concat(_ctx.name + _ctx.idPostFix, "); fill: none;")),
    cx: "15",
    cy: "15",
    r: "14",
    "stroke-width": "2",
    "paint-order": "stroke"
  }, null, 4))]), _ctx.getOpaque ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementBlock)("g", {
    key: 0,
    innerHTML: _ctx.render,
    transform: _ctx.config[_ctx.name] ? _ctx.config[_ctx.name].transform : 'translate(7,7) scale(0.8)',
    style: {
      "fill": "#fff",
      "fill-rule": "evenodd",
      "clip-rule": "evenodd"
    }
  }, null, 8, _hoisted_5)) : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementBlock)("g", {
    key: 1,
    innerHTML: _ctx.render,
    transform: _ctx.config[_ctx.name] ? _ctx.config[_ctx.name].transform : 'translate(7,7) scale(0.8)',
    style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.normalizeStyle)(["fill: url(#id_".concat(_ctx.name + _ctx.idPostFix, ");"), {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd"
    }])
  }, null, 12, _hoisted_6))]))], 2);
}
;// CONCATENATED MODULE: ./src/ColoredIcon.vue?vue&type=template&id=e2d8f7e6&scoped=true&ts=true

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __nested_webpack_require_70918__(1539);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __nested_webpack_require_70918__(4747);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __nested_webpack_require_70918__(7941);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.push.js
var es_array_push = __nested_webpack_require_70918__(7658);
;// CONCATENATED MODULE: ./src/icon-config.json
var icon_config_namespaceObject = JSON.parse('{"alert":{"transform":"translate(7,5) scale(0.8)"},"abort":{"transform":"translate(7,6.5) scale(0.8)"},"arrowDown":{"transform":"translate(7,6.5) scale(0.8)"},"addFriend":{"transform":"translate(7,6) scale(0.8)"},"burger":{"transform":"translate(8,8) scale(0.7)"},"community":{"transform":"translate(7,5) scale(0.8)"},"controller":{"transform":"translate(7,6) scale(0.8)"},"expressPayment":{"transform":"translate(5.2,5.8) scale(0.93)"},"friend":{"transform":"translate(6,5) scale(0.9)"},"secure":{"transform":"translate(7.5,6.5) scale(0.75)"},"numbre1":{"transform":"translate(7,6.5) scale(0.8)"},"bookmarkAndroid":{"transform":"translate(7,6.5) scale(0.8)"},"coins":{"transform":"translate(7,6) scale(0.8)"},"phoneService":{"transform":"translate(7,6.5) scale(0.8)"},"specialAutumn":{"transform":"translate(7,6) scale(0.8)"},"mobile":{"transform":"translate(7,7) scale(0.8)"},"challenge":{"transform":"translate(7,6.5) scale(0.8)"},"externLink":{"transform":"translate(7.5,7.5) scale(0.75)"},"internLink":{"transform":"translate(7.5,7.5) scale(0.75)"},"cardsBoards":{"transform":"translate(7,7.5) scale(0.8)"},"faceNeutral":{"transform":"translate(7,6) scale(0.8)"},"subscription":{"transform":"translate(6,6.2) scale(0.85)"},"specialSummer":{"transform":"translate(7,6.5) scale(0.8)"},"specialWinter":{"transform":"translate(5,5) scale(1)"},"warning":{"transform":"translate(6,6) scale(0.9)"},"infoPositive":{"transform":"translate(6,6) scale(0.9)"},"winnings":{"transform":"translate(7,7.5) scale(0.8)"},"toTablet":{"transform":"translate(7.5,7.5) scale(0.75)"},"toDesktop":{"transform":"translate(7.5,7.5) scale(0.75)"},"table":{"transform":"translate(7.5,7.5) scale(0.75)"},"warning-triangle":{"transform":"translate(8,9.5) scale(0.7)"},"equalUser":{"transform":"translate(7,6.5) scale(0.8)"},"computer":{"transform":"translate(7,8) scale(0.8)"},"fxLo":{"transform":"translate(5.5,6.5) scale(0.85)"},"fxHi":{"transform":"translate(5.5,6.5) scale(0.85)"},"logout":{"transform":"translate(7,7) scale(0.8)"},"login":{"transform":"translate(6.5,7) scale(0.8)"}}');
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.find.js
var es_array_find = __nested_webpack_require_70918__(9826);
;// CONCATENATED MODULE: ./src/icons.json
var icons_namespaceObject = JSON.parse('[{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{},"childs":[{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st0","d":"M10,0.851c0.55,0,1,0.476,1,1.057l0,7.829c0,0.581-0.45,1.057-1,1.057l0,0c-0.55,0-1-0.476-1-1.057l0-7.829\\r\\n\\t\\t\\tC9,1.326,9.45,0.851,10,0.851L10,0.851z"}}]},{"name":"path","attrs":{"class":"st0","d":"M14.813,2.848l0.005-0.013l-0.463-0.268c-0.179-0.141-0.58-0.278-0.58-0.278\\r\\n\\t\\tc-0.404-0.037-0.819,0.101-1.088,0.442c-0.424,0.535-0.332,1.32,0.203,1.743l0.965,0.627c1.612,1.203,2.662,3.116,2.662,5.282\\r\\n\\t\\tc0,3.631-2.933,6.575-6.558,6.598C6.333,16.959,3.4,14.015,3.4,10.384c0-2.166,1.051-4.079,2.662-5.282l0.965-0.627\\r\\n\\t\\tc0.535-0.424,0.627-1.208,0.203-1.743C6.961,2.391,6.547,2.253,6.143,2.29c0,0-0.402,0.136-0.58,0.278L5.099,2.835l0.005,0.013\\r\\n\\t\\tC2.637,4.451,1,7.222,1,10.384c0,4.956,4.007,8.975,8.958,8.998c4.951-0.023,8.958-4.042,8.958-8.998\\r\\n\\t\\tC18.917,7.222,17.28,4.451,14.813,2.848z"}}]},{"name":"rect","attrs":{"class":"st1","width":"20","height":"20.007"}}],"title":"abort"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st0","d":"M7.909,2.982c0,0,0.586,2.458,3.515,4.563c3.455,2.482,6.284,1.796,6.284,1.796L16.952,0L7.909,2.982z"}},{"name":"path","attrs":{"class":"st0","d":"M10.643,8.58C8.16,6.745,7.691,4.855,7.691,4.855l-4.615,7.714c0,0,0.205,0.791,0.74,1.657l-1.381,1.532\\r\\n\\t\\tc-0.205,0.228-0.187,0.579,0.041,0.784c0.228,0.205,0.579,0.187,0.784-0.041l1.246-1.382c0.198,0.212,0.41,0.417,0.659,0.595\\r\\n\\t\\tc0.114,0.082,0.222,0.142,0.332,0.207l-2.725,3.022c-0.205,0.228-0.187,0.579,0.041,0.784c0.228,0.205,0.579,0.187,0.784-0.041\\r\\n\\t\\tl2.915-3.234l0.053,0.027c1.361,0.531,2.277,0.265,2.277,0.265l6.41-6.263C15.251,10.484,13.126,10.414,10.643,8.58z"}}]},{"name":"rect","attrs":{"class":"st1","width":"20","height":"20"}}],"title":"action"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{},"childs":[{"name":"g","attrs":{"id":"addFriend_2_"},"childs":[{"name":"path","attrs":{"class":"st0","d":"M18.746,13.095c-0.482-1.555-1.929-2.339-1.929-2.339l-2.678,0.429l-2.955-0.429c0,0-1.447,0.784-1.93,2.339\\r\\n\\t\\t\\tC8.771,14.65,9.125,18,9.125,18h4.861h0.321h4.568C18.875,18,19.229,14.65,18.746,13.095z"}},{"name":"path","attrs":{"class":"st0","d":"M13.788,2.693c1.963,0,3.554,1.591,3.554,3.554S15.75,9.8,13.788,9.8s-3.554-1.591-3.554-3.554\\r\\n\\t\\t\\tS11.825,2.693,13.788,2.693z"}}]},{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st0","d":"M7.1,8.119H4.881V5.9c0-0.49-0.397-0.888-0.887-0.888S3.106,5.41,3.106,5.9v2.219H0.887\\r\\n\\t\\t\\tC0.399,8.119,0,8.518,0,9.006c0,0.488,0.399,0.887,0.887,0.887h2.219v2.219c0,0.49,0.397,0.887,0.888,0.887\\r\\n\\t\\t\\ts0.887-0.397,0.887-0.887V9.894H7.1c0.488,0,0.888-0.399,0.888-0.887C7.988,8.518,7.588,8.119,7.1,8.119z"}}]}]},{"name":"rect","attrs":{"class":"st1","width":"20","height":"20"}}],"title":"addFriend"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{"id":"icf_x5F_alert"},"childs":[{"name":"rect","attrs":{"x":"0","y":"0","class":"st0","width":"20","height":"20"}},{"name":"path","attrs":{"class":"st1","d":"M19.19,16.236L11.547,2.93c-0.661-1.227-2.453-1.227-3.114,0L0.789,16.236\\r\\n\\t\\tc-0.566,1.227,0.189,2.737,1.604,2.737h15.193C19.096,18.972,19.945,17.462,19.19,16.236z M9.997,17.613\\r\\n\\t\\tc-0.877,0-1.644-0.767-1.644-1.644c0-0.877,0.767-1.644,1.644-1.644c0.877,0,1.644,0.767,1.644,1.644\\r\\n\\t\\tC11.641,16.846,10.874,17.613,9.997,17.613z M9.722,12.946c0,0-1.18-5.505-1.18-6.291S9.231,5.18,10.017,5.18\\r\\n\\t\\ts1.474,0.688,1.474,1.474c0,0.59-1.18,6.291-1.18,6.291H9.722z"}}]}],"title":"alert"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{},"childs":[{"name":"rect","attrs":{"x":"0","y":"0","class":"st0","width":"20","height":"20"}},{"name":"path","attrs":{"class":"st1","d":"M18.313,6.25c-0.653-0.653-1.722-0.653-2.375,0L10,12.188L4.062,6.25c-0.653-0.653-1.722-0.653-2.375,0\\r\\n\\t\\tc-0.653,0.653-0.653,1.722,0,2.375l7.126,7.126c0.653,0.653,1.722,0.653,2.375,0l7.126-7.126\\r\\n\\t\\tC18.966,7.972,18.966,6.903,18.313,6.25z"}}]}],"title":"arrowBottom"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"path","attrs":{"class":"st0","d":"M18.313,9.976c-0.653-0.653-1.722-0.653-2.375,0l-4.165,4.165V2.648c0-0.975-0.798-1.773-1.773-1.773\\r\\n\\tc-0.975,0-1.773,0.798-1.773,1.773v11.493L4.062,9.976c-0.653-0.653-1.722-0.653-2.375,0c-0.653,0.653-0.653,1.722,0,2.375\\r\\n\\tl7.126,7.126c0.653,0.653,1.722,0.653,2.375,0l7.126-7.126C18.966,11.698,18.966,10.629,18.313,9.976z"}},{"name":"rect","attrs":{"class":"st1","width":"20","height":"20"}}],"title":"arrowDown"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st0","d":"M7.812,10l5.938-5.938c0.653-0.653,0.653-1.722,0-2.375c-0.653-0.653-1.722-0.653-2.375,0L4.25,8.812\\r\\n\\t\\tc-0.653,0.653-0.653,1.722,0,2.375l7.126,7.126c0.653,0.653,1.722,0.653,2.375,0c0.653-0.653,0.653-1.722,0-2.375L7.812,10z"}}]},{"name":"g","attrs":{},"childs":[{"name":"rect","attrs":{"class":"st1","width":"20","height":"20"}}]}],"title":"arrowLeft"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st0","d":"M15.75,8.812L8.625,1.687c-0.653-0.653-1.722-0.653-2.375,0c-0.653,0.653-0.653,1.722,0,2.375L12.188,10\\r\\n\\t\\tL6.25,15.938c-0.653,0.653-0.653,1.722,0,2.375c0.653,0.653,1.722,0.653,2.375,0l7.126-7.126\\r\\n\\t\\tC16.403,10.534,16.403,9.466,15.75,8.812z"}}]},{"name":"rect","attrs":{"class":"st1","width":"20","height":"20"}}],"title":"arrowRight"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{},"childs":[{"name":"rect","attrs":{"x":"0","y":"0","class":"st0","width":"20","height":"20"}},{"name":"path","attrs":{"class":"st1","d":"M18.955,11.559l-7.676-7.676c-0.704-0.704-1.855-0.704-2.559,0l-7.676,7.676c-0.704,0.704-0.704,1.855,0,2.559\\r\\n\\t\\tc0.704,0.704,1.855,0.704,2.559,0L10,7.721l6.397,6.397c0.704,0.704,1.855,0.704,2.559,0\\r\\n\\t\\tC19.659,13.414,19.659,12.262,18.955,11.559z"}}]}],"title":"arrowTop"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st0","d":"M8.743,13.849l1.834-1.834c0.349-0.349,0.349-0.917,0-1.267c-0.168-0.169-0.393-0.261-0.633-0.261\\r\\n\\t\\tc-0.24,0-0.465,0.093-0.633,0.261l-1.835,1.834l-1.834-1.834c-0.168-0.169-0.393-0.261-0.633-0.261\\r\\n\\t\\tc-0.24,0-0.465,0.093-0.633,0.261c-0.349,0.349-0.349,0.917,0,1.267l1.834,1.834l-1.834,1.835c-0.349,0.349-0.349,0.917,0,1.267\\r\\n\\t\\tc0.168,0.169,0.393,0.261,0.633,0.261c0.24,0,0.465-0.093,0.633-0.261l1.834-1.834l1.835,1.834\\r\\n\\t\\tc0.168,0.169,0.393,0.261,0.633,0.261c0.24,0,0.465-0.093,0.633-0.261c0.349-0.349,0.349-0.917,0-1.267L8.743,13.849z"}},{"name":"rect","attrs":{"x":"0","class":"st1","width":"20","height":"20"}},{"name":"path","attrs":{"class":"st0","d":"M15.333,0H7.766C5.802,0,4.058,1.804,4.008,4.039C2.348,4.314,1,5.735,1,7.453v9.056\\r\\n\\t\\tc0,0.47,0.495,0.851,0.964,0.851S3,16.978,3,16.509V7.453c0-0.976,0.609-1.472,1.585-1.472h7.392C12.953,5.981,13,6.477,13,7.453\\r\\n\\t\\tv9.056c0,0.976-0.047,1.472-1.022,1.472H8.48c-0.47,0-0.851,0.679-0.851,1.149s0.382,0.851,0.851,0.851h3.498\\r\\n\\t\\tc1.748,0,2.812-1.302,2.987-2.985c0.01-0.007,0.015-0.015,0.036-0.015c1.96,0,4-1.77,4-3.73V3.554C19,1.591,17.296,0,15.333,0z\\r\\n\\t\\t M17,13.251c0,1.172-0.685,1.62-2,1.701V7.453c0-1.914-1.108-3.472-3.022-3.472H6.102C6.104,3.927,6.11,3.886,6.123,3.875\\r\\n\\t\\tC6.115,2.872,6.762,1.981,7.766,1.981h7.567c1,0,1.667,0.573,1.667,1.573V13.251z"}}]}],"title":"autosortOff"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st0","d":"M15.333,0.019H7.766c-1.964,0-3.708,1.804-3.758,4.039C2.348,4.333,1,5.754,1,7.472v9.056\\r\\n\\t\\tc0,0.47,0.495,0.851,0.964,0.851S3,16.997,3,16.528V7.472C3,6.496,3.609,6,4.585,6h7.392C12.953,6,13,6.496,13,7.472v9.056\\r\\n\\t\\tC13,17.504,12.953,18,11.978,18H8.48c-0.47,0-0.851,0.679-0.851,1.149S8.01,20,8.48,20h3.498c1.748,0,2.812-1.302,2.987-2.985\\r\\n\\t\\tC14.974,17.009,14.98,17,15,17c1.96,0,4-1.77,4-3.73V3.573C19,1.61,17.296,0.019,15.333,0.019z M17,13.27\\r\\n\\t\\tc0,1.172-0.685,1.62-2,1.701V7.472C15,5.558,13.892,4,11.978,4H6.102C6.104,3.946,6.11,3.905,6.123,3.894\\r\\n\\t\\tC6.115,2.891,6.762,2,7.766,2h7.567C16.333,2,17,2.573,17,3.573V13.27z"}},{"name":"g","attrs":{},"childs":[{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st0","d":"M11.501,10.845L11.501,10.845v4.811c0,0.773-0.958,1.203-1.473,0.601l-1.553-1.546\\r\\n\\t\\t\\t\\tc0,0-5.333,1.577-1.805,4.954c-1.78-0.466-2.855-1.393-2.925-2.321c-0.269-3.55,2.926-4.431,2.926-4.431l-1.38-1.38\\r\\n\\t\\t\\t\\tc-0.172-0.172-0.258-0.376-0.258-0.548c0-0.43,0.343-0.891,0.859-0.891h4.725C11.132,10.093,11.501,10.329,11.501,10.845z"}}]},{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st0","d":"M11.501,10.845L11.501,10.845v4.811c0,0.773-0.958,1.203-1.473,0.601l-1.553-1.546\\r\\n\\t\\t\\t\\tc0,0-5.333,1.577-1.805,4.954c-1.78-0.466-2.855-1.393-2.925-2.321c-0.269-3.55,2.926-4.431,2.926-4.431l-1.38-1.38\\r\\n\\t\\t\\t\\tc-0.172-0.172-0.258-0.376-0.258-0.548c0-0.43,0.343-0.891,0.859-0.891h4.725C11.132,10.093,11.501,10.329,11.501,10.845z"}}]}]},{"name":"rect","attrs":{"class":"st1","width":"20","height":"20"}}]}],"title":"autosortOn"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{},"childs":[{"name":"g","attrs":{},"childs":[{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st0","d":"M2.857,16.072C2.857,16.165,2.949,15.886,2.857,16.072L2.857,16.072z"}},{"name":"path","attrs":{"class":"st0","d":"M15,10v5H3V8h8.541l0.094-0.844L9.753,5.3C9.471,5.021,9.376,4.65,9.471,4.278C9.471,4.186,9.906,4.093,10,4\\r\\n\\t\\t\\t\\tH2.882C1.941,4,1,4.928,1,5.857v9.375c0,0.928,0.847,1.764,1.788,1.764h12.329c0.941,0,1.882-0.928,1.882-1.857V11L15,10L15,10z\\r\\n\\t\\t\\t\\t M2.506,5.857c0-0.557,0.471-1.021,1.035-1.021S4.482,5.3,4.482,5.857S4.012,6.878,3.447,6.878S2.506,6.413,2.506,5.857z"}},{"name":"polygon","attrs":{"class":"st0","points":"20,4.342 16.844,3.878 15.452,1 14.152,3.692 14.152,3.692 14.059,3.878 10.903,4.342 13.131,6.477 \\r\\n\\t\\t\\t\\t13.038,7.405 13.038,7.405 12.667,9.633 15.359,8.148 15.359,8.148 15.452,8.148 18.236,9.633 17.679,6.477 \\t\\t\\t"}}]}]},{"name":"rect","attrs":{"x":"0.018","y":"-0.022","class":"st1","width":"20","height":"20"}}]}],"title":"bookmarkAndroid"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{},"childs":[{"name":"rect","attrs":{"class":"st0","width":"20","height":"20"}},{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st1","d":"M20,10c0,1.1-0.9,2-2,2H2c-1.1,0-2-0.9-2-2l0,0c0-1.1,0.9-2,2-2h16C19.1,8,20,8.9,20,10L20,10z"}},{"name":"path","attrs":{"class":"st1","d":"M20,3c0,1.1-0.9,2-2,2H2C0.9,5,0,4.1,0,3l0,0c0-1.1,0.9-2,2-2h16C19.1,1,20,1.9,20,3L20,3z"}},{"name":"path","attrs":{"class":"st1","d":"M20,17c0,1.1-0.9,2-2,2H2c-1.1,0-2-0.9-2-2l0,0c0-1.1,0.9-2,2-2h16C19.1,15,20,15.9,20,17L20,17z"}}]}]}],"title":"burger"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{"id":"icf_x5F_cardBackChange_1_"},"childs":[{"name":"rect","attrs":{"class":"st0","width":"20","height":"20"}},{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st1","d":"M15.442,0H8.558C6.593,0,5,1.593,5,3.558V4H4.558C2.593,4,1,5.593,1,7.558v8.884C1,18.407,2.593,20,4.558,20\\r\\n\\t\\t\\th6.884C13.407,20,15,18.407,15,16.442V16h0.442C17.407,16,19,14.407,19,12.442V3.558C19,1.593,17.407,0,15.442,0z M13,16.442\\r\\n\\t\\t\\tC13,17.301,12.301,18,11.442,18H4.558C3.699,18,3,17.301,3,16.442V7.558C3,6.699,3.699,6,4.558,6h6.884\\r\\n\\t\\t\\tC12.301,6,13,6.699,13,7.558V16.442z M17,12.442C17,13.301,16.301,14,15.442,14H15V7.558C15,5.593,13.407,4,11.442,4H7V3.558\\r\\n\\t\\t\\tC7,2.699,7.699,2,8.558,2h6.884C16.301,2,17,2.699,17,3.558V12.442z"}},{"name":"path","attrs":{"class":"st1","d":"M11.003,7H4.997C4.447,7,4,7.447,4,7.997v8.005C4,16.553,4.447,17,4.997,17h6.005\\r\\n\\t\\t\\tC11.553,17,12,16.553,12,16.003V7.997C12,7.447,11.553,7,11.003,7z"}}]}]}],"title":"cardBackChange"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{"id":"icf_x5F_cardFrontChange_1_"},"childs":[{"name":"rect","attrs":{"class":"st0","width":"20","height":"20"}},{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st1","d":"M15.442,0H8.558C6.593,0,5,1.593,5,3.558V4H4.558C2.593,4,1,5.593,1,7.558v8.884C1,18.407,2.593,20,4.558,20\\r\\n\\t\\t\\th6.884C13.407,20,15,18.407,15,16.442V16h0.442C17.407,16,19,14.407,19,12.442V3.558C19,1.593,17.407,0,15.442,0z M13,16.442\\r\\n\\t\\t\\tC13,17.301,12.301,18,11.442,18H4.558C3.699,18,3,17.301,3,16.442V7.558C3,6.699,3.699,6,4.558,6h6.884\\r\\n\\t\\t\\tC12.301,6,13,6.699,13,7.558V16.442z M17,12.442C17,13.301,16.301,14,15.442,14H15V7.558C15,5.593,13.407,4,11.442,4H7V3.558\\r\\n\\t\\t\\tC7,2.699,7.699,2,8.558,2h6.884C16.301,2,17,2.699,17,3.558V12.442z"}},{"name":"path","attrs":{"class":"st1","d":"M8.433,9.308c-0.239-0.239-0.626-0.239-0.865,0l-2.26,2.26c-0.239,0.239-0.239,0.626,0,0.865l2.26,2.26\\r\\n\\t\\t\\tc0.239,0.239,0.626,0.239,0.865,0l2.26-2.26c0.239-0.239,0.239-0.626,0-0.865L8.433,9.308z"}}]}]}],"title":"cardFrontChange"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st0","d":"M7.941,4.625c0-0.533,0.386-0.966,0.922-0.966h3.125v-2.65C11.988,0.452,11.534,0,10.974,0H3.05\\r\\n\\t\\tC2.49,0,2.036,0.452,2.036,1.009v13.982C2.036,15.548,2.49,16,3.05,16h4.891V4.625z"}},{"name":"path","attrs":{"class":"st0","d":"M18,18.117C18,18.605,17.602,19,17.11,19h-6.992c-0.491,0-0.89-0.395-0.89-0.883V5.883\\r\\n\\t\\tC9.229,5.395,9.627,5,10.118,5h6.992C17.602,5,18,5.395,18,5.883V18.117z"}}]},{"name":"rect","attrs":{"x":"0","y":"0","class":"st1","width":"20","height":"20"}}],"title":"cardsBoards"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{"id":"challenge"},"childs":[{"name":"path","attrs":{"class":"st0","d":"M14.255,1.003c1.735,0,3.067,1.187,3.067,2.922c0,1.735-1.332,2.917-3.067,2.917\\r\\n\\t\\tc-1.735,0-3.067-1.182-3.067-2.917C11.187,2.19,12.519,1.003,14.255,1.003z"}},{"name":"path","attrs":{"class":"st0","d":"M5.712,1.003c1.735,0,3.067,1.187,3.067,2.922c0,1.735-1.332,2.917-3.067,2.917\\r\\n\\t\\tc-1.735,0-3.067-1.182-3.067-2.917C2.645,2.19,3.977,1.003,5.712,1.003z"}},{"name":"path","attrs":{"class":"st0","d":"M18.624,10.07c-0.466-1.609-1.865-1.811-1.865-1.811L4.468,8.291L3.405,8.259c0,0-1.507,0.201-2.01,1.811\\r\\n\\t\\tc-0.503,1.61-0.134,7.822-0.134,7.822h2.573h0.689h14.226C18.749,17.892,19.091,11.68,18.624,10.07z M7.494,16.872H5.166\\r\\n\\t\\tL2.713,9.88h2.169l1.487,4.995L7.837,9.88h2.128L7.494,16.872z M16.257,16.393c-0.622,0.425-1.474,0.637-2.555,0.637\\r\\n\\t\\tc-0.598,0-1.141-0.056-1.628-0.168c-0.487-0.112-0.878-0.235-1.173-0.371V14.72h0.198c0.108,0.076,0.232,0.159,0.374,0.248\\r\\n\\t\\tc0.142,0.09,0.342,0.187,0.602,0.29c0.223,0.092,0.477,0.171,0.76,0.236c0.283,0.066,0.586,0.099,0.91,0.099\\r\\n\\t\\tc0.423,0,0.736-0.047,0.94-0.141c0.203-0.094,0.305-0.232,0.305-0.416c0-0.163-0.06-0.282-0.18-0.356s-0.347-0.145-0.682-0.212\\r\\n\\t\\tc-0.16-0.036-0.376-0.075-0.649-0.117c-0.273-0.042-0.522-0.093-0.745-0.153c-0.61-0.16-1.063-0.408-1.359-0.745\\r\\n\\t\\tc-0.295-0.337-0.443-0.757-0.443-1.26c0-0.646,0.306-1.184,0.919-1.613c0.612-0.429,1.449-0.643,2.51-0.643\\r\\n\\t\\tc0.503,0,0.984,0.051,1.445,0.153c0.461,0.102,0.821,0.211,1.08,0.326v1.7H16.7c-0.319-0.22-0.683-0.398-1.092-0.536\\r\\n\\t\\tc-0.409-0.138-0.823-0.206-1.242-0.206c-0.347,0-0.639,0.048-0.877,0.144c-0.237,0.096-0.356,0.232-0.356,0.407\\r\\n\\t\\tc0,0.16,0.054,0.281,0.162,0.365c0.108,0.084,0.361,0.168,0.76,0.251c0.22,0.044,0.456,0.087,0.709,0.129\\r\\n\\t\\tc0.253,0.042,0.507,0.095,0.763,0.159c0.567,0.148,0.986,0.38,1.257,0.697c0.271,0.317,0.407,0.713,0.407,1.188\\r\\n\\t\\tC17.19,15.409,16.879,15.968,16.257,16.393z"}}]},{"name":"rect","attrs":{"class":"st1","width":"20","height":"20"}}],"title":"challenge"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st0","d":"M6.788,19.969c-0.285,0-0.582-0.011-0.893-0.034c-0.342-0.026-0.626-0.259-0.703-0.578\\r\\n\\t\\tc-0.078-0.319,0.07-0.649,0.364-0.815c0.769-0.435,1.232-1.088,1.478-1.573H3.103c-2.069,0-3.103-1-3.103-3.057V3.714\\r\\n\\t\\tc0-1.686,1.034-2.745,3.103-2.745h13.446c2.417,0,3.451,1,3.451,3v9.943c0,2.057-1.034,3.057-3.103,3.057h-3.451\\r\\n\\t\\tC12.774,18.061,10.54,19.969,6.788,19.969z M3,2.969c-0.942,0-1,0.142-1,1v10c0,0.858,0.058,1,1,1h5.275\\r\\n\\t\\tc0.226,0,0.276,0.277,0.425,0.439c0.149,0.163,0.218,0.379,0.188,0.593c-0.008,0.06-0.177,1.703-0.902,2.699\\r\\n\\t\\tc2.846-0.406,3.775-2.884,3.851-3.044c0.107-0.293,0.233-0.687,0.576-0.687H17c0.942,0,1-0.142,1-1v-10c0-0.858-0.058-1-1-1H3z"}},{"name":"g","attrs":{},"childs":[{"name":"circle","attrs":{"class":"st0","cx":"10.5","cy":"11.531","r":"1.472"}},{"name":"circle","attrs":{"class":"st0","cx":"15.5","cy":"11.531","r":"1.472"}},{"name":"circle","attrs":{"class":"st0","cx":"5.5","cy":"11.531","r":"1.472"}}]},{"name":"rect","attrs":{"class":"st1","width":"20","height":"20"}}]}],"title":"chat"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"path","attrs":{"class":"st0","d":"M14.147,8.393L8.389,8.395l1.059-1.08c0.247-0.155,0.395-0.404,0.395-0.671c0-0.179-0.065-0.349-0.188-0.492\\r\\n\\tC9.347,5.793,8.78,5.715,8.316,5.988l-2.73,2.43C5.34,8.635,5.182,8.833,5.165,9.093L5.164,9.139c0,0.246,0.082,0.45,0.283,0.658\\r\\n\\tl2.771,2.821c0.391,0.279,0.968,0.246,1.311-0.076c0.163-0.153,0.253-0.352,0.253-0.561c0-0.238-0.119-0.47-0.312-0.609\\r\\n\\tl-0.976-1.133l5.653-0.002c0.379,0,0.689-0.415,0.689-0.922C14.836,8.808,14.526,8.393,14.147,8.393z"}},{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st1","d":"M6.788,20c-0.285,0-0.582-0.011-0.893-0.034c-0.342-0.026-0.626-0.259-0.703-0.578\\r\\n\\t\\tc-0.078-0.319,0.07-0.649,0.364-0.815C6.326,18.138,6.788,17.485,7.034,17H3.103C1.034,17,0,16,0,13.943V3.745\\r\\n\\t\\tC0,2.059,1.034,1,3.103,1h13.446C18.966,1,20,2,20,4v9.943C20,16,18.966,17,16.897,17h-3.451C12.774,18.092,10.54,20,6.788,20z\\r\\n\\t\\t M3,3C2.058,3,2,3.142,2,4v10c0,0.858,0.058,1,1,1h5.275c0.226,0,0.276,0.277,0.425,0.439c0.149,0.163,0.218,0.379,0.188,0.593\\r\\n\\t\\tc-0.008,0.06-0.177,1.703-0.902,2.699c2.846-0.406,3.775-2.884,3.851-3.044C11.942,15.394,12.069,15,12.412,15H17\\r\\n\\t\\tc0.942,0,1-0.142,1-1V4c0-0.858-0.058-1-1-1H3z"}}]},{"name":"rect","attrs":{"class":"st2","width":"20","height":"20"}}],"title":"chatHistory"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{},"childs":[{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st0","d":"M6.788,20.061c-0.285,0-0.582-0.011-0.893-0.034c-0.342-0.026-0.626-0.259-0.703-0.578\\r\\n\\t\\t\\tc-0.078-0.319,0.07-0.649,0.364-0.815c0.769-0.435,1.232-1.088,1.478-1.573H3.103c-2.069,0-3.103-1-3.103-3.057V3.806\\r\\n\\t\\t\\tC0,2.12,1.034,1.061,3.103,1.061h13.446c2.417,0,3.451,1,3.451,3v9.943c0,2.057-1.034,3.057-3.103,3.057h-3.451\\r\\n\\t\\t\\tC12.774,18.153,10.54,20.061,6.788,20.061z M3,3.061c-0.942,0-1,0.142-1,1v10c0,0.858,0.058,1,1,1h5.275\\r\\n\\t\\t\\tc0.226,0,0.276,0.277,0.425,0.439c0.149,0.163,0.218,0.379,0.188,0.593c-0.008,0.06-0.177,1.703-0.902,2.699\\r\\n\\t\\t\\tc2.846-0.406,3.775-2.884,3.851-3.044c0.107-0.293,0.233-0.687,0.576-0.687H17c0.942,0,1-0.142,1-1v-10c0-0.858-0.058-1-1-1H3z"}}]},{"name":"g","attrs":{},"childs":[{"name":"rect","attrs":{"x":"5.25","y":"4.373","class":"st1","width":"9.5","height":"9.5"}},{"name":"path","attrs":{"class":"st2","d":"M11.285,9.123l2.249-2.249c0.353-0.353,0.353-0.932,0-1.285c-0.353-0.353-0.932-0.353-1.285,0L10,7.837\\r\\n\\t\\t\\tL7.751,5.588c-0.353-0.353-0.932-0.353-1.285,0c-0.353,0.353-0.353,0.932,0,1.285l2.249,2.249l-2.249,2.249\\r\\n\\t\\t\\tc-0.353,0.353-0.353,0.932,0,1.285c0.353,0.353,0.932,0.353,1.285,0L10,10.408l2.249,2.249c0.353,0.353,0.932,0.353,1.285,0\\r\\n\\t\\t\\tc0.353-0.353,0.353-0.932,0-1.285L11.285,9.123z"}}]},{"name":"rect","attrs":{"class":"st1","width":"20","height":"20"}}]}],"title":"chatOff"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{},"childs":[{"name":"rect","attrs":{"class":"st0","width":"20","height":"20"}},{"name":"path","attrs":{"class":"st1","d":"M12.706,10l4.736-4.736c0.744-0.744,0.744-1.962,0-2.706c-0.744-0.744-1.962-0.744-2.706,0L10,7.294\\r\\n\\t\\tL5.264,2.558c-0.744-0.744-1.962-0.744-2.706,0c-0.744,0.744-0.744,1.962,0,2.706L7.294,10l-4.736,4.736\\r\\n\\t\\tc-0.744,0.744-0.744,1.962,0,2.706c0.744,0.744,1.962,0.744,2.706,0L10,12.706l4.736,4.736c0.744,0.744,1.962,0.744,2.706,0\\r\\n\\t\\tc0.744-0.744,0.744-1.962,0-2.706L12.706,10z"}}]}],"title":"close"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{},"childs":[{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st0","d":"M12.536,7.053c0.697,0.889,1.204,1.931,1.468,3.067c1.571,0.001,3.175-0.186,4.523-0.723V6.229\\r\\n\\t\\t\\tC16.904,7.033,14.659,7.26,12.536,7.053z"}},{"name":"path","attrs":{"class":"st0","d":"M18.527,13.956v-3.023c-1.221,0.555-2.753,0.806-4.319,0.806c0.001,0.057,0.008,0.113,0.008,0.17\\r\\n\\t\\t\\tc0,0.975-0.184,1.906-0.508,2.768C15.371,14.701,17.094,14.526,18.527,13.956z"}},{"name":"path","attrs":{"class":"st0","d":"M18.527,4.707V3.026c-0.008,0.004-0.018,0.007-0.026,0.011c0-0.004,0.004-0.007,0.004-0.011\\r\\n\\t\\t\\tc0-0.763-2.53-1.381-5.651-1.381c-3.121,0-5.651,0.618-5.651,1.381c0,0.031,0.029,0.059,0.037,0.089\\r\\n\\t\\t\\tC7.228,3.11,7.214,3.106,7.203,3.101v0.973c1.246,0.137,2.403,0.565,3.405,1.213C12.996,5.596,16.192,5.715,18.527,4.707z"}},{"name":"path","attrs":{"class":"st0","d":"M12.81,16.392c-0.566,0.815-1.276,1.522-2.101,2.074c0.665,0.067,1.392,0.105,2.156,0.105\\r\\n\\t\\t\\tc3.067,0,5.55-0.598,5.635-1.343c0.004-0.001,0.027-0.009,0.027-0.009v-1.727C16.945,16.22,14.83,16.503,12.81,16.392z"}}]},{"name":"path","attrs":{"class":"st0","d":"M6.548,5.618C2.932,5.618,0,8.549,0,12.166s2.932,6.548,6.548,6.548s6.548-2.932,6.548-6.548\\r\\n\\t\\tS10.165,5.618,6.548,5.618z M8.711,15.972c-0.013,0.086-0.032,0.155-0.057,0.206c-0.024,0.051-0.052,0.088-0.083,0.109\\r\\n\\t\\tC8.54,16.31,8.505,16.32,8.465,16.32H4.584c-0.036,0-0.068-0.011-0.099-0.033c-0.031-0.022-0.059-0.058-0.083-0.109\\r\\n\\t\\tc-0.025-0.051-0.043-0.12-0.057-0.206c-0.013-0.087-0.02-0.192-0.02-0.316c0-0.129,0.006-0.236,0.016-0.322\\r\\n\\t\\tc0.011-0.087,0.029-0.156,0.054-0.209c0.024-0.054,0.052-0.092,0.083-0.116c0.031-0.024,0.066-0.037,0.106-0.037h1.087V9.377\\r\\n\\t\\tl-1.382,0.764C4.188,10.19,4.105,10.22,4.04,10.23c-0.064,0.011-0.115-0.002-0.152-0.04c-0.038-0.038-0.063-0.103-0.077-0.196\\r\\n\\t\\tc-0.013-0.093-0.02-0.224-0.02-0.392c0-0.106,0.002-0.194,0.006-0.263c0.005-0.068,0.015-0.127,0.033-0.176\\r\\n\\t\\tc0.018-0.048,0.042-0.089,0.073-0.119C3.935,9.013,3.977,8.981,4.03,8.945l1.847-1.196C5.9,7.731,5.928,7.717,5.961,7.705\\r\\n\\t\\tc0.033-0.011,0.076-0.02,0.13-0.026C6.144,7.672,6.213,7.668,6.3,7.666s0.198-0.003,0.336-0.003c0.168,0,0.304,0.003,0.408,0.01\\r\\n\\t\\tC7.148,7.679,7.227,7.69,7.28,7.705c0.053,0.016,0.089,0.037,0.107,0.063c0.018,0.027,0.026,0.06,0.026,0.1v7.103h1.052\\r\\n\\t\\tc0.04,0,0.076,0.012,0.109,0.037c0.033,0.024,0.062,0.063,0.087,0.116c0.024,0.053,0.042,0.123,0.053,0.209\\r\\n\\t\\tc0.011,0.087,0.017,0.194,0.017,0.322C8.731,15.78,8.724,15.885,8.711,15.972z"}}]},{"name":"rect","attrs":{"class":"st1","width":"20","height":"20"}}],"title":"coins"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{},"childs":[{"name":"rect","attrs":{"class":"st0","width":"20","height":"20"}},{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st1","d":"M10,4C4.477,4,0,10,0,10s4.477,6,10,6s10-6,10-6S15.523,4,10,4z M10,14.8c-4.418,0-8-4.8-8-4.8\\r\\n\\t\\t\\ts3.582-4.8,8-4.8s8,4.8,8,4.8S14.418,14.8,10,14.8z"}},{"name":"circle","attrs":{"class":"st1","cx":"10","cy":"10","r":"3"}}]}]}],"title":"colorblindOff"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{},"childs":[{"name":"rect","attrs":{"class":"st0","width":"20","height":"20"}},{"name":"path","attrs":{"class":"st1","d":"M10,4C4.477,4,0,10,0,10s4.477,6,10,6s10-6,10-6S15.523,4,10,4z M10,13.5c-1.933,0-3.5-1.567-3.5-3.5\\r\\n\\t\\tS8.067,6.5,10,6.5s3.5,1.567,3.5,3.5S11.933,13.5,10,13.5z"}}]}],"title":"colorblindOn"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{"id":"community"},"childs":[{"name":"path","attrs":{"class":"st0","d":"M4.843,12.249l-2.341-0.03c0,0-1.341,0.179-1.789,1.611c-0.447,1.432-0.119,3.69-0.119,3.69h4.249\\r\\n\\t\\tL4.843,12.249z"}},{"name":"path","attrs":{"class":"st0","d":"M13.857,12.202c-0.447-1.432-1.789-1.611-1.789-1.611L10,10.614l-2.068-0.023c0,0-1.341,0.179-1.789,1.611\\r\\n\\t\\tc-0.447,1.432-0.119,5.331-0.119,5.331h3.42h1.112h3.42C13.976,17.533,14.304,13.634,13.857,12.202z"}},{"name":"path","attrs":{"class":"st0","d":"M15.145,12.249l2.352-0.03c0,0,1.341,0.179,1.789,1.611c0.447,1.432,0.119,3.69,0.119,3.69h-4.26\\r\\n\\t\\tL15.145,12.249z"}},{"name":"path","attrs":{"class":"st0","d":"M9.985,4.134c1.544,0,2.729,1.056,2.729,2.6c0,1.544-1.185,2.596-2.729,2.596\\r\\n\\t\\tc-1.544,0-2.729-1.052-2.729-2.596C7.256,5.19,8.441,4.134,9.985,4.134z"}},{"name":"path","attrs":{"class":"st0","d":"M15.958,6.277c1.287,0,2.331,1.043,2.331,2.331c0,1.287-1.043,2.331-2.331,2.331s-2.331-1.043-2.331-2.331\\r\\n\\t\\tC13.627,7.32,14.671,6.277,15.958,6.277z"}},{"name":"path","attrs":{"class":"st0","d":"M4.042,6.277c-1.287,0-2.331,1.043-2.331,2.331c0,1.287,1.043,2.331,2.331,2.331s2.331-1.043,2.331-2.331\\r\\n\\t\\tC6.373,7.32,5.329,6.277,4.042,6.277z"}}]},{"name":"rect","attrs":{"x":"0","y":"0","class":"st1","width":"20","height":"20"}}],"title":"community"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{"id":"icf-computer"},"childs":[{"name":"rect","attrs":{"x":"0","class":"st0","width":"20","height":"20"}},{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st1","d":"M17,2h-7H3C2.091,2,1,3.043,1,4v9c0,1,1,2,2,2h5c0,0,0.115,0.878,0,1c-0.909,0.957-2,1-2,1v1h4h4v-1\\r\\n\\t\\t\\tc0,0-1.091-0.043-2-1c-0.115-0.122,0-1,0-1h5c1,0,2-1,2-2V4C19,3.043,17.909,2,17,2z M17,13h-7H3V4h7h7V13z"}}]}]}],"title":"computer"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{},"childs":[{"name":"rect","attrs":{"class":"st0","width":"20","height":"20"}},{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st1","d":"M6.166,7.3c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6C7.666,8,6.966,7.3,6.166,7.3\\r\\n\\t\\t\\tz"}},{"name":"path","attrs":{"class":"st1","d":"M13.966,3.2c-0.9,0-2.5,1.2-3.9,1.2s-3.2-1.2-4-1.2c-5.1,0-8,13.8-4.2,13.8c3.3,0,3.7-3.9,8.2-3.9\\r\\n\\t\\t\\tc3.6,0,5.7,3.9,8.2,3.9C22.066,17,19.166,3.2,13.966,3.2z M6.066,11.5c-1.5,0-2.6-1.2-2.6-2.6c0-1.5,1.2-2.6,2.6-2.6\\r\\n\\t\\t\\tc1.5,0,2.6,1.2,2.6,2.6C8.766,10.3,7.566,11.5,6.066,11.5z M12.5,9.313c-0.449,0-0.813-0.364-0.813-0.813\\r\\n\\t\\t\\tc0-0.449,0.364-0.813,0.813-0.813s0.812,0.364,0.812,0.813C13.312,8.949,12.949,9.313,12.5,9.313z M14.5,7.313\\r\\n\\t\\t\\tc-0.449,0-0.813-0.364-0.813-0.813c0-0.449,0.364-0.813,0.813-0.813s0.812,0.364,0.812,0.813\\r\\n\\t\\t\\tC15.312,6.949,14.949,7.313,14.5,7.313z M14.5,11.313c-0.449,0-0.813-0.364-0.813-0.813c0-0.449,0.364-0.813,0.813-0.813\\r\\n\\t\\t\\ts0.812,0.364,0.812,0.813C15.312,10.949,14.949,11.313,14.5,11.313z M16.5,9.313c-0.449,0-0.813-0.364-0.813-0.813\\r\\n\\t\\t\\tc0-0.449,0.364-0.813,0.813-0.813s0.812,0.364,0.812,0.813C17.312,8.949,16.949,9.313,16.5,9.313z"}}]}]}],"title":"controller"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{},"childs":[{"name":"rect","attrs":{"class":"st0","width":"20","height":"20"}},{"name":"path","attrs":{"class":"st1","d":"M10,1c-4.971,0-9,4.029-9,9c0,4.971,4.029,9,9,9s9-4.029,9-9C19,5.029,14.971,1,10,1z M15,11H5V9h10V11z"}}]}],"title":"denied"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{},"childs":[{"name":"polygon","attrs":{"class":"st0","points":"6,4 3,3 6,2 14,2 17,3 14,4 \\t"}},{"name":"polygon","attrs":{"class":"st0","points":"14.375,8 5.656,8 6.281,5 13.656,5 \\t"}},{"name":"polygon","attrs":{"class":"st0","points":"14,9 9.973,18 6,9 \\t"}},{"name":"polygon","attrs":{"class":"st0","points":"4.562,9 9,18 1,7 \\t"}},{"name":"polygon","attrs":{"class":"st0","points":"15.437,9 11,18 19,7 \\t"}},{"name":"polygon","attrs":{"class":"st0","points":"1,6 4.452,7.631 5,5 2,4 \\t"}},{"name":"polygon","attrs":{"class":"st0","points":"19,6 15.576,7.5 15,5 18,4 \\t"}},{"name":"rect","attrs":{"class":"st1","width":"20","height":"20"}}]}],"title":"diamond"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st0","d":"M2,6v9c0,1.65,1.35,3,3,3h9L2,6z M6,16c-1.105,0-2-0.895-2-2c0-1.105,0.895-2,2-2s2,0.895,2,2\\r\\n\\t\\tC8,15.105,7.105,16,6,16z"}},{"name":"path","attrs":{"class":"st1","d":"M19.192,19.192L19.192,19.192c-0.389,0.389-1.025,0.389-1.414,0L0.808,2.222c-0.389-0.389-0.389-1.025,0-1.414\\r\\n\\t\\tl0,0c0.389-0.389,1.025-0.389,1.414,0l16.971,16.971C19.581,18.167,19.581,18.803,19.192,19.192z"}},{"name":"path","attrs":{"class":"st0","d":"M18,14V5c0-1.65-1.35-3-3-3H6L18,14z M14,4c1.105,0,2,0.895,2,2c0,1.105-0.895,2-2,2s-2-0.895-2-2\\r\\n\\t\\tC12,4.895,12.895,4,14,4z"}},{"name":"rect","attrs":{"class":"st2","width":"20","height":"20"}}]}],"title":"diceOff"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st0","d":"M15,2H5C3.35,2,2,3.35,2,5v10c0,1.65,1.35,3,3,3h10c1.65,0,3-1.35,3-3V5C18,3.35,16.65,2,15,2z M6,16\\r\\n\\t\\tc-1.105,0-2-0.895-2-2c0-1.105,0.895-2,2-2s2,0.895,2,2C8,15.105,7.105,16,6,16z M10,12c-1.105,0-2-0.895-2-2c0-1.105,0.895-2,2-2\\r\\n\\t\\ts2,0.895,2,2C12,11.105,11.105,12,10,12z M14,8c-1.105,0-2-0.895-2-2c0-1.105,0.895-2,2-2s2,0.895,2,2C16,7.105,15.105,8,14,8z"}},{"name":"rect","attrs":{"class":"st1","width":"20","height":"20"}}]}],"title":"diceOn"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{"id":"icf_x5F_doubleArrow"},"childs":[{"name":"path","attrs":{"class":"st0","d":"M9.023,1.374L3.162,6.813c-0.537,0.499-0.537,1.314,0,1.813c0.279,0.259,0.649,0.38,1.016,0.37l0,0.003h11.664\\r\\n\\t\\tV8.998c0.36,0.004,0.721-0.119,0.994-0.372c0.537-0.499,0.537-1.314,0-1.813l-5.861-5.439C10.44,0.875,9.56,0.875,9.023,1.374z"}},{"name":"path","attrs":{"class":"st0","d":"M10.977,18.626l5.861-5.439c0.537-0.499,0.537-1.314,0-1.813c-0.279-0.259-0.649-0.38-1.016-0.37l0-0.003\\r\\n\\t\\tH4.157v0.002c-0.36-0.004-0.721,0.119-0.994,0.372c-0.537,0.499-0.537,1.314,0,1.813l5.861,5.439\\r\\n\\t\\tC9.56,19.125,10.44,19.125,10.977,18.626z"}},{"name":"rect","attrs":{"x":"0","y":"0","class":"st1","width":"20","height":"20"}}]}],"title":"doubleArrow"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{"id":"icf-equal"},"childs":[{"name":"rect","attrs":{"y":"0","class":"st0","width":"20","height":"20"}},{"name":"g","attrs":{"id":"addFriend_3_"},"childs":[{"name":"path","attrs":{"class":"st1","d":"M10.945,13.095c-0.486-1.555-1.942-2.339-1.942-2.339l-2.696,0.429l-2.975-0.429c0,0-1.457,0.784-1.942,2.339\\r\\n\\t\\t\\tC0.903,14.65,1.259,18,1.259,18h4.893h0.323h4.599C11.074,18,11.43,14.65,10.945,13.095z"}},{"name":"path","attrs":{"class":"st1","d":"M5.988,2.693c1.963,0,3.554,1.591,3.554,3.554S7.95,9.8,5.988,9.8S2.434,8.209,2.434,6.246\\r\\n\\t\\t\\tS4.025,2.693,5.988,2.693z"}}]},{"name":"path","attrs":{"class":"st1","d":"M19,10h-5c-0.552,0-1-0.448-1-1v0c0-0.552,0.448-1,1-1h5c0.552,0,1,0.448,1,1v0C20,9.552,19.552,10,19,10z"}},{"name":"path","attrs":{"class":"st1","d":"M19,14h-5c-0.552,0-1-0.448-1-1v0c0-0.552,0.448-1,1-1h5c0.552,0,1,0.448,1,1v0C20,13.552,19.552,14,19,14z"}}]}],"title":"equalUser"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"rect","attrs":{"class":"st0","width":"20","height":"20"}},{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st1","d":"M14.004,4c-3.312,0-5.996,2.682-5.996,5.994s2.685,5.996,5.996,5.996c3.312,0,5.996-2.685,5.996-5.996\\r\\n\\t\\tS17.315,4,14.004,4z M16.204,13.68c-0.012,0.079-0.03,0.142-0.052,0.189c-0.022,0.047-0.048,0.08-0.076,0.1\\r\\n\\t\\tC16.048,13.99,16.015,14,15.979,14h-3.553c-0.033,0-0.063-0.01-0.091-0.031c-0.028-0.02-0.054-0.053-0.076-0.1\\r\\n\\t\\tc-0.023-0.047-0.04-0.11-0.052-0.189c-0.012-0.079-0.018-0.175-0.018-0.289c0-0.118,0.005-0.216,0.015-0.295\\r\\n\\t\\tc0.01-0.079,0.026-0.143,0.049-0.191c0.022-0.049,0.048-0.084,0.076-0.107c0.028-0.022,0.061-0.034,0.097-0.034h0.996V7.641\\r\\n\\t\\tl-1.266,0.7c-0.093,0.045-0.169,0.072-0.228,0.082c-0.059,0.01-0.105-0.002-0.14-0.036c-0.035-0.034-0.058-0.094-0.07-0.18\\r\\n\\t\\tc-0.012-0.085-0.018-0.205-0.018-0.359c0-0.097,0.002-0.177,0.006-0.24c0.004-0.063,0.014-0.117,0.031-0.161\\r\\n\\t\\tc0.016-0.044,0.039-0.081,0.067-0.109c0.028-0.028,0.067-0.058,0.116-0.091L13.61,6.15c0.02-0.016,0.046-0.029,0.076-0.04\\r\\n\\t\\tc0.031-0.01,0.07-0.018,0.119-0.024c0.049-0.006,0.112-0.01,0.191-0.012s0.182-0.003,0.307-0.003c0.154,0,0.279,0.003,0.374,0.009\\r\\n\\t\\tc0.095,0.006,0.167,0.016,0.216,0.03c0.049,0.015,0.081,0.033,0.098,0.058c0.016,0.025,0.024,0.055,0.024,0.091v6.504h0.964\\r\\n\\t\\tc0.036,0,0.07,0.011,0.1,0.034c0.031,0.022,0.057,0.057,0.079,0.107c0.022,0.049,0.039,0.112,0.049,0.191\\r\\n\\t\\tc0.01,0.079,0.016,0.177,0.016,0.295C16.222,13.505,16.216,13.601,16.204,13.68z"}},{"name":"path","attrs":{"class":"st1","d":"M3,13c-0.55,0-1,0.45-1,1s0.45,1,1,1h4.76c-0.483-0.602-0.879-1.274-1.173-2H3z"}},{"name":"path","attrs":{"class":"st1","d":"M6,10c0-0.339,0.028-0.672,0.069-1H1c-0.55,0-1,0.45-1,1s0.45,1,1,1h5.069C6.028,10.672,6,10.339,6,10z"}},{"name":"path","attrs":{"class":"st1","d":"M2,6c0,0.55,0.45,1,1,1h3.587C6.881,6.274,7.278,5.602,7.76,5H3C2.45,5,2,5.45,2,6z"}}]}],"title":"expressPayment"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{},"childs":[{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st0","d":"M19,0L19,0l-5.6,0c-0.9,0-1.4,1.1-0.7,1.7L14,3l-4,3.9l3.1,3.1l4-3.9l1.1,1.1c0.2,0.2,0.5,0.3,0.7,0.3\\r\\n\\t\\t\\tc0.5,0,1-0.4,1-1L20,1C20,0.4,19.6,0,19,0z"}}]},{"name":"path","attrs":{"class":"st0","d":"M17,11.188V16c0,0.7-0.4,1-1,1H4c-0.6,0.1-1-0.4-1-1V4c0-0.6,0.4-1,1-1h4.773l2-2H4C2.3,1,1,2.3,1,4v12\\r\\n\\t\\tc0,1.8,1.3,3,3,3h12c1.8,0,3-1.3,3-3c0,0,0-5.427,0-6.813L17,11.188z"}}]},{"name":"rect","attrs":{"class":"st1","width":"20","height":"20"}}],"title":"externLink"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{"id":"icfFaceFrowling_1_"},"childs":[{"name":"rect","attrs":{"class":"st0","width":"20","height":"20"}},{"name":"g","attrs":{"id":"icf_x5F_faceSmiling_2_"},"childs":[{"name":"circle","attrs":{"class":"st1","cx":"15.714","cy":"4.476","r":"2.857"}},{"name":"circle","attrs":{"class":"st1","cx":"4.286","cy":"4.476","r":"2.857"}},{"name":"path","attrs":{"class":"st2","d":"M10.034,12.238c5.742,0,8.631,4.233,8.751,4.413c0.392,0.588,0.233,1.385-0.355,1.777\\r\\n\\t\\t\\tc-0.587,0.392-1.38,0.234-1.773-0.35c-0.097-0.142-2.291-3.278-6.623-3.278c-4.338,0-6.532,3.145-6.623,3.278\\r\\n\\t\\t\\tc-0.397,0.583-1.19,0.737-1.777,0.343c-0.584-0.395-0.743-1.184-0.351-1.77C1.403,16.471,4.292,12.238,10.034,12.238z"}}]}]}],"title":"faceFrowling"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{"id":"icf_x5F_faceNeutral"},"childs":[{"name":"rect","attrs":{"y":"0","class":"st0","width":"20","height":"20"}},{"name":"g","attrs":{"id":"icf_x5F_faceSmiling_3_"},"childs":[{"name":"circle","attrs":{"class":"st1","cx":"15.7","cy":"4.5","r":"2.9"}},{"name":"circle","attrs":{"class":"st1","cx":"4.3","cy":"4.5","r":"2.9"}},{"name":"path","attrs":{"class":"st2","d":"M17.5,18h-15C1.7,18,1,17.3,1,16.5l0,0C1,15.7,1.7,15,2.5,15h15c0.8,0,1.5,0.7,1.5,1.5l0,0\\r\\n\\t\\t\\tC19,17.3,18.3,18,17.5,18z"}}]}]}],"title":"faceNeutral"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{"id":"icf_x5F_faceSmiling"},"childs":[{"name":"rect","attrs":{"class":"st0","width":"20","height":"20"}},{"name":"g","attrs":{"id":"icf_x5F_faceSmiling_1_"},"childs":[{"name":"circle","attrs":{"class":"st1","cx":"15.714","cy":"4.476","r":"2.857"}},{"name":"circle","attrs":{"class":"st1","cx":"4.286","cy":"4.476","r":"2.857"}},{"name":"path","attrs":{"class":"st2","d":"M10.034,18.643c-5.742,0-8.631-4.233-8.751-4.413c-0.392-0.588-0.233-1.385,0.355-1.777\\r\\n\\t\\t\\tc0.587-0.392,1.38-0.234,1.773,0.35c0.097,0.142,2.291,3.278,6.623,3.278c4.338,0,6.532-3.145,6.623-3.278\\r\\n\\t\\t\\tc0.397-0.583,1.19-0.737,1.777-0.343c0.584,0.395,0.743,1.184,0.351,1.77C18.664,14.41,15.776,18.643,10.034,18.643z"}}]}]}],"title":"faceSmiling"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"path","attrs":{"class":"st0","d":"M15.533,8.921L8.734,2.445c-0.623-0.594-1.643-0.594-2.266,0C6.144,2.753,5.992,3.162,6.004,3.568L6,3.568\\r\\n\\tv12.888h0.002c-0.005,0.398,0.149,0.797,0.465,1.099c0.623,0.594,1.643,0.594,2.266,0l6.799-6.476\\r\\n\\tC16.156,10.486,16.156,9.514,15.533,8.921z"}},{"name":"rect","attrs":{"x":"0","y":"0","class":"st1","width":"20","height":"20"}}],"title":"fatArrow"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"path","attrs":{"class":"st0","d":"M13.948,2.508c-2.512,0.193-3.997,3.103-3.997,3.103S8.462,2.456,5.649,2.508\\r\\n\\tc-4.633,0.086-5.573,5.224-3.831,7.14c0.843,0.927,3.631,3.495,5.801,5.468l2.309,2.21c0.261,0.261,0.609,0.261,0.869,0l1.406-1.438\\r\\n\\tc1.565-1.524,3.857-3.851,5.75-6.153C20.573,6.549,17.909,2.203,13.948,2.508z"}},{"name":"rect","attrs":{"x":"0","y":"0","class":"st1","width":"20","height":"20"}}],"title":"favorite"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st0","d":"M13.612,13.693h-2.283V10.97c2.421-0.596,4.219-2.776,4.219-5.381c0-3.064-2.484-5.548-5.548-5.548\\r\\n\\t\\tS4.452,2.524,4.452,5.589c0,2.617,1.814,4.805,4.251,5.39v2.715H6.42c-0.722,0-1.313,0.591-1.313,1.313s0.591,1.313,1.313,1.313\\r\\n\\t\\th2.283v2.283c0,0.725,0.588,1.313,1.313,1.313s1.313-0.588,1.313-1.313v-2.283h2.283c0.722,0,1.313-0.591,1.313-1.313\\r\\n\\t\\tS14.334,13.693,13.612,13.693z M10.016,8.509c-1.622,0-2.938-1.315-2.938-2.938c0-1.622,1.315-2.938,2.938-2.938\\r\\n\\t\\ts2.938,1.315,2.938,2.938C12.953,7.194,11.638,8.509,10.016,8.509z"}}]},{"name":"rect","attrs":{"class":"st1","width":"20","height":"20"}}],"title":"female"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st0","d":"M18.5,12.091c0,3.728-3.104,7.204-6.078,7.909c1.293-0.638,1.994-1.935,2.161-3.303\\r\\n\\t\\tc0.221-1.806-0.392-3.791-2.536-4.654c0.511,1.619-0.613,3.065-0.613,3.065c-0.332-2.946-1.944-4.321-4.069-4.962\\r\\n\\t\\tc0.048,0.098,0.96,1.028-0.679,3.01c-0.675,0.822-1.122,1.774-1.122,2.965c0,1.458,0.377,2.723,2.021,3.879\\r\\n\\t\\tC4.228,18.993,1.5,15.72,1.5,11.989c0-2.98,1.017-4.598,3.066-6.816C7.028,2.508,5.84,0.365,5.313,0\\r\\n\\t\\tc4.429,1.192,7.48,4.38,7.617,8.374c0.849-0.82,1.164-3.164,0.377-4.515C14.875,4.406,18.5,6.728,18.5,12.091"}},{"name":"rect","attrs":{"class":"st1","width":"20","height":"20"}}]}],"title":"flame"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{},"childs":[{"name":"rect","attrs":{"class":"st0","width":"20","height":"20"}},{"name":"path","attrs":{"class":"st1","d":"M6.741,8.688c-0.323,0.323-0.905,0.388-1.293,0L0.93,5.126c-0.388-0.388-0.388-0.905,0-1.293l4.518-3.551\\r\\n\\t\\tC6.03-0.3,7.065,0.088,7,0.929V3h5.046c4.4,0,8,3.6,8,8s-3.6,8-8,8h-7.5c-0.825,0-1.5-0.675-1.5-1.5s0.675-1.5,1.5-1.5h7.5\\r\\n\\t\\tc2.757,0,5-2.243,5-5s-2.243-5-5-5H7v2.041C7,8.3,6.871,8.559,6.741,8.688z"}}]}],"title":"flipBoardLeft"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{},"childs":[{"name":"rect","attrs":{"class":"st0","width":"20","height":"20"}},{"name":"path","attrs":{"class":"st1","d":"M13.305,8.688c0.323,0.323,0.905,0.388,1.293,0l4.518-3.562c0.388-0.388,0.388-0.905,0-1.293l-4.518-3.551\\r\\n\\t\\tc-0.582-0.582-1.617-0.194-1.552,0.647V3H8c-4.4,0-8,3.6-8,8s3.6,8,8,8h7.5c0.825,0,1.5-0.675,1.5-1.5S16.325,16,15.5,16H8\\r\\n\\t\\tc-2.757,0-5-2.243-5-5s2.243-5,5-5h5.046v2.041C13.046,8.3,13.175,8.559,13.305,8.688z"}}]}],"title":"flipBoardRight"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{"id":"addFriend_1_"},"childs":[{"name":"path","attrs":{"class":"st0","d":"M14.754,12.935c-0.486-1.555-1.942-2.339-1.942-2.339l-2.696,0.429l-2.975-0.429c0,0-1.457,0.784-1.942,2.339\\r\\n\\t\\tc-0.486,1.555-0.13,4.905-0.13,4.905h4.893h0.323h4.599C14.884,17.84,15.24,14.49,14.754,12.935z"}},{"name":"path","attrs":{"class":"st0","d":"M9.797,2.533c1.963,0,3.554,1.591,3.554,3.554S11.76,9.64,9.797,9.64S6.243,8.049,6.243,6.086\\r\\n\\t\\tS7.834,2.533,9.797,2.533z"}}]},{"name":"rect","attrs":{"class":"st1","width":"20","height":"20"}}],"title":"friend"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{},"childs":[{"name":"rect","attrs":{"class":"st0","width":"20","height":"20"}},{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st1","d":"M11.658,9L11.658,9l4.105-0.484c0.592,0,0.921-0.712,0.461-1.1l-0.855-0.841L18,4.05L15.916,2l-2.587,2.568\\r\\n\\t\\t\\tl-0.724-0.712c-0.132-0.129-0.329-0.194-0.461-0.194c-0.329,0-0.658,0.259-0.658,0.647L11,8.353C11,8.741,11.263,9,11.658,9z"}}]},{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st1","d":"M11.658,11L11.658,11l4.105,0.484c0.592,0,0.921,0.712,0.461,1.1l-0.855,0.841L18,15.95L15.916,18\\r\\n\\t\\t\\tl-2.587-2.568l-0.724,0.712c-0.132,0.129-0.329,0.194-0.461,0.194c-0.329,0-0.658-0.259-0.658-0.647L11,11.647\\r\\n\\t\\t\\tC11,11.259,11.263,11,11.658,11z"}}]},{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st1","d":"M8.342,9L8.342,9L4.237,8.516c-0.592,0-0.921-0.712-0.461-1.1l0.855-0.841L2,4.05L4.084,2l2.587,2.568\\r\\n\\t\\t\\tl0.724-0.712c0.132-0.129,0.329-0.194,0.461-0.194c0.329,0,0.658,0.259,0.658,0.647L9,8.353C9,8.741,8.737,9,8.342,9z"}}]},{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st1","d":"M8.342,11L8.342,11l-4.105,0.484c-0.592,0-0.921,0.712-0.461,1.1l0.855,0.841L2,15.95L4.084,18l2.587-2.568\\r\\n\\t\\t\\tl0.724,0.712c0.132,0.129,0.329,0.194,0.461,0.194c0.329,0,0.658-0.259,0.658-0.647L9,11.647C9,11.259,8.737,11,8.342,11z"}}]}]}],"title":"fullscreenOff"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{},"childs":[{"name":"rect","attrs":{"class":"st0","width":"20","height":"20"}},{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st1","d":"M17.342,1.993L17.342,1.993l-4.105,0.484c-0.592,0-0.921,0.712-0.461,1.1l0.855,0.841L11,6.943l2.084,2.05\\r\\n\\t\\t\\tl2.587-2.568l0.724,0.712c0.132,0.129,0.329,0.194,0.461,0.194c0.329,0,0.658-0.259,0.658-0.647L18,2.64\\r\\n\\t\\t\\tC18,2.252,17.737,1.993,17.342,1.993z"}}]},{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st1","d":"M17.342,17.993L17.342,17.993l-4.105-0.484c-0.592,0-0.921-0.712-0.461-1.1l0.855-0.841L11,13.043l2.084-2.05\\r\\n\\t\\t\\tl2.587,2.568l0.724-0.712c0.132-0.129,0.329-0.194,0.461-0.194c0.329,0,0.658,0.259,0.658,0.647L18,17.346\\r\\n\\t\\t\\tC18,17.734,17.737,17.993,17.342,17.993z"}}]},{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st1","d":"M2.658,1.993L2.658,1.993l4.105,0.484c0.592,0,0.921,0.712,0.461,1.1L6.368,4.419L9,6.943l-2.084,2.05\\r\\n\\t\\t\\tL4.329,6.425L3.605,7.137C3.474,7.267,3.276,7.331,3.145,7.331c-0.329,0-0.658-0.259-0.658-0.647L2,2.64\\r\\n\\t\\t\\tC2,2.252,2.263,1.993,2.658,1.993z"}}]},{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st1","d":"M2.658,17.993L2.658,17.993l4.105-0.484c0.592,0,0.921-0.712,0.461-1.1l-0.855-0.841L9,13.043l-2.084-2.05\\r\\n\\t\\t\\tl-2.587,2.568l-0.724-0.712c-0.132-0.129-0.329-0.194-0.461-0.194c-0.329,0-0.658,0.259-0.658,0.647L2,17.346\\r\\n\\t\\t\\tC2,17.734,2.263,17.993,2.658,17.993z"}}]}]}],"title":"fullscreenOn"},{"name":"svg","attrs":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"},"childs":[{"name":"defs","attrs":{}},{"name":"g","attrs":{"id":"Layer_2","data-name":"Layer 2"},"childs":[{"name":"g","attrs":{"id":"_-GENERIC","data-name":"-GENERIC"},"childs":[{"name":"g","attrs":{"id":"icf-fxHi"},"childs":[{"name":"rect","attrs":{"class":"cls-1","width":"20","height":"20"}},{"name":"path","attrs":{"class":"cls-2","d":"M13,8.72A1.7,1.7,0,0,1,14.65,7H16A1,1,0,1,0,16,5H14.65A1.7,1.7,0,0,1,13,3.27V1.89a1,1,0,1,0-1.93,0V3.27A1.76,1.76,0,0,1,9.28,5H7.93A1,1,0,1,0,7.93,7H9.28A1.76,1.76,0,0,1,11,8.72v1.39a1,1,0,0,0,1.93,0Z"}},{"name":"path","attrs":{"class":"cls-2","d":"M6.08,16.18a1.11,1.11,0,0,1,1.11-1.11H8a.58.58,0,1,0,0-1.15H7.19a1.11,1.11,0,0,1-1.11-1.11V12a.58.58,0,1,0-1.16,0v.77a1.11,1.11,0,0,1-1.1,1.11H3.06a.58.58,0,1,0,0,1.15h.76a1.11,1.11,0,0,1,1.1,1.11V17a.58.58,0,0,0,1.16,0Z"}},{"name":"path","attrs":{"class":"cls-2","d":"M3,8.87a.9.9,0,0,1,.9-.9h.62a.47.47,0,0,0,0-.94H3.87a.91.91,0,0,1-.9-.9V5.5A.47.47,0,1,0,2,5.5v.63a.9.9,0,0,1-.9.9H.52A.47.47,0,1,0,.52,8h.61a.9.9,0,0,1,.9.9V9.5A.47.47,0,0,0,3,9.5Z"}},{"name":"path","attrs":{"class":"cls-3","d":"M11.05,18.52v-5a.41.41,0,0,1,.41-.42h.84a.41.41,0,0,1,.41.42v1.66H14.3V13.5a.41.41,0,0,1,.41-.42h.8a.41.41,0,0,1,.41.42v5a.41.41,0,0,1-.41.42h-.8a.41.41,0,0,1-.41-.42V16.88H12.71v1.64a.41.41,0,0,1-.41.42h-.84A.41.41,0,0,1,11.05,18.52Z"}},{"name":"path","attrs":{"class":"cls-3","d":"M18.94,13.43v5.19a.33.33,0,0,1-.32.32H17.38a.33.33,0,0,1-.32-.32V13.43a.33.33,0,0,1,.32-.33h1.24A.33.33,0,0,1,18.94,13.43Z"}}]}]}]}],"title":"fxHi"},{"name":"svg","attrs":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"},"childs":[{"name":"defs","attrs":{}},{"name":"g","attrs":{"id":"Layer_2","data-name":"Layer 2"},"childs":[{"name":"g","attrs":{"id":"_-GENERIC","data-name":"-GENERIC"},"childs":[{"name":"g","attrs":{"id":"icf-fxLo"},"childs":[{"name":"rect","attrs":{"class":"cls-1","width":"20","height":"20"}},{"name":"path","attrs":{"class":"cls-2","d":"M10.9,8.47a1.62,1.62,0,0,1,1.62-1.62h1.26a.9.9,0,0,0,0-1.79H12.52A1.62,1.62,0,0,1,10.9,3.44V2.16a.9.9,0,0,0-1.79,0V3.44A1.63,1.63,0,0,1,7.48,5.06H6.24a.9.9,0,1,0,0,1.79H7.48A1.63,1.63,0,0,1,9.11,8.47V9.75a.9.9,0,0,0,1.79,0Z"}},{"name":"path","attrs":{"class":"cls-2","d":"M4,12.87a.9.9,0,0,1,.9-.9h.62a.47.47,0,0,0,0-.94H4.87a.91.91,0,0,1-.9-.9V9.5A.47.47,0,1,0,3,9.5v.63a.9.9,0,0,1-.9.9H1.52a.47.47,0,0,0,0,.94h.61a.9.9,0,0,1,.9.9v.63a.47.47,0,1,0,.94,0Z"}},{"name":"path","attrs":{"class":"cls-3","d":"M10.92,13.56v3.52h1.5a.46.46,0,0,1,.46.45v1a.47.47,0,0,1-.46.46H9.59a.51.51,0,0,1-.51-.51V13.56a.46.46,0,0,1,.45-.46h.94A.46.46,0,0,1,10.92,13.56Z"}},{"name":"path","attrs":{"class":"cls-3","d":"M16,19a2.81,2.81,0,0,1-2.92-3,2.82,2.82,0,0,1,3-3,2.81,2.81,0,0,1,2.92,3A2.82,2.82,0,0,1,16,19ZM17,16.89h0a1.35,1.35,0,0,0,0-1.74h0a1.35,1.35,0,0,0-2.07,0h0a1.36,1.36,0,0,0,0,1.76h0A1.36,1.36,0,0,0,17,16.89Z"}}]}]}]}],"title":"fxLo"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st0","d":"M10,1.061c-4.971,0-9,4.029-9,9c0,4.971,4.029,9,9,9s9-4.029,9-9C19,5.091,14.971,1.061,10,1.061z\\r\\n\\t\\t M11.513,15.961c0,0.824-0.674,1.498-1.498,1.498c-0.824,0-1.498-0.674-1.498-1.498V9.963c0-0.824,0.674-1.498,1.498-1.498\\r\\n\\t\\tc0.824,0,1.498,0.674,1.498,1.498V15.961z M10,7.061c-1.105,0-2-0.895-2-2c0-1.105,0.895-2,2-2c1.105,0,2,0.895,2,2\\r\\n\\t\\tC12,6.166,11.105,7.061,10,7.061z"}},{"name":"rect","attrs":{"class":"st1","width":"20","height":"20"}}]}],"title":"info"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st0","d":"M12,17.001C12,18.101,11.1,19,10,19c-1.1,0-2-0.899-2-1.999V8.999C8,7.899,8.9,7,10,7c1.1,0,2,0.899,2,1.999\\r\\n\\t\\tV17.001z"}},{"name":"circle","attrs":{"class":"st0","cx":"10","cy":"3","r":"2"}}]},{"name":"rect","attrs":{"class":"st1","width":"20","height":"20"}}],"title":"infoPositive"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"path","attrs":{"class":"st0","d":"M17,11.188V16c0,0.7-0.4,1-1,1H4c-0.6,0.1-1-0.4-1-1V4c0-0.6,0.4-1,1-1h4.773l2-2H4C2.3,1,1,2.3,1,4v12\\r\\n\\tc0,1.8,1.3,3,3,3h12c1.8,0,3-1.3,3-3c0,0,0-5.427,0-6.813L17,11.188z"}},{"name":"rect","attrs":{"class":"st1","width":"20","height":"20"}},{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st0","d":"M11,10L11,10h5.6c0.9,0,1.4-1.1,0.7-1.7L16,7l4-3.9L16.9,0l-4,3.9l-1.1-1.1c-0.2-0.2-0.5-0.3-0.7-0.3\\r\\n\\t\\tc-0.5,0-1,0.4-1,1L10,9C10,9.6,10.4,10,11,10z"}}]}],"title":"internLink"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st0","d":"M15.702,11.567c0,0,1.433-1.433,1.556-1.556c0.746-0.746-0.081-1.572-1.534-1.534c0,0-5.616,0.324-5.643,0.296\\r\\n\\t\\tc0.028,0.028-0.365,5.712-0.365,5.712c-0.046,1.213,0.871,2.197,1.534,1.534c0.109-0.109,1.624-1.624,1.624-1.624\\r\\n\\t\\ts6.049,0.98,2.221,5.605c2.681-0.375,3.812-1.738,3.828-3.213C18.923,13.406,15.702,11.567,15.702,11.567z"}},{"name":"rect","attrs":{"class":"st1","width":"20","height":"20"}},{"name":"g","attrs":{},"childs":[{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st2","d":"M9,10L9,10v5.6c0,0.9,1.1,1.4,1.7,0.7l1.8-1.8c0,0,6.437,1.75,0.562,5.5c3.25-0.271,4.943-1.917,4.938-3\\r\\n\\t\\t\\t\\tc-0.021-4.104-3.406-4.594-3.406-4.594L16.2,10.8c0.2-0.2,0.3-0.5,0.3-0.7c0-0.5-0.4-1.1-1-1.1H10C9.4,9,9,9.4,9,10z"}}]},{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st2","d":"M9,10L9,10v5.6c0,0.9,1.1,1.4,1.7,0.7l1.8-1.8c0,0,6.437,1.75,0.562,5.5c3.25-0.271,4.943-1.917,4.938-3\\r\\n\\t\\t\\t\\tc-0.021-4.104-3.406-4.594-3.406-4.594L16.2,10.8c0.2-0.2,0.3-0.5,0.3-0.7c0-0.5-0.4-1.1-1-1.1H10C9.4,9,9,9.4,9,10z"}}]}]},{"name":"path","attrs":{"class":"st2","d":"M15.25,1H2.75C1.784,1,1,1.784,1,2.75v12.5C1,16.216,1.784,17,2.75,17H7c0.406,0,1-0.594,1-1v-1H4.75\\r\\n\\t\\tC3.784,15,3,14.216,3,13.25v-8.5C3,3.784,3.784,3,4.75,3h8.5C14.216,3,15,3.784,15,4.75V8h1c0.55,0,1-0.45,1-1V2.75\\r\\n\\t\\tC17,1.784,16.216,1,15.25,1z"}},{"name":"circle","attrs":{"class":"st2","cx":"6.5","cy":"6.5","r":"1.5"}},{"name":"circle","attrs":{"class":"st2","cx":"11.5","cy":"6.5","r":"1.5"}}]}],"title":"jumpToDuell"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st0","d":"M12.333,6.001H7.667C5.704,6.001,4,7.592,4,9.555v6.892c0,1.963,1.704,3.554,3.667,3.554h4.666\\r\\n\\t\\tc1.963,0,3.667-1.591,3.667-3.554V9.555C16,7.592,14.296,6.001,12.333,6.001z M14,16.447c0,1-0.667,1.573-1.667,1.573H7.667\\r\\n\\t\\tc-1,0-1.667-0.573-1.667-1.573V9.555c0-1,0.667-1.573,1.667-1.573h4.666c1,0,1.667,0.573,1.667,1.573V16.447z"}},{"name":"path","attrs":{"class":"st0","d":"M7,10.001h2v2H7V10.001z M11,12.001h2v-2h-2V12.001z M7,16.001h2v-2H7V16.001z M11,16.001h2v-2h-2V16.001z"}},{"name":"path","attrs":{"class":"st0","d":"M0,6.555v6.892c0,1.736,1.334,3.176,3,3.487v-2.016c-0.618-0.205-1-0.716-1-1.472V6.555\\r\\n\\t\\tc0-0.756,0.382-1.267,1-1.472V3.068C1.334,3.379,0,4.819,0,6.555z"}},{"name":"path","attrs":{"class":"st0","d":"M5.993,3.553c0-1,0.667-1.573,1.667-1.573h4.666c0.09,0,0.129-0.005,0.258-0.004h3.014\\r\\n\\t\\tc-0.611-1.18-1.87-1.976-3.272-1.976H7.66c-1.963,0-3.667,1.591-3.667,3.554v1.446h2V3.553z"}},{"name":"path","attrs":{"class":"st0","d":"M16.333,3.001h-4.666c-1.403,0-2.661,0.82-3.272,2c0,0,8.112-0.009,8.196,0c0,0,0.091,0,0.409,0.082\\r\\n\\t\\tc0.612,0.141,1,0.716,1,1.472v6.892c0,0.756-0.382,1.267-1,1.472v2.016c1.666-0.311,3-1.751,3-3.487V6.555\\r\\n\\t\\tC20,4.592,18.296,3.001,16.333,3.001z"}}]}],"title":"lastTrick"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{},"childs":[{"name":"rect","attrs":{"class":"st0","width":"20","height":"20"}},{"name":"path","attrs":{"class":"st1","d":"M15.25,1H2.75C1.784,1,1,1.784,1,2.75v12.5C1,16.216,1.784,17,2.75,17H7c0.406,0,1-0.594,1-1v-1H4.75\\r\\n\\t\\tC3.784,15,3,14.216,3,13.25v-8.5C3,3.784,3.784,3,4.75,3h8.5C14.216,3,15,3.784,15,4.75V8h1c0.55,0,1-0.45,1-1V2.75\\r\\n\\t\\tC17,1.784,16.216,1,15.25,1z"}},{"name":"circle","attrs":{"class":"st1","cx":"6.5","cy":"6.5","r":"1.5"}},{"name":"circle","attrs":{"class":"st1","cx":"11.5","cy":"6.5","r":"1.5"}},{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st2","d":"M15.691,14l2.96-2.96c0.465-0.465,0.465-1.226,0-1.691c-0.465-0.465-1.226-0.465-1.691,0L14,12.309\\r\\n\\t\\t\\tl-2.96-2.96c-0.465-0.465-1.226-0.465-1.691,0c-0.465,0.465-0.465,1.226,0,1.691l2.96,2.96l-2.96,2.96\\r\\n\\t\\t\\tc-0.465,0.465-0.465,1.226,0,1.691c0.465,0.465,1.226,0.465,1.691,0l2.96-2.96l2.96,2.96c0.465,0.465,1.226,0.465,1.691,0\\r\\n\\t\\t\\tc0.465-0.465,0.465-1.226,0-1.691L15.691,14z"}}]}]}],"title":"leaveDuell"},{"name":"svg","attrs":{"version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{"id":"Layer_1"}},{"name":"g","attrs":{"id":"_x2D_GENERIC"},"childs":[{"name":"g","attrs":{"id":"buchstabeOn"}},{"name":"g","attrs":{"id":"buchstabeOff"},"childs":[{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st0","d":"M17,2H7H3C1.35,2,0,3.35,0,5v10c0,1.65,1.35,3,3,3h4h3h7c1.65,0,3-1.35,3-3V5C20,3.35,18.65,2,17,2z\\r\\n\\t\\t\\t\\t M8.536,12.121c0.389,0.389,0.389,1.025,0,1.414s-1.025,0.389-1.414,0L5,11.414l-2.121,2.121c-0.389,0.389-1.025,0.389-1.414,0\\r\\n\\t\\t\\t\\ts-0.389-1.025,0-1.414L3.586,10L1.464,7.879c-0.389-0.389-0.389-1.025,0-1.414c0.389-0.389,1.025-0.389,1.414,0L5,8.586\\r\\n\\t\\t\\t\\tl2.121-2.121c0.389-0.389,1.025-0.389,1.414,0c0.389,0.389,0.389,1.025,0,1.414L6.414,10L8.536,12.121z M18,15\\r\\n\\t\\t\\t\\tc0,0.542-0.458,1-1,1h-7v-1v-4.127l3.744-0.001l-1.059,1.08c-0.247,0.155-0.395,0.404-0.395,0.671\\r\\n\\t\\t\\t\\tc0,0.179,0.065,0.349,0.188,0.492c0.308,0.36,0.875,0.437,1.339,0.165l2.73-2.43c0.245-0.218,0.404-0.415,0.421-0.675\\r\\n\\t\\t\\t\\tl0.001-0.046c0-0.246-0.082-0.45-0.283-0.658l-2.771-2.821c-0.391-0.279-0.968-0.246-1.311,0.076\\r\\n\\t\\t\\t\\tc-0.163,0.153-0.253,0.352-0.253,0.561c0,0.238,0.119,0.47,0.312,0.609l0.976,1.133L10,9.029V5V4h7c0.542,0,1,0.458,1,1V15z"}},{"name":"rect","attrs":{"class":"st1","width":"20","height":"20"}}]}]}]}],"title":"letterOff"},{"name":"svg","attrs":{"version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{"id":"Layer_1"}},{"name":"g","attrs":{"id":"_x2D_GENERIC"},"childs":[{"name":"g","attrs":{"id":"buchstabeOn"},"childs":[{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st0","d":"M17,2H7H3C1.35,2,0,3.35,0,5v10c0,1.65,1.35,3,3,3h4h3h7c1.65,0,3-1.35,3-3V5C20,3.35,18.65,2,17,2z M18,15\\r\\n\\t\\t\\t\\tc0,0.542-0.458,1-1,1h-7v-1v-4.127l3.744-0.001l-1.059,1.08c-0.247,0.155-0.395,0.404-0.395,0.671\\r\\n\\t\\t\\t\\tc0,0.179,0.065,0.349,0.188,0.492c0.308,0.36,0.875,0.437,1.339,0.165l2.73-2.43c0.245-0.218,0.404-0.415,0.421-0.675\\r\\n\\t\\t\\t\\tl0.001-0.046c0-0.246-0.082-0.45-0.283-0.658l-2.771-2.821c-0.391-0.279-0.968-0.246-1.311,0.076\\r\\n\\t\\t\\t\\tc-0.163,0.153-0.253,0.352-0.253,0.561c0,0.238,0.119,0.47,0.312,0.609l0.976,1.133L10,9.029V5V4h7c0.542,0,1,0.458,1,1V15z"}},{"name":"rect","attrs":{"class":"st1","width":"20","height":"20"}}]}]}]}],"title":"letterOn"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st0","d":"M10.028,0C10.018,0,10.01,0.003,10,0.003C9.99,0.003,9.982,0,9.972,0C6.343,0,3.401,2.883,3.401,6.438\\r\\n\\t\\tc0,0.644,0.126,1.253,0.305,1.839c0.041,0.234,0.131,0.532,0.296,0.928l1.685,3.42C6.568,14.42,6.015,16,7.043,16H10h2.957\\r\\n\\t\\tc1.028,0,0.475-1.58,1.356-3.374l1.685-3.42c0.165-0.396,0.255-0.694,0.296-0.928c0.179-0.586,0.305-1.196,0.305-1.839\\r\\n\\t\\tC16.599,2.883,13.657,0,10.028,0z"}},{"name":"path","attrs":{"class":"st0","d":"M13.356,19.035c0,0.533-0.527,0.965-1.177,0.965H7.821c-0.65,0-1.177-0.432-1.177-0.965l0,0\\r\\n\\t\\tc0-0.533,0.527-0.965,1.177-0.965h4.358C12.829,18.071,13.356,18.502,13.356,19.035L13.356,19.035z"}}]},{"name":"rect","attrs":{"class":"st1","width":"20","height":"20"}}],"title":"logic"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{"id":"icf_x5F_login"},"childs":[{"name":"rect","attrs":{"class":"st0","width":"20","height":"20"}},{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st1","d":"M8.897,12.163C8.629,12.33,8.47,12.6,8.47,12.888c0,0.194,0.07,0.378,0.203,0.533\\r\\n\\t\\t\\tc0.333,0.389,0.947,0.473,1.448,0.178l2.952-2.627c0.265-0.235,0.436-0.449,0.455-0.73l0.002-0.05\\r\\n\\t\\t\\tc0-0.266-0.088-0.486-0.306-0.712l-2.997-3.05C9.804,6.127,9.181,6.163,8.809,6.511C8.633,6.677,8.536,6.892,8.536,7.118\\r\\n\\t\\t\\tc0,0.257,0.129,0.508,0.337,0.659l1.055,1.225L1.705,9.003C1.296,9.003,0.96,9.452,0.96,10c0,0.548,0.335,0.996,0.745,0.996\\r\\n\\t\\t\\tl8.336-0.001L8.897,12.163z"}},{"name":"path","attrs":{"class":"st1","d":"M16,1H6C5.091,1,4,2.043,4,3v4h2V3h10v14H6v-4H4v4c0,1,1,2,2,2h10c1,0,2-1,2-2V3C18,2.043,16.909,1,16,1z"}}]}]}],"title":"login"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"rect","attrs":{"x":"0","y":"0","class":"st0","width":"20","height":"20"}},{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st1","d":"M19.224,9.479l-2.997-3.05c-0.423-0.302-1.046-0.266-1.418,0.082c-0.176,0.165-0.274,0.381-0.274,0.607\\r\\n\\t\\tc0,0.257,0.129,0.508,0.337,0.659l1.055,1.225L7.705,9.003C7.296,9.003,6.96,9.452,6.96,10c0,0.548,0.335,0.996,0.745,0.996\\r\\n\\t\\tl8.336-0.001l-1.145,1.167c-0.268,0.167-0.427,0.437-0.427,0.725c0,0.194,0.07,0.378,0.203,0.533\\r\\n\\t\\tc0.333,0.389,0.947,0.473,1.448,0.178l2.952-2.627c0.265-0.235,0.436-0.449,0.455-0.73l0.002-0.05\\r\\n\\t\\tC19.53,9.925,19.442,9.705,19.224,9.479z"}},{"name":"path","attrs":{"class":"st1","d":"M14,17H4V3h10v1h2V3c0-1-1-2-2-2H4C3,1,2,2,2,3v14c0,0.957,1.091,2,2,2h10c0.909,0,2-1.043,2-2v-1h-2V17z"}}]}],"title":"logout"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"path","attrs":{"class":"st0","d":"M8,0C3.582,0,0,3.582,0,8c0,4.418,3.582,8,8,8s8-3.582,8-8C16,3.582,12.418,0,8,0z M8,13c-2.761,0-5-2.239-5-5\\r\\n\\tc0-2.761,2.239-5,5-5s5,2.239,5,5C13,10.761,10.761,13,8,13z"}},{"name":"path","attrs":{"class":"st0","d":"M18.243,18.243c-0.778,0.778-2.05,0.778-2.828,0.001l-3.159-3.159c-0.777-0.777-0.777-2.05,0.001-2.828\\r\\n\\tc0.778-0.778,2.05-0.778,2.828-0.001l3.159,3.159C19.021,16.192,19.02,17.465,18.243,18.243"}},{"name":"rect","attrs":{"class":"st1","width":"20","height":"20"}}],"title":"magnify"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st0","d":"M18.356,5.685c-0.454-1.118-1.081-2.077-1.881-2.877c-0.786-0.8-1.724-1.422-2.813-1.865\\r\\n\\t\\tc-1.09-0.443-2.263-0.664-3.52-0.664c-1.265,0-2.46,0.239-3.585,0.718C5.431,1.475,4.465,2.128,3.658,2.957\\r\\n\\t\\tC2.829,3.8,2.179,4.788,1.707,5.92C1.236,7.053,1,8.283,1,9.612c0,1.379,0.227,2.651,0.681,3.815\\r\\n\\t\\tc0.454,1.165,1.084,2.158,1.892,2.979c0.814,0.829,1.777,1.468,2.888,1.918C7.571,18.775,8.78,19,10.088,19\\r\\n\\t\\tc0.113,0,0.216-0.007,0.327-0.009L10.41,19c0.103-0.002,0.255-0.01,0.424-0.02c0.493-0.017,0.968-0.046,1.407-0.098\\r\\n\\t\\tc0.105-0.013,0.211-0.032,0.316-0.046c0.566-0.061,1.085-0.132,1.341-0.203l0.005,0.01l0.291-0.098\\r\\n\\t\\tc0.01-0.002,0.019-0.004,0.029-0.006v-0.004l0.117-0.039c0.193-0.035,0.51-0.217,0.51-0.217c0.254-0.24,0.401-0.586,0.334-0.954\\r\\n\\t\\tc-0.087-0.483-0.494-0.814-0.962-0.856V16.46c-0.01,0.003-0.023,0.005-0.034,0.008c-0.082-0.005-0.162-0.021-0.246-0.005\\r\\n\\t\\tl-0.955,0.266c-0.204,0.043-0.556,0.114-0.899,0.173c-0.743,0.104-1.412,0.158-1.999,0.158c-0.914,0-1.781-0.161-2.602-0.482\\r\\n\\t\\tc-0.821-0.322-1.542-0.789-2.163-1.404c-0.621-0.622-1.119-1.4-1.494-2.336c-0.375-0.936-0.562-2.011-0.562-3.226\\r\\n\\t\\tc0-1.115,0.198-2.14,0.594-3.076C4.262,5.601,4.778,4.822,5.414,4.2c0.621-0.607,1.34-1.089,2.157-1.447\\r\\n\\t\\tc0.818-0.357,1.679-0.536,2.586-0.536c0.949,0,1.831,0.15,2.645,0.45c0.814,0.3,1.524,0.757,2.131,1.372\\r\\n\\t\\tc0.593,0.6,1.056,1.356,1.392,2.267c0.336,0.911,0.503,1.97,0.503,3.178c0,0.607-0.063,1.241-0.187,1.902\\r\\n\\t\\tc-0.125,0.661-0.192,1.113-0.484,1.86c0,0-0.217,0.983-1.046,0.926c-0.829-0.057-0.865-0.947-0.865-0.947V4.479H11.76v0.664\\r\\n\\t\\tc-0.2-0.193-0.482-0.377-0.846-0.552c-0.364-0.175-0.782-0.263-1.254-0.263c-0.55,0-1.104,0.129-1.661,0.386\\r\\n\\t\\tC7.441,4.972,6.966,5.329,6.573,5.786C6.151,6.272,5.819,6.842,5.576,7.496C5.333,8.149,5.212,8.912,5.212,9.784\\r\\n\\t\\tc0,1.629,0.361,2.924,1.082,3.885c0.722,0.961,1.665,1.441,2.829,1.441c0.714,0,1.261-0.08,1.64-0.241\\r\\n\\t\\tc0.344-0.146,0.785-0.38,1.169-0.625c0.402,0.743,1.416,1.353,2.669,1.509c1.298,0.161,2.47-0.213,3.019-0.879\\r\\n\\t\\tc0.028-0.024,0.054-0.048,0.054-0.048c0.429-0.679,0.648-1.304,0.933-2.336c0.286-1.032,0.429-2.049,0.429-3.049\\r\\n\\t\\tC19.036,8.055,18.809,6.803,18.356,5.685z M11.706,12.216c-0.286,0.279-0.568,0.491-0.847,0.638\\r\\n\\t\\tc-0.279,0.147-0.604,0.22-0.975,0.22c-0.707,0-1.215-0.271-1.522-0.814c-0.307-0.543-0.461-1.379-0.461-2.508\\r\\n\\t\\tc0-1.043,0.186-1.865,0.557-2.465c0.371-0.6,0.9-0.9,1.586-0.9c0.314,0,0.596,0.034,0.846,0.102\\r\\n\\t\\tc0.25,0.068,0.522,0.177,0.815,0.327V12.216z"}}]},{"name":"rect","attrs":{"x":"0","y":"0","class":"st1","width":"20","height":"20"}}],"title":"mailService"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st0","d":"M16.754,2.108H9.322c-0.681,0-1.239,0.557-1.239,1.239s0.557,1.239,1.239,1.239h4.443L9.903,8.448\\r\\n\\t\\tc-2.133-1.288-4.94-1.027-6.781,0.814c-2.167,2.167-2.167,5.68,0,7.846c2.167,2.167,5.68,2.167,7.846,0\\r\\n\\t\\tc1.849-1.849,2.106-4.674,0.798-6.81l3.749-3.749v4.229c0,0.681,0.557,1.239,1.239,1.239c0.681,0,1.239-0.557,1.239-1.239V3.347\\r\\n\\t\\tC17.993,2.666,17.435,2.108,16.754,2.108z M9.099,15.263c-1.147,1.147-3.007,1.147-4.154,0c-1.147-1.147-1.147-3.007,0-4.154\\r\\n\\t\\ts3.007-1.147,4.154,0S10.246,14.116,9.099,15.263z"}}]},{"name":"rect","attrs":{"class":"st1","width":"20","height":"20"}}],"title":"male"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{"id":"icf_x5F_message_1_"},"childs":[{"name":"rect","attrs":{"class":"st0","width":"20","height":"20"}},{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st1","d":"M9.134,9.834c0.499,0.427,1.234,0.427,1.733,0l8.19-7.009C18.519,2.317,17.798,2,17,2H3\\r\\n\\t\\t\\tC2.202,2,1.481,2.317,0.943,2.825L9.134,9.834z"}},{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st1","d":"M20,13.872V5c0-0.267-0.046-0.522-0.112-0.768l-5.58,4.776L20,13.872z"}},{"name":"path","attrs":{"class":"st1","d":"M13.079,10.059l-1.66,1.421c-0.81,0.693-2.004,0.694-2.815,0.001l-1.673-1.43l-6.468,5.535\\r\\n\\t\\t\\t\\tC0.993,16.433,1.927,17,3,17h14c1.073,0,2.007-0.567,2.537-1.414L13.079,10.059z"}},{"name":"path","attrs":{"class":"st1","d":"M5.692,8.993L0.114,4.226C0.047,4.474,0,4.73,0,5v8.864L5.692,8.993z"}}]}]}]}],"title":"message"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st0","d":"M19,10c0,1.1-0.9,2-2,2H3c-1.1,0-2-0.9-2-2l0,0c0-1.1,0.9-2,2-2h14C18.1,8,19,8.9,19,10L19,10z"}},{"name":"rect","attrs":{"class":"st1","width":"20","height":"20"}}]}],"title":"minus"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{},"childs":[{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st0","d":"M12.964,10.239c0,1.308-1.09,2.528-2.133,2.776c0.454-0.224,0.7-0.679,0.759-1.159\\r\\n\\t\\t\\tc0.077-0.634-0.137-1.33-0.89-1.634c0.179,0.568-0.215,1.076-0.215,1.076c-0.116-1.034-0.682-1.517-1.428-1.741\\r\\n\\t\\t\\tc0.017,0.034,0.337,0.361-0.238,1.056c-0.237,0.288-0.394,0.622-0.394,1.041c0,0.512,0.132,0.956,0.709,1.361\\r\\n\\t\\t\\tc-1.178-0.353-2.136-1.502-2.136-2.812c0-1.046,0.357-1.614,1.076-2.392C8.937,6.876,8.52,6.124,8.335,5.996\\r\\n\\t\\t\\tc1.554,0.418,2.625,1.537,2.674,2.939c0.298-0.288,0.409-1.111,0.132-1.585C11.691,7.542,12.964,8.357,12.964,10.239"}},{"name":"rect","attrs":{"x":"6.471","y":"5.996","class":"st1","width":"7.02","height":"7.02"}}]},{"name":"path","attrs":{"class":"st2","d":"M14,1H6C5.143,1,4,2.35,4,3.2V17c0,0.85,1.143,2,2,2h8c0.857,0,2-1.15,2-2V3.2C16,2.35,14.857,1,14,1z\\r\\n\\t\\t M10.005,18.578c-0.589,0-1.066-0.473-1.066-1.057c0-0.584,0.477-1.057,1.066-1.057c0.589,0,1.066,0.473,1.066,1.057\\r\\n\\t\\tC11.071,18.105,10.594,18.578,10.005,18.578z M14,16H6V3h8V16z"}}]},{"name":"rect","attrs":{"class":"st1","width":"20","height":"20"}}],"title":"mobile"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{},"childs":[{"name":"g","attrs":{},"childs":[{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st0","d":"M11,11v1.75c-0.989-0.434-2.677-0.391-4.047,0.053c-2.349,0.76-3.35,2.582-2.81,4.218\\r\\n\\t\\t\\t\\tc0.54,1.636,2.882,2.268,4.934,1.707C11.024,18.196,13,16.891,13,15.503V13L11,11z"}},{"name":"path","attrs":{"class":"st0","d":"M19.011,9.836c-0.216-9.016-3.908-6.71-6.484-9.32c0,0-0.362-0.401-0.822-0.401\\r\\n\\t\\t\\t\\tc-0.782,0-0.704,0.521-0.704,0.521V5L13,7V4.686c5.886,2.018,4.373,5.814,5.772,6.024C19.073,10.6,19.018,10.109,19.011,9.836z"}}]},{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st0","d":"M18.7,14.455c-0.4,0.4-1.055,0.4-1.455,0L2.985,2.71c-0.4-0.4-0.4-1.055,0-1.455l0,0\\r\\n\\t\\t\\t\\tc0.4-0.4,1.055-0.4,1.455,0L18.7,13C19.1,13.4,19.1,14.055,18.7,14.455L18.7,14.455z"}}]}]},{"name":"rect","attrs":{"y":"0","class":"st1","width":"20","height":"20"}}]}],"title":"musicOff"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"path","attrs":{"class":"st0","d":"M18.775,9.836c-0.216-9.016-3.908-6.71-6.484-9.32c0,0-0.362-0.401-0.822-0.401c-0.782,0-0.72,0.521-0.72,0.521\\r\\n\\tv9.969V11.4v1.35c-0.989-0.434-2.457-0.391-3.827,0.053c-2.349,0.76-3.35,2.582-2.81,4.218c0.54,1.636,2.882,2.268,4.933,1.708\\r\\n\\tc1.948-0.532,3.895-1.837,3.895-3.226v-1.911v-0.737v-0.059V4.686c5.886,2.018,4.195,5.814,5.594,6.024\\r\\n\\tC18.837,10.6,18.781,10.11,18.775,9.836z"}},{"name":"rect","attrs":{"x":"0.018","class":"st1","width":"20","height":"20"}}],"title":"musicOn"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"path","attrs":{"class":"st0","d":"M14.045,1H5.955C4.875,1,4,1.875,4,2.955v0.972v3.312V19l6-4.573L16,19V7.239V3.927V2.955\\r\\n\\tC16,1.875,15.125,1,14.045,1z M12.977,12.395c-0.015,0.1-0.036,0.179-0.063,0.238c-0.028,0.058-0.059,0.1-0.094,0.126\\r\\n\\tc-0.035,0.026-0.075,0.039-0.121,0.039H7.317c-0.04,0-0.078-0.013-0.113-0.039c-0.035-0.026-0.067-0.068-0.094-0.126\\r\\n\\tc-0.028-0.059-0.049-0.138-0.064-0.238c-0.015-0.099-0.023-0.221-0.023-0.364c0-0.148,0.006-0.272,0.019-0.372\\r\\n\\tc0.013-0.099,0.033-0.18,0.06-0.241c0.028-0.061,0.059-0.106,0.094-0.134c0.035-0.028,0.075-0.042,0.121-0.042h1.817V4.778\\r\\n\\tL7.565,5.661C7.45,5.717,7.355,5.752,7.282,5.764C7.21,5.777,7.152,5.762,7.11,5.718C7.066,5.675,7.038,5.599,7.023,5.492\\r\\n\\tS7,5.233,7,5.039c0-0.123,0.003-0.224,0.008-0.303c0.005-0.079,0.018-0.147,0.038-0.203c0.02-0.056,0.048-0.102,0.083-0.138\\r\\n\\tC7.163,4.359,7.211,4.32,7.271,4.279l2.095-1.381c0.025-0.02,0.056-0.037,0.094-0.05c0.037-0.012,0.086-0.023,0.147-0.031\\r\\n\\tc0.06-0.007,0.14-0.012,0.237-0.015C9.944,2.8,10.07,2.798,10.226,2.798c0.191,0,0.345,0.004,0.463,0.012\\r\\n\\tc0.118,0.007,0.207,0.02,0.267,0.038c0.06,0.018,0.101,0.042,0.121,0.073c0.02,0.031,0.03,0.069,0.03,0.115v8.204h1.591\\r\\n\\tc0.045,0,0.086,0.014,0.125,0.042c0.037,0.028,0.069,0.073,0.097,0.134c0.027,0.061,0.047,0.142,0.06,0.241\\r\\n\\tc0.012,0.1,0.019,0.224,0.019,0.372C13,12.174,12.992,12.296,12.977,12.395z"}},{"name":"rect","attrs":{"class":"st1","width":"20","height":"20"}}],"title":"numbre1"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{},"childs":[{"name":"rect","attrs":{"class":"st0","width":"20","height":"20"}},{"name":"path","attrs":{"class":"st1","d":"M18.416,3.224c-0.691-0.581-1.733-0.491-2.314,0.2L7.418,14.231l-3.976-3.976\\r\\n\\t\\tc-0.639-0.639-1.684-0.639-2.322,0c-0.639,0.639-0.639,1.684,0,2.322l5.225,5.225c0.295,0.295,0.678,0.448,1.067,0.47h0\\r\\n\\t\\tc0.057,0.003,0.114,0.004,0.172,0.001c0.469,0,0.936-0.191,1.259-0.576l9.773-12.161C19.198,4.846,19.108,3.805,18.416,3.224z"}}]}],"title":"ok"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st0","d":"M12.147,13.939c-0.9,0.424-2.74-0.034-4.376-2.882C6.384,8.644,7.145,7.44,7.522,7.042L4.588,2.667\\r\\n\\t\\tC4.113,2.95,3.107,3.731,3.002,5.334c-0.229,3.496,3.148,8.943,6.59,12.022c3.086,2.761,5.098,1.284,5.482,0.949L12.147,13.939z"}},{"name":"path","attrs":{"class":"st0","d":"M15.979,17.87c0.013-0.008,0.028-0.008,0.04-0.016l0.62-0.419c0.391-0.264,0.478-0.821,0.193-1.242\\r\\n\\t\\tl-1.999-2.96c-0.285-0.422-0.833-0.55-1.224-0.285l-0.62,0.419c-0.007,0.005-0.01,0.013-0.017,0.018L15.979,17.87z"}},{"name":"path","attrs":{"class":"st0","d":"M8.357,6.453C8.401,6.434,8.449,6.427,8.49,6.4l0.617-0.417c0.39-0.263,0.475-0.817,0.192-1.237L7.309,1.8\\r\\n\\t\\tC7.026,1.38,6.48,1.252,6.09,1.515L5.473,1.932C5.437,1.957,5.417,1.994,5.387,2.023L8.357,6.453z"}}]},{"name":"rect","attrs":{"x":"0","y":"0","class":"st1","width":"20","height":"20"}}],"title":"phoneService"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st0","d":"M17,8h-5V3c0-1.105-0.895-2-2-2S8,1.895,8,3v5H3c-1.1,0-2,0.9-2,2c0,1.1,0.9,2,2,2h5v5c0,1.105,0.895,2,2,2\\r\\n\\t\\ts2-0.895,2-2v-5h5c1.1,0,2-0.9,2-2C19,8.9,18.1,8,17,8z"}},{"name":"rect","attrs":{"class":"st1","width":"20","height":"20"}}]}],"title":"plus"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{},"childs":[{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st0","d":"M13.976,2.114c-1.077-0.81-2.532-1.215-4.366-1.215c-1.017,0-2.02,0.11-3.007,0.329\\r\\n\\t\\t\\tC5.616,1.447,4.883,1.696,4.883,1.696c-0.26,0.088-0.473,0.386-0.473,0.661v2.397c0,0.275,0.1,0.5,0.223,0.5\\r\\n\\t\\t\\tS5.051,5.143,5.29,5.008c0,0,0.736-0.415,1.408-0.645c0.672-0.23,1.275-0.345,1.81-0.345c0.869,0,1.542,0.158,2.021,0.474\\r\\n\\t\\t\\tc0.479,0.316,0.718,0.846,0.718,1.589c0,0.498-0.124,0.944-0.373,1.338c-0.249,0.394-0.592,0.74-1.03,1.037\\r\\n\\t\\t\\tC9.376,8.791,8.929,9.032,8.502,9.181c-0.427,0.149-0.95,0.298-0.95,0.298c-0.264,0.075-0.481,0.362-0.481,0.637v2.756\\r\\n\\t\\t\\tc0,0.275,0.225,0.5,0.5,0.5h2.92c0.275,0,0.5-0.225,0.5-0.5v-1.541c0-0.275,0.206-0.589,0.459-0.699c0,0,0.879-0.381,1.44-0.715\\r\\n\\t\\t\\tc0.56-0.335,1.041-0.714,1.442-1.137c0.401-0.423,0.711-0.923,0.93-1.499c0.219-0.576,0.328-1.239,0.328-1.99\\r\\n\\t\\t\\tC15.591,3.983,15.052,2.924,13.976,2.114z"}}]},{"name":"circle","attrs":{"class":"st0","cx":"8.958","cy":"16.871","r":"2.159"}}]},{"name":"rect","attrs":{"x":"0","y":"0","class":"st1","width":"20","height":"20"}}],"title":"question"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{},"childs":[{"name":"rect","attrs":{"class":"st0","width":"20","height":"20"}},{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st1","d":"M19,10l-2,2v4c0,0.7-0.4,1-1,1H4c-0.6,0.1-1-0.4-1-1V4c0-0.6,0.4-1,1-1h5l2-2H4C2.3,1,1,2.3,1,4v12\\r\\n\\t\\t\\tc0,1.8,1.3,3,3,3h12c1.8,0,3-1,3-3V10z"}}]},{"name":"path","attrs":{"class":"st1","d":"M18.928,0.487c-0.912-0.637-2.057-0.64-2.743-0.06L16.147,0.4L8.173,11.393V15l4-1l7.743-10.965l-0.038-0.027\\r\\n\\t\\tC20.215,2.184,19.84,1.124,18.928,0.487z M9.609,13.326L9.25,11.216l6.471-8.929c0.155,0.479,0.48,0.939,0.965,1.278\\r\\n\\t\\ts1.034,0.491,1.547,0.479l-6.471,8.929L9.609,13.326z"}}]}],"title":"result"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"path","attrs":{"class":"st0","d":"M14.885,2.603l0.005-0.013l-0.463-0.268c-0.179-0.141-0.58-0.278-0.58-0.278\\r\\n\\tc-0.404-0.037-0.819,0.101-1.088,0.442c-0.424,0.535-0.332,1.32,0.203,1.743l0.965,0.627c1.612,1.203,2.662,3.116,2.662,5.282\\r\\n\\tc0,3.631-2.933,6.575-6.558,6.598c-3.626-0.023-6.558-2.967-6.558-6.598c0-1.643,0.606-3.138,1.601-4.291\\r\\n\\tC5.78,6.861,6.812,8.276,7.104,8.324C7.56,8.399,7.994,8.088,8.07,7.632l0.822-4.971C8.967,2.206,8.656,1.771,8.2,1.696L3.229,0.874\\r\\n\\tC2.773,0.799,2.339,1.11,2.263,1.566C2.217,1.844,3.02,3.005,3.65,3.865C2.061,5.484,1.072,7.69,1.072,10.139\\r\\n\\tc0,4.956,4.007,8.975,8.958,8.998c4.951-0.023,8.958-4.042,8.958-8.998C18.989,6.977,17.352,4.207,14.885,2.603z"}},{"name":"rect","attrs":{"x":"0","y":"0","class":"st1","width":"20","height":"20"}}],"title":"rounds"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{},"childs":[{"name":"g","attrs":{},"childs":[{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st0","d":"M18.047,4.938c0,0,0.024,0.994-0.971,1c-1.076,0.007-1.029-1-1.029-1l0-0.937c0-0.7-0.4-1-1-1l-12,0\\r\\n\\t\\t\\t\\tc-0.6-0.1-1,0.4-1,1l0,12c0,0.6,0.4,1,1,1l6.525,0h0.913c0,0,1.011-0.053,1.008,0.988C11.491,19.001,10.501,19,10.501,19H9.708\\r\\n\\t\\t\\t\\tl-6.661,0c-1.7,0-3-1.3-3-3l0-12c0-1.8,1.3-3,3-3l12,0c1.8,0,3,1,3,3L18.047,4.938z"}}]},{"name":"path","attrs":{"class":"st1","d":"M11.182,12.962h-4.48c-0.381,0-0.693-0.433-0.693-0.962v0c0-0.529,0.312-0.962,0.693-0.962h4.48\\r\\n\\t\\t\\tc0.381,0,0.693,0.433,0.693,0.962v0C11.874,12.529,11.563,12.962,11.182,12.962z"}},{"name":"path","attrs":{"class":"st1","d":"M11.182,8.775h-4.48c-0.381,0-0.693-0.433-0.693-0.962v0c0-0.529,0.312-0.962,0.693-0.962h4.48\\r\\n\\t\\t\\tc0.381,0,0.693,0.433,0.693,0.962v0C11.874,8.342,11.563,8.775,11.182,8.775z"}},{"name":"g","attrs":{},"childs":[{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st0","d":"M19.003,8.876c-0.634-0.477-1.49-0.715-2.57-0.715c-0.599,0-1.066,0.065-1.648,0.193\\r\\n\\t\\t\\t\\t\\tc-0.581,0.129-1.013,0.276-1.013,0.276c-0.153,0.052-0.279,0.227-0.279,0.389v1.411c0,0.162,0.059,0.294,0.131,0.294\\r\\n\\t\\t\\t\\t\\ts0.246-0.065,0.387-0.145c0,0,0.433-0.244,0.829-0.38c0.395-0.135,0.628-0.203,0.943-0.203c0.511,0,0.908,0.093,1.19,0.279\\r\\n\\t\\t\\t\\t\\tc0.282,0.186,0.423,0.498,0.423,0.936c0,0.293-0.073,0.556-0.22,0.788c-0.146,0.232-0.349,0.435-0.606,0.611\\r\\n\\t\\t\\t\\t\\tc-0.275,0.197-0.539,0.339-0.79,0.427c-0.251,0.087-0.559,0.175-0.559,0.175c-0.156,0.044-0.283,0.213-0.283,0.375v1.623\\r\\n\\t\\t\\t\\t\\tc0,0.162,0.132,0.294,0.294,0.294h1.719c0.162,0,0.294-0.132,0.294-0.294v-0.907c0-0.162,0.122-0.347,0.27-0.411\\r\\n\\t\\t\\t\\t\\tc0,0,0.518-0.224,0.848-0.421c0.33-0.197,0.613-0.42,0.849-0.669c0.236-0.249,0.418-0.543,0.547-0.882\\r\\n\\t\\t\\t\\t\\tc0.129-0.339,0.193-0.729,0.193-1.171C19.953,9.976,19.636,9.352,19.003,8.876z"}}]},{"name":"circle","attrs":{"class":"st0","cx":"16.049","cy":"17.729","r":"1.271"}}]}]},{"name":"rect","attrs":{"class":"st2","width":"20","height":"20"}}]}],"title":"rules"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{"id":"icf_x5F_screenBig"},"childs":[{"name":"rect","attrs":{"class":"st0","width":"20","height":"20"}},{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st1","d":"M18,1h-8H2C1.091,1,0,2.043,0,3v12c0,1,1,2,2,2h6c0,0,0.115,0.878,0,1c-0.909,0.957-2,1-2,1v1h4h4v-1\\r\\n\\t\\t\\tc0,0-1.091-0.043-2-1c-0.115-0.122,0-1,0-1h6c1,0,2-1,2-2V3C20,2.043,18.909,1,18,1z M18,15h-8H2V3h8h8V15z"}}]},{"name":"path","attrs":{"class":"st1","d":"M15.75,14H4.25C3.56,14,3,13.44,3,12.75v-7.5C3,4.56,3.56,4,4.25,4h11.5C16.44,4,17,4.56,17,5.25v7.5\\r\\n\\t\\tC17,13.44,16.44,14,15.75,14z"}}]}],"title":"screenBig"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{"id":"icf_x5F_screenMedium"},"childs":[{"name":"rect","attrs":{"class":"st0","width":"20","height":"20"}},{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st1","d":"M18,1h-8H2C1.091,1,0,2.043,0,3v12c0,1,1,2,2,2h6c0,0,0.115,0.878,0,1c-0.909,0.957-2,1-2,1v1h4h4v-1\\r\\n\\t\\t\\tc0,0-1.091-0.043-2-1c-0.115-0.122,0-1,0-1h6c1,0,2-1,2-2V3C20,2.043,18.909,1,18,1z M18,15h-8H2V3h8h8V15z"}}]},{"name":"path","attrs":{"class":"st1","d":"M14.75,13h-9.5C4.56,13,4,12.44,4,11.75v-5.5C4,5.56,4.56,5,5.25,5h9.5C15.44,5,16,5.56,16,6.25v5.5\\r\\n\\t\\tC16,12.44,15.44,13,14.75,13z"}}]}],"title":"screenMedium"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{"id":"icf_x5F_screenSmall"},"childs":[{"name":"rect","attrs":{"class":"st0","width":"20","height":"20"}},{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st1","d":"M18,1h-8H2C1.091,1,0,2.043,0,3v12c0,1,1,2,2,2h6c0,0,0.115,0.878,0,1c-0.909,0.957-2,1-2,1v1h4h4v-1\\r\\n\\t\\t\\tc0,0-1.091-0.043-2-1c-0.115-0.122,0-1,0-1h6c1,0,2-1,2-2V3C20,2.043,18.909,1,18,1z M18,15h-8H2V3h8h8V15z"}}]},{"name":"path","attrs":{"class":"st1","d":"M12.75,12h-5.5C6.56,12,6,11.44,6,10.75v-3.5C6,6.56,6.56,6,7.25,6h5.5C13.44,6,14,6.56,14,7.25v3.5\\r\\n\\t\\tC14,11.44,13.44,12,12.75,12z"}}]}],"title":"screenSmall"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"path","attrs":{"class":"st0","d":"M18.029,7.042H16.65V3.8c0-2.47-1.615-3.8-5.035-3.8h-4.37C4.68,0,3.35,1.425,3.35,3.8v3.242H1.958\\r\\n\\tc-0.855,0-0.95,0.19-0.95,1.045v9.963c0,0.855,0.095,0.95,0.95,0.95h16.071c0.855,0,0.95-0.095,0.95-0.95V7.992\\r\\n\\tC18.979,7.137,18.884,7.042,18.029,7.042z M5.987,3.938c0-0.855,0.095-0.95,0.95-0.95h6.125c0.855,0,0.95,0.095,0.95,0.95v3.104\\r\\n\\tH5.987V3.938z M10.95,14.25v1.9c0,0.19,0.19,0,0,0H9.62c-0.19,0-0.57,0-0.57,0v-1.9c-0.475-0.285-0.95-1.33-0.95-1.9\\r\\n\\tc0-1.049,1.045-1.9,1.9-1.9s1.9,0.772,1.9,1.9C11.9,12.92,11.425,13.965,10.95,14.25z"}},{"name":"rect","attrs":{"class":"st1","width":"20","height":"20"}}],"title":"secure"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st0","d":"M14,1H6C5.143,1,4,2.35,4,3.2V17c0,0.85,1.143,2,2,2h8c0.857,0,2-1.15,2-2V3.2C16,2.35,14.857,1,14,1z\\r\\n\\t\\t M10.005,18.578c-0.589,0-1.066-0.473-1.066-1.057c0-0.584,0.477-1.057,1.066-1.057c0.589,0,1.066,0.473,1.066,1.057\\r\\n\\t\\tC11.071,18.105,10.594,18.578,10.005,18.578z M14,16H6V3h8V16z"}},{"name":"rect","attrs":{"class":"st1","width":"20","height":"20"}}]}],"title":"shakeOff"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st0","d":"M16.749,7.466l-0.511,0.908c0.511,0.379,0.852,0.908,0.852,1.59c0,0.681-0.17,1.287-0.767,1.665l0.511,0.833\\r\\n\\t\\tc0.767-0.606,1.278-1.514,1.278-2.498C18.027,8.98,17.516,8.072,16.749,7.466z"}},{"name":"path","attrs":{"class":"st0","d":"M18.146,5.323l-0.645,0.928c0.886,0.928,1.531,2.279,1.531,3.714c0,1.519-0.564,2.87-1.531,3.798l0.645,0.928\\r\\n\\t\\tC19.275,13.51,20,11.822,20,9.965C19.919,8.193,19.275,6.505,18.146,5.323z"}},{"name":"path","attrs":{"class":"st0","d":"M1.888,9.998c0,0.984,0.511,1.893,1.278,2.498l0.511-0.833C3.08,11.285,2.91,10.68,2.91,9.998\\r\\n\\t\\tc0-0.681,0.341-1.211,0.852-1.59L3.251,7.5C2.484,8.106,1.973,9.014,1.888,9.998z"}},{"name":"path","attrs":{"class":"st0","d":"M0,9.965c0,1.857,0.725,3.545,1.854,4.726l0.645-0.928c-0.967-0.928-1.531-2.279-1.531-3.798\\r\\n\\t\\tc0-1.435,0.645-2.785,1.531-3.714L1.854,5.323C0.725,6.505,0.081,8.193,0,9.965z"}},{"name":"path","attrs":{"class":"st0","d":"M14,1H6C5.143,1,4,2.35,4,3.2V17c0,0.85,1.143,2,2,2h8c0.857,0,2-1.15,2-2V3.2C16,2.35,14.857,1,14,1z\\r\\n\\t\\t M10.005,18.578c-0.589,0-1.066-0.473-1.066-1.057c0-0.584,0.477-1.057,1.066-1.057c0.589,0,1.066,0.473,1.066,1.057\\r\\n\\t\\tC11.071,18.105,10.594,18.578,10.005,18.578z M14,16H6V3h8V16z"}}]},{"name":"rect","attrs":{"x":"0","y":"0","class":"st1","width":"20","height":"20"}}],"title":"shakeOn"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{"id":"icf_x5F_skillLevel"},"childs":[{"name":"rect","attrs":{"class":"st0","width":"20","height":"20"}},{"name":"path","attrs":{"class":"st1","d":"M10,0.022c-5.523,0-10,4.477-10,10c0,2.581,0.986,4.927,2.592,6.701c0.224,0.247,0.46,0.483,0.707,0.707\\r\\n\\t\\tl0.707-0.707l1.414-1.414l0.707-0.707c-0.255-0.216-0.491-0.452-0.707-0.707C4.536,12.849,4,11.499,4,10.022c0-3.314,2.686-6,6-6\\r\\n\\t\\ts6,2.686,6,6c0,1.477-0.536,2.827-1.421,3.872c-0.216,0.255-0.452,0.491-0.707,0.707l0.707,0.707l1.414,1.414l0.707,0.707\\r\\n\\t\\tc0.247-0.224,0.483-0.46,0.707-0.707C19.014,14.949,20,12.604,20,10.022C20,4.499,15.523,0.022,10,0.022z M16.701,16.016\\r\\n\\t\\tl-1.414-1.414C16.351,13.374,17,11.775,17,10.022c0-2.113-0.94-4.003-2.421-5.286l1.414-1.414C17.835,4.97,19,7.357,19,10.022\\r\\n\\t\\tC19,12.328,18.126,14.424,16.701,16.016z"}}]}],"title":"skillLevel"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st0","d":"M10.757,2L5,6v8l5.757,4C11.125,18,12,18,12,17V3C12,2,11.163,2,10.757,2z M0,7.071v5.858\\r\\n\\t\\tC0,13.572,0.321,14,0.964,14H4V6H0.964C0.321,6,0,6.321,0,7.071z"}},{"name":"rect","attrs":{"class":"st1","width":"20","height":"20"}},{"name":"path","attrs":{"class":"st0","d":"M17.752,10.5L17.752,10.5l2.163,2.163c0.114,0.114,0.114,0.341,0,0.455l-0.797,0.797\\r\\n\\t\\tc-0.114,0.114-0.341,0.114-0.455,0L16.5,11.752l0,0l-2.163,2.163c-0.114,0.114-0.341,0.114-0.455,0l-0.797-0.797\\r\\n\\t\\tc-0.114-0.114-0.114-0.341,0-0.455l2.163-2.163l0,0l-2.163-2.163c-0.114-0.114-0.114-0.341,0-0.455l0.797-0.797\\r\\n\\t\\tc0.114-0.114,0.341-0.114,0.455,0L16.5,9.248l0,0l2.163-2.163c0.114-0.114,0.341-0.114,0.455,0l0.797,0.797\\r\\n\\t\\tc0.114,0.114,0.114,0.341,0,0.455L17.752,10.5z"}}]}],"title":"soundOff"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st0","d":"M13.593,6.537L13,7.851c0.593,0.478,0.949,1.313,0.949,2.149c0,0.955-0.237,1.791-0.949,2.269l0.593,1.075\\r\\n\\t\\tc0.949-0.836,1.542-2.03,1.542-3.463C15.136,8.687,14.542,7.373,13.593,6.537z M17.034,2l-0.831,1.075\\r\\n\\t\\tc1.542,1.91,2.61,4.299,2.61,6.925s-1.068,5.015-2.729,6.925L16.915,18C18.814,15.851,20,13.104,20,10S18.814,4.149,17.034,2z\\r\\n\\t\\t M15.254,4.269l-0.831,1.194c1.186,1.194,1.898,2.866,1.898,4.657s-0.712,3.463-2.017,4.657l0.831,1.075\\r\\n\\t\\tc1.424-1.552,2.373-3.463,2.373-5.731C17.627,7.731,16.678,5.701,15.254,4.269z"}},{"name":"path","attrs":{"class":"st0","d":"M10.757,2L5,6v8l5.757,4C11.125,18,12,18,12,17V3C12,2,11.163,2,10.757,2z M0,7.071v5.858\\r\\n\\t\\tC0,13.572,0.321,14,0.964,14H4V6H0.964C0.321,6,0,6.321,0,7.071z"}},{"name":"rect","attrs":{"class":"st1","width":"20","height":"20"}}]}],"title":"soundOn"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"path","attrs":{"class":"st0","d":"M13.156,3.895c-4.936,1.501-0.773-2.008-0.773-2.008S10.952,0.823,10,1.775\\r\\n\\tc-1.349,2.274,0.038,3.112-3.239,2.222c-4.581,0.444-6.016,3.3-6.016,7.085c0,4.089,3.218,7.404,9.254,7.536\\r\\n\\tc6.565,0.132,9.254-3.447,9.254-7.536C19.254,7.608,17.19,4.693,13.156,3.895z M11.957,5.899c0.661,0,4.072,1.269,4.072,4.125\\r\\n\\tc-1.269-0.317-2.803-0.397-3.94,0.106C11.454,10.024,11.296,5.899,11.957,5.899z M10.282,10.271c0.876,0,2.115,2.239,2.115,2.239\\r\\n\\tH8.096C8.096,12.51,9.406,10.271,10.282,10.271z M7.938,6.058c0.397,0.264,0.529,4.019,0,4.231c-2.01-0.529-2.538-0.106-3.913,0\\r\\n\\tC4.024,6.798,7.541,5.794,7.938,6.058z M10.317,16.881c-4.981,0-7.051-4.292-6.311-4.821s0.484,2.688,6.311,2.582\\r\\n\\tc5.192,0.106,5.429-3.605,5.852-2.759C16.593,12.73,14.452,16.776,10.317,16.881z"}},{"name":"rect","attrs":{"x":"0","y":"0","class":"st1","width":"20","height":"20"}}],"title":"specialAutumn"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"path","attrs":{"class":"st0","d":"M1.137,11.556c0-1.688,1.368-3.056,3.056-3.056c0.082,0,0.163,0.003,0.243,0.01\\r\\n\\tc-1.031-0.491-1.743-1.543-1.743-2.76c0-1.688,1.368-3.056,3.056-3.056c1.218,0,2.269,0.712,2.76,1.743\\r\\n\\tC8.503,4.356,8.5,4.275,8.5,4.193c0-1.688,1.368-3.056,3.056-3.056c1.688,0,3.056,1.368,3.056,3.056c0,0.644-0.199,1.242-0.54,1.735\\r\\n\\tc0.493-0.34,1.09-0.54,1.735-0.54c1.688,0,3.056,1.368,3.056,3.056c0,1.688-1.368,3.056-3.056,3.056\\r\\n\\tc-0.082,0-0.163-0.003-0.243-0.01c1.031,0.491,1.743,1.543,1.743,2.76c0,1.688-1.368,3.056-3.056,3.056\\r\\n\\tc-1.218,0-2.269-0.712-2.76-1.743c0.006,0.08,0.01,0.161,0.01,0.243c0,1.688-1.368,3.056-3.056,3.056\\r\\n\\tc-1.688,0-3.056-1.368-3.056-3.056c0-0.644,0.199-1.242,0.54-1.735c-0.493,0.34-1.09,0.54-1.735,0.54\\r\\n\\tC2.505,14.612,1.137,13.244,1.137,11.556z M7.996,10c0,1.107,0.897,2.004,2.004,2.004s2.004-0.897,2.004-2.004\\r\\n\\tS11.107,7.996,10,7.996S7.996,8.893,7.996,10z"}},{"name":"rect","attrs":{"x":"0","y":"0","class":"st1","width":"20","height":"20"}}],"title":"specialSpring"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st0","d":"M2.039,12.087c1.036,0.862,2.123,1.661,3.195,2.48c0.637,0.486,0.755,0.838,0.493,1.584\\r\\n\\t\\tc-0.017,0.046-0.032,0.093-0.045,0.139c-0.019,0.063-0.038,0.126-0.053,0.189c-0.126,0.547,0.06,0.886,0.609,1\\r\\n\\t\\tc0.603,0.126,1.601,0.194,2.448,0.231l1.33,1.33l1.331-1.331c0.841-0.037,1.821-0.105,2.416-0.23c0.549-0.114,0.734-0.454,0.609-1\\r\\n\\t\\tc-0.014-0.063-0.034-0.126-0.052-0.189c-0.014-0.046-0.03-0.093-0.046-0.139c-0.261-0.747-0.143-1.099,0.495-1.584\\r\\n\\t\\tc1.072-0.818,2.158-1.617,3.194-2.48c1.356-1.128,1.658-2.544,0.96-4.16c-0.488-1.129-1.343-2.264-2.323-3.009\\r\\n\\t\\tc-0.472-0.358-0.893-0.612-1.056-0.075c-0.453,1.49-2.364,6.023-2.584,5.923c-0.412-0.188,1.139-5.435,1.286-6.53\\r\\n\\t\\tc0.053-0.392-0.117-0.694-0.305-0.807c-0.275-0.165-1.764-0.647-2.532-0.748c-0.769-0.101-0.704,0.39-0.724,0.697\\r\\n\\t\\tc-0.12,1.824-0.67,7.315-0.969,7.388C9.563,10.802,9.128,6.2,9.002,3.507c-0.017-0.366,0-0.858-0.408-0.827\\r\\n\\t\\tC8.185,2.711,6.769,3.035,5.752,3.522C5.412,3.73,5.545,4.013,5.56,4.144c0.179,1.485,1.437,6.791,1.172,6.923\\r\\n\\t\\tc-0.138,0.069-1.622-3.32-2.641-6.092C3.964,4.625,3.46,4.866,3.234,5.051c-0.952,0.78-1.667,1.746-2.155,2.876\\r\\n\\t\\tC0.382,9.543,0.684,10.959,2.039,12.087z"}}]},{"name":"rect","attrs":{"x":"0","y":"0","class":"st1","width":"20","height":"20"}}],"title":"specialSummer"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"path","attrs":{"class":"st0","d":"M15.801,12.465l0.652-0.16L16.22,11.46l-1.967,0.532l-0.04-0.024c0.281-0.6,0.45-1.262,0.45-1.968\\r\\n\\tc0-0.674-0.149-1.31-0.406-1.888l0.049-0.029l1.967,0.532l0.234-0.844l-0.652-0.16l1.353-0.797l0.288-1.117l-1.096-0.301\\r\\n\\tl-1.374,0.809l0.175-0.676l-0.842-0.228l-0.527,1.986l-0.035,0.02c-0.756-1.064-1.947-1.779-3.313-1.922l-0.001-0.06l1.447-1.435\\r\\n\\tl-0.613-0.625L10.851,3.75l-0.012-1.586l-0.822-0.809L9.207,2.152L9.22,3.762L8.723,3.272L8.104,3.885l1.453,1.453l0,0.043\\r\\n\\tc-1.37,0.131-2.565,0.839-3.329,1.896l-0.05-0.029L5.663,5.277L4.814,5.494L4.999,6.14L3.617,5.388L2.505,5.693l0.283,1.1\\r\\n\\tl1.404,0.764L3.518,7.741l0.219,0.843l1.987-0.528l0.037,0.022C5.494,8.666,5.337,9.313,5.337,10c0,0.696,0.163,1.351,0.436,1.944\\r\\n\\tl-0.005,0.003l-1.987-0.528l-0.219,0.843l0.674,0.184L2.82,13.27l-0.283,1.1l1.112,0.305l1.394-0.812l-0.185,0.646l0.848,0.216\\r\\n\\tl0.516-1.971l0.022-0.012c0.765,1.046,1.952,1.747,3.313,1.877l0,0.039l-1.453,1.453l0.619,0.613l0.497-0.491l-0.012,1.615\\r\\n\\tl0.809,0.797l0.822-0.809l0.012-1.591l0.466,0.484l0.613-0.625l-1.447-1.435l0.001-0.055c1.334-0.139,2.497-0.828,3.255-1.851\\r\\n\\tl0.04,0.024l0.527,1.986l0.842-0.228l-0.176-0.676l1.394,0.797l1.096-0.301l-0.288-1.117L15.801,12.465z"}},{"name":"rect","attrs":{"x":"0","y":"0","class":"st1","width":"20","height":"20"}}],"title":"specialWinter"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{"id":"icf_x5F_star"},"childs":[{"name":"path","attrs":{"class":"st0","d":"M3.757,17.124c0.094-0.567,0.196-1.196,0.303-1.825c0.196-1.153,0.399-2.305,0.587-3.46\\r\\n\\t\\tc0.013-0.08-0.052-0.197-0.117-0.261c-0.882-0.87-1.77-1.732-2.656-2.598c-0.34-0.333-0.686-0.66-1.014-1.005\\r\\n\\t\\tC0.584,7.685,0.352,7.353,0.479,6.921c0.134-0.458,0.528-0.608,0.943-0.674c1.196-0.191,2.395-0.363,3.593-0.539\\r\\n\\t\\tc0.494-0.073,0.989-0.14,1.483-0.208c0.147-0.02,0.239-0.085,0.31-0.23c0.741-1.514,1.487-3.025,2.244-4.531\\r\\n\\t\\tC9.149,0.545,9.294,0.365,9.45,0.214c0.331-0.321,0.771-0.323,1.096,0.008c0.186,0.189,0.35,0.416,0.469,0.653\\r\\n\\t\\tc0.726,1.448,1.44,2.902,2.148,4.36c0.087,0.18,0.204,0.247,0.388,0.273c1.442,0.205,2.884,0.416,4.325,0.627\\r\\n\\t\\tc0.235,0.034,0.47,0.065,0.702,0.113c0.15,0.031,0.301,0.079,0.441,0.143c0.509,0.234,0.69,0.698,0.398,1.172\\r\\n\\t\\tc-0.203,0.329-0.487,0.615-0.765,0.89c-1.055,1.044-2.121,2.077-3.187,3.11c-0.109,0.105-0.148,0.197-0.119,0.36\\r\\n\\t\\tc0.288,1.619,0.565,3.239,0.835,4.861c0.035,0.207,0.039,0.426,0.019,0.635c-0.058,0.621-0.501,0.928-1.105,0.761\\r\\n\\t\\tc-0.234-0.065-0.462-0.166-0.678-0.279c-1.385-0.723-2.769-1.45-4.147-2.188c-0.205-0.11-0.358-0.103-0.56,0.005\\r\\n\\t\\tc-1.429,0.762-2.864,1.515-4.303,2.259c-0.214,0.111-0.456,0.199-0.693,0.226c-0.549,0.062-0.867-0.22-0.929-0.769\\r\\n\\t\\tC3.777,17.354,3.771,17.273,3.757,17.124z"}},{"name":"rect","attrs":{"class":"st1","width":"20","height":"20"}}]}],"title":"star"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"rect","attrs":{"class":"st0","width":"20","height":"20"}},{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st1","d":"M9,11.499c0-2.486-2.015-4.501-4.501-4.501C2.013,6.998,0,9.013,0,11.499S2.013,16,4.499,16\\r\\n\\t\\tC6.984,16,9,13.985,9,11.499z M3.073,13.983c-0.021-0.015-0.04-0.04-0.057-0.075c-0.017-0.035-0.03-0.082-0.039-0.142\\r\\n\\t\\tc-0.009-0.059-0.014-0.214-0.014-0.299c0-0.089,0.004-0.162,0.011-0.222c0.008-0.06,0.02-0.107,0.037-0.144\\r\\n\\t\\tc0.017-0.037,0.036-0.063,0.057-0.08c0.021-0.017,0.046-0.025,0.073-0.025h0.747v-2.975l-0.95,0.525\\r\\n\\t\\tc-0.07,0.034-0.127,0.054-0.171,0.062c-0.044,0.008-0.079-0.001-0.105-0.027c-0.026-0.026-0.044-0.071-0.053-0.135\\r\\n\\t\\tc-0.009-0.064-0.013-0.154-0.013-0.269c0-0.073,0.001-0.133,0.004-0.181C2.603,9.95,2.611,9.91,2.623,9.876\\r\\n\\t\\tc0.012-0.033,0.029-0.061,0.05-0.082S2.724,9.75,2.76,9.726l1.27-0.822c0.015-0.012,0.034-0.022,0.057-0.03\\r\\n\\t\\tC4.11,8.866,4.139,8.86,4.176,8.856C4.213,8.851,4.26,8.848,4.32,8.846c0.059-0.001,0.136-0.002,0.231-0.002\\r\\n\\t\\tc0.115,0,0.209,0.002,0.281,0.007c0.072,0.005,0.126,0.012,0.162,0.023C5.03,8.885,5.054,8.899,5.067,8.917\\r\\n\\t\\tc0.012,0.018,0.018,0.041,0.018,0.069v4.011h0.723c0.027,0,0.052,0.008,0.075,0.025c0.023,0.017,0.043,0.043,0.059,0.08\\r\\n\\t\\tc0.017,0.036,0.029,0.084,0.036,0.144c0.008,0.059,0.012,0.133,0.012,0.222c0,0.085-0.005,0.24-0.014,0.299\\r\\n\\t\\tc-0.009,0.059-0.022,0.107-0.039,0.142c-0.017,0.035-0.036,0.06-0.057,0.075c-0.021,0.016-0.046,0.023-0.073,0.023H3.141\\r\\n\\t\\tC3.117,14.006,3.094,13.999,3.073,13.983z"}},{"name":"path","attrs":{"class":"st1","d":"M19.996,4.047c-0.001-0.742-0.328-1.322-0.951-1.727c-0.318-0.206-0.672-0.301-1.05-0.304\\r\\n\\t\\tc-0.07,0-0.436,0-0.995,0.001V3.5C17,4.325,16.325,5,15.5,5S14,4.325,14,3.5V2.022c-1.626,0.003-3.475,0.005-5,0.005V3.5\\r\\n\\t\\tC9,4.325,8.325,5,7.5,5S6,4.325,6,3.5V2.02C5.911,2.019,5.862,2.017,5.862,2.016c-0.024,0-1.412,0.003-1.828,0.002\\r\\n\\t\\tC3.024,2.013,1.999,3,2.009,3.824c0,0.016,0,1.636,0,2.243c0.673-0.279,1.412-0.433,2.187-0.433c1.447,0,3.241,0.474,4.247,1.361\\r\\n\\t\\tc3.342,0,9.561,0.001,9.561,0.001L18,17.002c0,0-15.298-0.007-15.998-0.002c0,0.994,1.016,1.981,1.998,1.981\\r\\n\\t\\tc0.214,0,9.545,0.01,13.98,0.01c0.97,0,1.793-0.664,1.979-1.616c0.026-0.134,0.037-0.273,0.037-0.409\\r\\n\\t\\tC19.998,12.99,19.999,8.022,19.996,4.047z"}},{"name":"path","attrs":{"class":"st1","d":"M7.495,4c0.443,0,0.805-0.362,0.805-0.805V0.805C8.299,0.362,7.937,0,7.495,0S6.69,0.362,6.69,0.805v2.391\\r\\n\\t\\tC6.69,3.638,7.052,4,7.495,4z"}},{"name":"path","attrs":{"class":"st1","d":"M15.495,4c0.443,0,0.805-0.362,0.805-0.805V0.805C16.299,0.362,15.937,0,15.495,0S14.69,0.362,14.69,0.805\\r\\n\\t\\tv2.391C14.69,3.638,15.052,4,15.495,4z"}}]}],"title":"subscription"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{},"childs":[{"name":"rect","attrs":{"class":"st0","width":"20","height":"20"}},{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st1","d":"M17.833,4H2.167C1.522,4,1,3.478,1,2.833V2.167C1,1.522,1.522,1,2.167,1h15.667C18.478,1,19,1.522,19,2.167\\r\\n\\t\\t\\tv0.667C19,3.478,18.478,4,17.833,4z"}},{"name":"path","attrs":{"class":"st1","d":"M17.833,9H2.167C1.522,9,1,8.478,1,7.833V7.167C1,6.522,1.522,6,2.167,6h15.667C18.478,6,19,6.522,19,7.167\\r\\n\\t\\t\\tv0.667C19,8.478,18.478,9,17.833,9z"}},{"name":"path","attrs":{"class":"st1","d":"M17.833,14H2.167C1.522,14,1,13.478,1,12.833v-0.667C1,11.522,1.522,11,2.167,11h15.667\\r\\n\\t\\t\\tC18.478,11,19,11.522,19,12.167v0.667C19,13.478,18.478,14,17.833,14z"}},{"name":"path","attrs":{"class":"st1","d":"M17.833,19H2.167C1.522,19,1,18.478,1,17.833v-0.667C1,16.522,1.522,16,2.167,16h15.667\\r\\n\\t\\t\\tC18.478,16,19,16.522,19,17.167v0.667C19,18.478,18.478,19,17.833,19z"}}]}]}],"title":"table"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{"id":"icf_x5F_themeChange_1_"},"childs":[{"name":"rect","attrs":{"class":"st0","width":"20","height":"20"}},{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st1","d":"M14.494,6c-0.824,0-1.493,0.668-1.493,1.493s0.668,1.493,1.493,1.493c0.824,0,1.493-0.668,1.493-1.493\\r\\n\\t\\t\\tS15.318,6,14.494,6z"}},{"name":"path","attrs":{"class":"st1","d":"M16.442,2H3.558C1.593,2,0,3.593,0,5.558v8.884C0,16.407,1.593,18,3.558,18h12.884\\r\\n\\t\\t\\tC18.407,18,20,16.407,20,14.442V5.558C20,3.593,18.407,2,16.442,2z M18,14.442c0,0.474-0.218,0.895-0.553,1.181L14.29,10.91\\r\\n\\t\\t\\tl-2.467,2.965L7.555,7.357l-5.17,8.099C2.148,15.183,2,14.831,2,14.442V5.558C2,4.699,2.699,4,3.558,4h12.884\\r\\n\\t\\t\\tC17.301,4,18,4.699,18,5.558V14.442z"}}]}]}],"title":"themeChange"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{},"childs":[{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st0","d":"M10,1.673c-4.603,0-8.334,3.731-8.334,8.334S5.397,18.341,10,18.341c4.603,0,8.334-3.731,8.334-8.334\\r\\n\\t\\t\\tS14.603,1.673,10,1.673z M13.818,12.941c-0.235,0.383-0.741,0.503-1.124,0.268l-3.556-2.247H9.1V9.805V6.717V6.534\\r\\n\\t\\t\\tc0-0.449,0.368-0.817,0.817-0.817c0.449,0,0.817,0.368,0.817,0.817v3.271h-0.007v0.283l0.031,0.019l0.006-0.003l2.786,1.714\\r\\n\\t\\t\\tC13.933,12.053,14.054,12.558,13.818,12.941z"}}]},{"name":"rect","attrs":{"class":"st1","width":"20","height":"20"}}]}],"title":"timing"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{},"childs":[{"name":"g","attrs":{},"childs":[{"name":"rect","attrs":{"x":"0","y":"0","class":"st0","width":"20","height":"20"}},{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st1","d":"M20,12V2c0-0.957-1.091-2-2-2L4,0C3.091,0,2,1.043,2,2v4H1C0.441,6,0,6.395,0,7l0,12c0,0.605,0.552,1,1,1h8\\r\\n\\t\\t\\t\\tc0.559,0,1-0.516,1-1v-2h5v-1c0,0-1.091-0.043-2-1c-0.115-0.122,0-1,0-1h5C19,14,20,13,20,12L20,12z M4.573,19.849\\r\\n\\t\\t\\t\\tc-0.336,0-0.559-0.242-0.559-0.605c0-0.363,0.224-0.605,0.559-0.605s0.559,0.242,0.559,0.605S4.909,19.849,4.573,19.849z M10,12\\r\\n\\t\\t\\t\\tc0-0.363,0-1.637,0-2H8v8H2V8h4V6H4V2h14v10H10z"}}]}]},{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st1","d":"M14.443,6.978L14.443,6.978l-2.622-2.622c-0.421-0.421-1.17-0.14-1.124,0.468l0,1.217L7,5.995l0,2.902\\r\\n\\t\\t\\tl3.698,0.047l0,1.03c0,0.187,0.094,0.375,0.187,0.468c0.234,0.234,0.655,0.281,0.936,0l2.622-2.528\\r\\n\\t\\t\\tC14.724,7.634,14.724,7.259,14.443,6.978z"}}]}]}],"title":"toDesktop"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{},"childs":[{"name":"g","attrs":{},"childs":[{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st0","d":"M0,12c0,1,1,2,2,2h5c0,0,0.115,0.878,0,1c-0.909,0.957-2,1-2,1v1h5v2c0,0.484,0.441,1,1,1h8\\r\\n\\t\\t\\t\\tc0.448,0,1-0.395,1-1V7c0-0.605-0.441-1-1-1h-1V2c0-0.957-1.091-2-2-2H2C1.091,0,0,1.043,0,2V12L0,12z M14.867,19.244\\r\\n\\t\\t\\t\\tc0-0.363,0.224-0.605,0.559-0.605s0.559,0.242,0.559,0.605c0,0.363-0.224,0.605-0.559,0.605S14.867,19.607,14.867,19.244z M2,12\\r\\n\\t\\t\\t\\tV2h14v4h-2l1,2h3v10h-6v-7h-2c0,0.363,0,0.637,0,1H2z"}}]},{"name":"rect","attrs":{"x":"0","y":"0","class":"st1","width":"20","height":"20"}}]},{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st0","d":"M12.886,6.907L12.886,6.907l-2.622-2.622c-0.421-0.421-1.17-0.14-1.124,0.468l0,1.217L5.443,5.924l0,2.902\\r\\n\\t\\t\\tl3.698,0.047l0,1.03c0,0.187,0.094,0.375,0.187,0.468c0.234,0.234,0.655,0.281,0.936,0l2.622-2.528\\r\\n\\t\\t\\tC13.167,7.562,13.167,7.188,12.886,6.907z"}}]},{"name":"rect","attrs":{"class":"st1","width":"20","height":"20"}}]}],"title":"toTablet"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"rect","attrs":{"class":"st0","width":"20","height":"20"}},{"name":"g","attrs":{"id":"icf_x5F_visitingCard_1_"},"childs":[{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st1","d":"M9,1H3.071C1.927,1,1,1.927,1,3.071V9h8V1z"}},{"name":"path","attrs":{"class":"st1","d":"M16.929,1H11v8h8V3.071C19,1.927,18.073,1,16.929,1z"}},{"name":"path","attrs":{"class":"st1","d":"M11,19h5.929C18.073,19,19,18.073,19,16.929V11h-8V19z"}},{"name":"path","attrs":{"class":"st1","d":"M1,11v5.929C1,18.073,1.927,19,3.071,19H9v-8H1z"}}]}]}],"title":"visitingCard"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{},"childs":[{"name":"path","attrs":{"class":"st0","d":"M10,1c1.1,0,2,0.899,2,1.999l0,8.002C12,12.101,11.1,13,10,13c-1.1,0-2-0.899-2-1.999l0-8.002\\r\\n\\t\\tC8,1.899,8.9,1,10,1"}},{"name":"circle","attrs":{"class":"st0","cx":"10","cy":"17","r":"2"}}]},{"name":"rect","attrs":{"x":"0","y":"0","class":"st1","width":"20","height":"20"}}],"title":"warning"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{"id":"icf_x5F_winnerbypoint"},"childs":[{"name":"path","attrs":{"class":"st0","d":"M14.776,6.159L18.419,0h-1.658l-3.581,6h-0.84l-1.329-2.119L13.361,0h-1.666l-1.529,2.542L8.592,0H6.913\\r\\n\\t\\tl3.748,6H7.18L3.6,0H1.942l3.639,6.151c-2.79,0.5-4.926,2.947-4.926,5.875C0.654,15.312,3.343,18,6.629,18h7.051\\r\\n\\t\\tc3.286,0,5.975-2.688,5.975-5.974C19.654,9.115,17.543,6.678,14.776,6.159z M6,16H4v-4.572c0,0.353-1.068,0.625-1.638,0.813\\r\\n\\t\\tL2,12.328v-1.687l0.355-0.046c0.339-0.11,0.826-0.328,1.234-0.646C3.984,9.642,4.312,9.41,4.457,9.005L4.559,9H6V16z M13,15v1\\r\\n\\t\\tH7.315l0.024,0.005c0.056-0.517,0.225-0.899,0.503-1.361c0.279-0.46,0.803-0.988,1.604-1.732c0.618-0.575,0.997-0.937,1.128-1.129\\r\\n\\t\\tc0.168-0.252,0.254-0.488,0.254-0.728c0-0.258-0.063-0.439-0.192-0.568c-0.13-0.13-0.31-0.189-0.551-0.189\\r\\n\\t\\tc-0.237,0-0.418,0.068-0.553,0.205c-0.136,0.139-0.217,0.392-0.24,0.747l-0.014,0.207L7.48,11.277l0.022-0.2\\r\\n\\t\\tc0.088-0.821,0.377-1.423,0.857-1.79c0.471-0.36,1.063-0.543,1.761-0.543c0.768,0,1.384,0.214,1.831,0.635\\r\\n\\t\\tc0.449,0.426,0.678,0.962,0.678,1.591c0,0.349-0.064,0.688-0.189,1.009c-0.126,0.313-0.323,0.644-0.589,0.981\\r\\n\\t\\tc-0.174,0.223-0.479,0.534-0.935,0.952c-0.433,0.397-0.708,0.782-0.824,0.912C10.076,14.842,10.061,15,10.045,15H13z\\r\\n\\t\\t M18.112,15.846c-0.503,0.485-1.137,0.731-1.882,0.731c-0.706,0-1.302-0.208-1.77-0.618c-0.472-0.412-0.748-0.956-0.822-1.616\\r\\n\\t\\tl-0.021-0.197l1.745-0.211l0.024,0.198c0.038,0.3,0.132,0.52,0.288,0.671c0.151,0.146,0.33,0.216,0.546,0.216\\r\\n\\t\\tc0.23,0,0.42-0.085,0.579-0.261c0.164-0.183,0.243-0.429,0.243-0.751c0-0.302-0.075-0.53-0.229-0.698\\r\\n\\t\\tc-0.15-0.164-0.329-0.243-0.544-0.243c-0.16,0-0.357,0.032-0.585,0.097l-0.294,0.083l0.219-1.616c0,0,0.183,0.004,0.185,0.004\\r\\n\\t\\tc0.349,0,0.573-0.066,0.723-0.196c0.154-0.135,0.229-0.313,0.229-0.542c0-0.192-0.052-0.338-0.159-0.446\\r\\n\\t\\tc-0.108-0.106-0.252-0.159-0.439-0.159c-0.185,0-0.339,0.063-0.472,0.192c-0.134,0.132-0.218,0.335-0.249,0.604l-0.023,0.21\\r\\n\\t\\tl-1.698-0.287l0.041-0.203c0.096-0.467,0.242-0.846,0.437-1.129c0.199-0.292,0.48-0.523,0.834-0.688\\r\\n\\t\\tc0.349-0.162,0.742-0.245,1.17-0.245c0.738,0,1.342,0.241,1.794,0.717c0.376,0.395,0.566,0.849,0.566,1.35\\r\\n\\t\\tc0,0.589-0.264,1.082-0.783,1.471c0.272,0.122,0.504,0.301,0.692,0.534c0.277,0.347,0.419,0.768,0.419,1.252\\r\\n\\t\\tC18.874,14.761,18.617,15.359,18.112,15.846z"}},{"name":"rect","attrs":{"class":"st1","width":"20","height":"20"}}]}],"title":"winnerByPoint"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"g","attrs":{"id":"icf_x5F_winnertakesall"},"childs":[{"name":"path","attrs":{"class":"st0","d":"M14.244,8.039L19,0h-1.746l-4.201,7.101l-1.851-2.989L13.676,0h-1.754l-1.61,2.676L8.655,0H6.887l4.056,6.55\\r\\n\\t\\tc-0.265-0.034-0.533-0.058-0.808-0.058c-0.916,0-1.783,0.202-2.567,0.555L3.4,0H1.654l4.629,7.825\\r\\n\\t\\tc-1.46,1.145-2.402,2.921-2.402,4.92c0,3.454,2.8,6.254,6.254,6.254c3.454,0,6.254-2.8,6.254-6.254\\r\\n\\t\\tC16.39,10.867,15.557,9.185,14.244,8.039z M11.516,17h-2v-5.792c-1,0.405-1.093,0.719-1.742,0.933l-0.258,0.087v-1.834\\r\\n\\t\\tl-0.032-0.045c0.382-0.124,0.709-0.368,1.165-0.723c0.443-0.345,0.866-0.894,0.866-1.35V8h2V17z"}},{"name":"rect","attrs":{"class":"st1","width":"20","height":"20"}}]}],"title":"winnerTakesAll"},{"name":"svg","attrs":{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","style":"enable-background:new 0 0 20 20;","xmlSpace":"preserve"},"childs":[{"name":"path","attrs":{"class":"st0","d":"M16,2C12,2,8,2,4,2S0,4,0,5s0,0,0,1c0,2,9,9,9,9v1l-4,3h10l-4-3v-1c0,0,9-7,9-9c0-1,0,0,0-1S20,2,16,2z M4,9\\r\\n\\tc0,0-3-2-3-3s0,0,0-1c0-2,3-2,3-2V9z M19,6c0,1-3,3-3,3V3c0,0,3,0,3,2C19,6,19,5,19,6z"}},{"name":"rect","attrs":{"x":"0","y":"0","class":"st1","width":"20","height":"20"}}],"title":"winnings"}]');
;// CONCATENATED MODULE: ./src/util.ts






/**
 * Get an icon from the icons.json
 * @param name
 * @returns {*}
 */
function getIcon(name) {
  return icons_namespaceObject.find(function (child) {
    return child.title === name ? child : undefined;
  });
}
function createIconElement(elem) {
  var node = document.createElement(elem.name);
  Object.keys(elem.attrs).forEach(function (attrName) {
    if (attrName !== 'style' && elem.name !== 'rect') {
      node.setAttribute(attrName, elem.attrs[attrName]);
    }
  });
  if (elem.childs) {
    elem.childs.forEach(function (c) {
      //  if (c.name !== 'rect')
      node.appendChild(createIconElement(c));
    });
  }
  return node;
}

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/ColoredIcon.vue?vue&type=script&lang=ts






// TODO can be removed as we don't support IE11 anymore ?
// required to make innerHTML work for svg foooor.... dim dim dim tateratataaaaaa....: IE11


/* harmony default export */ var ColoredIconvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.defineComponent)({
  name: 'colored-icon',
  props: {
    name: {
      required: true,
      type: String
    },
    color: {
      default: 'darkGrey',
      required: false,
      type: String
    },
    opaque: {
      required: false,
      default: false,
      type: Boolean
    }
  },
  data: function data() {
    return {
      config: icon_config_namespaceObject,
      idPostFix: this._uid
    };
  },
  computed: {
    getOpaque: function getOpaque() {
      // enable it with: opaque & opaque="true" & :opaque="true"
      return this.$props.opaque === '' || this.$props.opaque === true || this.$props.opaque === 'true';
    },
    render: function render() {
      return createIconElement(getIcon(this.$props.name)).innerHTML;
    },
    classes: function classes() {
      var _this = this;
      var c = [];
      Object.keys(this.$attrs).forEach(function (key) {
        if (_this.$attrs[key] !== undefined) {
          c.push('colored-icon--' + key.toLowerCase());
        }
      });
      return c;
    }
  }
}));
;// CONCATENATED MODULE: ./src/ColoredIcon.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-32.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-32.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-32.use[2]!./node_modules/less-loader/dist/cjs.js??clonedRuleSet-32.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/ColoredIcon.vue?vue&type=style&index=0&id=e2d8f7e6&scoped=true&lang=less
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/ColoredIcon.vue?vue&type=style&index=0&id=e2d8f7e6&scoped=true&lang=less

// EXTERNAL MODULE: ./node_modules/vue-loader/dist/exportHelper.js
var exportHelper = __nested_webpack_require_70918__(3744);
;// CONCATENATED MODULE: ./src/ColoredIcon.vue




;


const __exports__ = /*#__PURE__*/(0,exportHelper/* default */.Z)(ColoredIconvue_type_script_lang_ts, [['render',render],['__scopeId',"data-v-e2d8f7e6"]])

/* harmony default export */ var ColoredIcon = (__exports__);
;// CONCATENATED MODULE: ./src/main.ts

/**
 * Exports the Vue components for the commonjs export
 */
/* harmony default export */ var main = ({
  ColoredIcon: ColoredIcon
});

;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = (main);


}();
module.exports = __nested_webpack_exports__;
/******/ })()
;
//# sourceMappingURL=colored-icons.common.js.map

/***/ }),

/***/ 9662:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isCallable = __webpack_require__(614);
var tryToString = __webpack_require__(6330);

var $TypeError = TypeError;

// `Assert: IsCallable(argument) is true`
module.exports = function (argument) {
  if (isCallable(argument)) return argument;
  throw $TypeError(tryToString(argument) + ' is not a function');
};


/***/ }),

/***/ 9670:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isObject = __webpack_require__(111);

var $String = String;
var $TypeError = TypeError;

// `Assert: Type(argument) is Object`
module.exports = function (argument) {
  if (isObject(argument)) return argument;
  throw $TypeError($String(argument) + ' is not an object');
};


/***/ }),

/***/ 8533:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $forEach = (__webpack_require__(2092).forEach);
var arrayMethodIsStrict = __webpack_require__(9341);

var STRICT_METHOD = arrayMethodIsStrict('forEach');

// `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach
module.exports = !STRICT_METHOD ? function forEach(callbackfn /* , thisArg */) {
  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
} : [].forEach;


/***/ }),

/***/ 1318:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var toIndexedObject = __webpack_require__(5656);
var toAbsoluteIndex = __webpack_require__(1400);
var lengthOfArrayLike = __webpack_require__(6244);

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = lengthOfArrayLike(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),

/***/ 2092:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var bind = __webpack_require__(9974);
var uncurryThis = __webpack_require__(1702);
var IndexedObject = __webpack_require__(8361);
var toObject = __webpack_require__(7908);
var lengthOfArrayLike = __webpack_require__(6244);
var arraySpeciesCreate = __webpack_require__(5417);

var push = uncurryThis([].push);

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var createMethod = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var IS_FILTER_REJECT = TYPE == 7;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var boundFunction = bind(callbackfn, that);
    var length = lengthOfArrayLike(self);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push(target, value);      // filter
        } else switch (TYPE) {
          case 4: return false;             // every
          case 7: push(target, value);      // filterReject
        }
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

module.exports = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod(6),
  // `Array.prototype.filterReject` method
  // https://github.com/tc39/proposal-array-filtering
  filterReject: createMethod(7)
};


/***/ }),

/***/ 9341:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var fails = __webpack_require__(7293);

module.exports = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call -- required for testing
    method.call(null, argument || function () { return 1; }, 1);
  });
};


/***/ }),

/***/ 3658:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var DESCRIPTORS = __webpack_require__(9781);
var isArray = __webpack_require__(3157);

var $TypeError = TypeError;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Safari < 13 does not throw an error in this case
var SILENT_ON_NON_WRITABLE_LENGTH_SET = DESCRIPTORS && !function () {
  // makes no sense without proper strict mode support
  if (this !== undefined) return true;
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', { writable: false }).length = 1;
  } catch (error) {
    return error instanceof TypeError;
  }
}();

module.exports = SILENT_ON_NON_WRITABLE_LENGTH_SET ? function (O, length) {
  if (isArray(O) && !getOwnPropertyDescriptor(O, 'length').writable) {
    throw $TypeError('Cannot set read only .length');
  } return O.length = length;
} : function (O, length) {
  return O.length = length;
};


/***/ }),

/***/ 206:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var uncurryThis = __webpack_require__(1702);

module.exports = uncurryThis([].slice);


/***/ }),

/***/ 7475:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isArray = __webpack_require__(3157);
var isConstructor = __webpack_require__(4411);
var isObject = __webpack_require__(111);
var wellKnownSymbol = __webpack_require__(5112);

var SPECIES = wellKnownSymbol('species');
var $Array = Array;

// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (isConstructor(C) && (C === $Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? $Array : C;
};


/***/ }),

/***/ 5417:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var arraySpeciesConstructor = __webpack_require__(7475);

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray, length) {
  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};


/***/ }),

/***/ 4326:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var uncurryThis = __webpack_require__(1702);

var toString = uncurryThis({}.toString);
var stringSlice = uncurryThis(''.slice);

module.exports = function (it) {
  return stringSlice(toString(it), 8, -1);
};


/***/ }),

/***/ 648:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var TO_STRING_TAG_SUPPORT = __webpack_require__(1694);
var isCallable = __webpack_require__(614);
var classofRaw = __webpack_require__(4326);
var wellKnownSymbol = __webpack_require__(5112);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var $Object = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && isCallable(O.callee) ? 'Arguments' : result;
};


/***/ }),

/***/ 9920:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var hasOwn = __webpack_require__(2597);
var ownKeys = __webpack_require__(3887);
var getOwnPropertyDescriptorModule = __webpack_require__(1236);
var definePropertyModule = __webpack_require__(3070);

module.exports = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};


/***/ }),

/***/ 8880:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var DESCRIPTORS = __webpack_require__(9781);
var definePropertyModule = __webpack_require__(3070);
var createPropertyDescriptor = __webpack_require__(9114);

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ 9114:
/***/ ((module) => {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ 8052:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isCallable = __webpack_require__(614);
var definePropertyModule = __webpack_require__(3070);
var makeBuiltIn = __webpack_require__(6339);
var defineGlobalProperty = __webpack_require__(3072);

module.exports = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable(value)) makeBuiltIn(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else definePropertyModule.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};


/***/ }),

/***/ 3072:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var global = __webpack_require__(7854);

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;

module.exports = function (key, value) {
  try {
    defineProperty(global, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),

/***/ 9781:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var fails = __webpack_require__(7293);

// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});


/***/ }),

/***/ 4154:
/***/ ((module) => {

var documentAll = typeof document == 'object' && document.all;

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var IS_HTMLDDA = typeof documentAll == 'undefined' && documentAll !== undefined;

module.exports = {
  all: documentAll,
  IS_HTMLDDA: IS_HTMLDDA
};


/***/ }),

/***/ 317:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var global = __webpack_require__(7854);
var isObject = __webpack_require__(111);

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),

/***/ 7207:
/***/ ((module) => {

var $TypeError = TypeError;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991

module.exports = function (it) {
  if (it > MAX_SAFE_INTEGER) throw $TypeError('Maximum allowed index exceeded');
  return it;
};


/***/ }),

/***/ 8324:
/***/ ((module) => {

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};


/***/ }),

/***/ 8509:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = __webpack_require__(317);

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype = classList && classList.constructor && classList.constructor.prototype;

module.exports = DOMTokenListPrototype === Object.prototype ? undefined : DOMTokenListPrototype;


/***/ }),

/***/ 9363:
/***/ ((module) => {

/* global Bun -- Deno case */
module.exports = typeof Bun == 'function' && Bun && typeof Bun.version == 'string';


/***/ }),

/***/ 8113:
/***/ ((module) => {

module.exports = typeof navigator != 'undefined' && String(navigator.userAgent) || '';


/***/ }),

/***/ 7392:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var global = __webpack_require__(7854);
var userAgent = __webpack_require__(8113);

var process = global.process;
var Deno = global.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

module.exports = version;


/***/ }),

/***/ 748:
/***/ ((module) => {

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),

/***/ 2109:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var global = __webpack_require__(7854);
var getOwnPropertyDescriptor = (__webpack_require__(1236).f);
var createNonEnumerableProperty = __webpack_require__(8880);
var defineBuiltIn = __webpack_require__(8052);
var defineGlobalProperty = __webpack_require__(3072);
var copyConstructorProperties = __webpack_require__(9920);
var isForced = __webpack_require__(4705);

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    defineBuiltIn(target, key, sourceProperty, options);
  }
};


/***/ }),

/***/ 7293:
/***/ ((module) => {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),

/***/ 2104:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var NATIVE_BIND = __webpack_require__(4374);

var FunctionPrototype = Function.prototype;
var apply = FunctionPrototype.apply;
var call = FunctionPrototype.call;

// eslint-disable-next-line es/no-reflect -- safe
module.exports = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND ? call.bind(apply) : function () {
  return call.apply(apply, arguments);
});


/***/ }),

/***/ 9974:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var uncurryThis = __webpack_require__(1470);
var aCallable = __webpack_require__(9662);
var NATIVE_BIND = __webpack_require__(4374);

var bind = uncurryThis(uncurryThis.bind);

// optional / simple context binding
module.exports = function (fn, that) {
  aCallable(fn);
  return that === undefined ? fn : NATIVE_BIND ? bind(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ 4374:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var fails = __webpack_require__(7293);

module.exports = !fails(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});


/***/ }),

/***/ 6916:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var NATIVE_BIND = __webpack_require__(4374);

var call = Function.prototype.call;

module.exports = NATIVE_BIND ? call.bind(call) : function () {
  return call.apply(call, arguments);
};


/***/ }),

/***/ 6530:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var DESCRIPTORS = __webpack_require__(9781);
var hasOwn = __webpack_require__(2597);

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS || (DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable));

module.exports = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};


/***/ }),

/***/ 1470:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var classofRaw = __webpack_require__(4326);
var uncurryThis = __webpack_require__(1702);

module.exports = function (fn) {
  // Nashorn bug:
  //   https://github.com/zloirock/core-js/issues/1128
  //   https://github.com/zloirock/core-js/issues/1130
  if (classofRaw(fn) === 'Function') return uncurryThis(fn);
};


/***/ }),

/***/ 1702:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var NATIVE_BIND = __webpack_require__(4374);

var FunctionPrototype = Function.prototype;
var call = FunctionPrototype.call;
var uncurryThisWithBind = NATIVE_BIND && FunctionPrototype.bind.bind(call, call);

module.exports = NATIVE_BIND ? uncurryThisWithBind : function (fn) {
  return function () {
    return call.apply(fn, arguments);
  };
};


/***/ }),

/***/ 5005:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var global = __webpack_require__(7854);
var isCallable = __webpack_require__(614);

var aFunction = function (argument) {
  return isCallable(argument) ? argument : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global[namespace]) : global[namespace] && global[namespace][method];
};


/***/ }),

/***/ 8173:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var aCallable = __webpack_require__(9662);
var isNullOrUndefined = __webpack_require__(8554);

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function (V, P) {
  var func = V[P];
  return isNullOrUndefined(func) ? undefined : aCallable(func);
};


/***/ }),

/***/ 7854:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof __webpack_require__.g == 'object' && __webpack_require__.g) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || this || Function('return this')();


/***/ }),

/***/ 2597:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var uncurryThis = __webpack_require__(1702);
var toObject = __webpack_require__(7908);

var hasOwnProperty = uncurryThis({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
module.exports = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject(it), key);
};


/***/ }),

/***/ 3501:
/***/ ((module) => {

module.exports = {};


/***/ }),

/***/ 4664:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var DESCRIPTORS = __webpack_require__(9781);
var fails = __webpack_require__(7293);
var createElement = __webpack_require__(317);

// Thanks to IE8 for its funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


/***/ }),

/***/ 8361:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var uncurryThis = __webpack_require__(1702);
var fails = __webpack_require__(7293);
var classof = __webpack_require__(4326);

var $Object = Object;
var split = uncurryThis(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split(it, '') : $Object(it);
} : $Object;


/***/ }),

/***/ 2788:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var uncurryThis = __webpack_require__(1702);
var isCallable = __webpack_require__(614);
var store = __webpack_require__(5465);

var functionToString = uncurryThis(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable(store.inspectSource)) {
  store.inspectSource = function (it) {
    return functionToString(it);
  };
}

module.exports = store.inspectSource;


/***/ }),

/***/ 9909:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var NATIVE_WEAK_MAP = __webpack_require__(4811);
var global = __webpack_require__(7854);
var isObject = __webpack_require__(111);
var createNonEnumerableProperty = __webpack_require__(8880);
var hasOwn = __webpack_require__(2597);
var shared = __webpack_require__(5465);
var sharedKey = __webpack_require__(6200);
var hiddenKeys = __webpack_require__(3501);

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError = global.TypeError;
var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  /* eslint-disable no-self-assign -- prototype methods protection */
  store.get = store.get;
  store.has = store.has;
  store.set = store.set;
  /* eslint-enable no-self-assign -- prototype methods protection */
  set = function (it, metadata) {
    if (store.has(it)) throw TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store.set(it, metadata);
    return metadata;
  };
  get = function (it) {
    return store.get(it) || {};
  };
  has = function (it) {
    return store.has(it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn(it, STATE)) throw TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),

/***/ 3157:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var classof = __webpack_require__(4326);

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
module.exports = Array.isArray || function isArray(argument) {
  return classof(argument) == 'Array';
};


/***/ }),

/***/ 614:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var $documentAll = __webpack_require__(4154);

var documentAll = $documentAll.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
module.exports = $documentAll.IS_HTMLDDA ? function (argument) {
  return typeof argument == 'function' || argument === documentAll;
} : function (argument) {
  return typeof argument == 'function';
};


/***/ }),

/***/ 4411:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var uncurryThis = __webpack_require__(1702);
var fails = __webpack_require__(7293);
var isCallable = __webpack_require__(614);
var classof = __webpack_require__(648);
var getBuiltIn = __webpack_require__(5005);
var inspectSource = __webpack_require__(2788);

var noop = function () { /* empty */ };
var empty = [];
var construct = getBuiltIn('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec = uncurryThis(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.exec(noop);

var isConstructorModern = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  try {
    construct(noop, empty, argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  switch (classof(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
  }
  try {
    // we can't check .prototype since constructors produced by .bind haven't it
    // `Function#toString` throws on some built-it function in some legacy engines
    // (for example, `DOMQuad` and similar in FF41-)
    return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource(argument));
  } catch (error) {
    return true;
  }
};

isConstructorLegacy.sham = true;

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
module.exports = !construct || fails(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;


/***/ }),

/***/ 4705:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var fails = __webpack_require__(7293);
var isCallable = __webpack_require__(614);

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable(detection) ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),

/***/ 8554:
/***/ ((module) => {

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
module.exports = function (it) {
  return it === null || it === undefined;
};


/***/ }),

/***/ 111:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isCallable = __webpack_require__(614);
var $documentAll = __webpack_require__(4154);

var documentAll = $documentAll.all;

module.exports = $documentAll.IS_HTMLDDA ? function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it) || it === documentAll;
} : function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it);
};


/***/ }),

/***/ 1913:
/***/ ((module) => {

module.exports = false;


/***/ }),

/***/ 2190:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getBuiltIn = __webpack_require__(5005);
var isCallable = __webpack_require__(614);
var isPrototypeOf = __webpack_require__(7976);
var USE_SYMBOL_AS_UID = __webpack_require__(3307);

var $Object = Object;

module.exports = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn('Symbol');
  return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, $Object(it));
};


/***/ }),

/***/ 6244:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var toLength = __webpack_require__(7466);

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
module.exports = function (obj) {
  return toLength(obj.length);
};


/***/ }),

/***/ 6339:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var uncurryThis = __webpack_require__(1702);
var fails = __webpack_require__(7293);
var isCallable = __webpack_require__(614);
var hasOwn = __webpack_require__(2597);
var DESCRIPTORS = __webpack_require__(9781);
var CONFIGURABLE_FUNCTION_NAME = (__webpack_require__(6530).CONFIGURABLE);
var inspectSource = __webpack_require__(2788);
var InternalStateModule = __webpack_require__(9909);

var enforceInternalState = InternalStateModule.enforce;
var getInternalState = InternalStateModule.get;
var $String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;
var stringSlice = uncurryThis(''.slice);
var replace = uncurryThis(''.replace);
var join = uncurryThis([].join);

var CONFIGURABLE_LENGTH = DESCRIPTORS && !fails(function () {
  return defineProperty(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn = module.exports = function (value, name, options) {
  if (stringSlice($String(name), 0, 7) === 'Symbol(') {
    name = '[' + replace($String(name), /^Symbol\(([^)]*)\)/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
    if (DESCRIPTORS) defineProperty(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn(options, 'arity') && value.length !== options.arity) {
    defineProperty(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS) defineProperty(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState(value);
  if (!hasOwn(state, 'source')) {
    state.source = join(TEMPLATE, typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn(function toString() {
  return isCallable(this) && getInternalState(this).source || inspectSource(this);
}, 'toString');


/***/ }),

/***/ 4758:
/***/ ((module) => {

var ceil = Math.ceil;
var floor = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
module.exports = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor : ceil)(n);
};


/***/ }),

/***/ 3070:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var DESCRIPTORS = __webpack_require__(9781);
var IE8_DOM_DEFINE = __webpack_require__(4664);
var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__(3353);
var anObject = __webpack_require__(9670);
var toPropertyKey = __webpack_require__(4948);

var $TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE in Attributes ? Attributes[CONFIGURABLE] : current[CONFIGURABLE],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw $TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ 1236:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var DESCRIPTORS = __webpack_require__(9781);
var call = __webpack_require__(6916);
var propertyIsEnumerableModule = __webpack_require__(5296);
var createPropertyDescriptor = __webpack_require__(9114);
var toIndexedObject = __webpack_require__(5656);
var toPropertyKey = __webpack_require__(4948);
var hasOwn = __webpack_require__(2597);
var IE8_DOM_DEFINE = __webpack_require__(4664);

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPropertyKey(P);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
};


/***/ }),

/***/ 8006:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var internalObjectKeys = __webpack_require__(6324);
var enumBugKeys = __webpack_require__(748);

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),

/***/ 5181:
/***/ ((__unused_webpack_module, exports) => {

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ 7976:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var uncurryThis = __webpack_require__(1702);

module.exports = uncurryThis({}.isPrototypeOf);


/***/ }),

/***/ 6324:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var uncurryThis = __webpack_require__(1702);
var hasOwn = __webpack_require__(2597);
var toIndexedObject = __webpack_require__(5656);
var indexOf = (__webpack_require__(1318).indexOf);
var hiddenKeys = __webpack_require__(3501);

var push = uncurryThis([].push);

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn(O, key = names[i++])) {
    ~indexOf(result, key) || push(result, key);
  }
  return result;
};


/***/ }),

/***/ 1956:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var internalObjectKeys = __webpack_require__(6324);
var enumBugKeys = __webpack_require__(748);

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),

/***/ 5296:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;


/***/ }),

/***/ 288:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__(1694);
var classof = __webpack_require__(648);

// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};


/***/ }),

/***/ 2140:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var call = __webpack_require__(6916);
var isCallable = __webpack_require__(614);
var isObject = __webpack_require__(111);

var $TypeError = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  throw $TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ 3887:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getBuiltIn = __webpack_require__(5005);
var uncurryThis = __webpack_require__(1702);
var getOwnPropertyNamesModule = __webpack_require__(8006);
var getOwnPropertySymbolsModule = __webpack_require__(5181);
var anObject = __webpack_require__(9670);

var concat = uncurryThis([].concat);

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
};


/***/ }),

/***/ 4488:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isNullOrUndefined = __webpack_require__(8554);

var $TypeError = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (isNullOrUndefined(it)) throw $TypeError("Can't call method on " + it);
  return it;
};


/***/ }),

/***/ 7152:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var global = __webpack_require__(7854);
var apply = __webpack_require__(2104);
var isCallable = __webpack_require__(614);
var ENGINE_IS_BUN = __webpack_require__(9363);
var USER_AGENT = __webpack_require__(8113);
var arraySlice = __webpack_require__(206);
var validateArgumentsLength = __webpack_require__(8053);

var Function = global.Function;
// dirty IE9- and Bun 0.3.0- checks
var WRAP = /MSIE .\./.test(USER_AGENT) || ENGINE_IS_BUN && (function () {
  var version = global.Bun.version.split('.');
  return version.length < 3 || version[0] == 0 && (version[1] < 3 || version[1] == 3 && version[2] == 0);
})();

// IE9- / Bun 0.3.0- setTimeout / setInterval / setImmediate additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#timers
// https://github.com/oven-sh/bun/issues/1633
module.exports = function (scheduler, hasTimeArg) {
  var firstParamIndex = hasTimeArg ? 2 : 1;
  return WRAP ? function (handler, timeout /* , ...arguments */) {
    var boundArgs = validateArgumentsLength(arguments.length, 1) > firstParamIndex;
    var fn = isCallable(handler) ? handler : Function(handler);
    var params = boundArgs ? arraySlice(arguments, firstParamIndex) : [];
    var callback = boundArgs ? function () {
      apply(fn, this, params);
    } : fn;
    return hasTimeArg ? scheduler(callback, timeout) : scheduler(callback);
  } : scheduler;
};


/***/ }),

/***/ 6200:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var shared = __webpack_require__(2309);
var uid = __webpack_require__(9711);

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),

/***/ 5465:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var global = __webpack_require__(7854);
var defineGlobalProperty = __webpack_require__(3072);

var SHARED = '__core-js_shared__';
var store = global[SHARED] || defineGlobalProperty(SHARED, {});

module.exports = store;


/***/ }),

/***/ 2309:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var IS_PURE = __webpack_require__(1913);
var store = __webpack_require__(5465);

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.30.2',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2014-2023 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.30.2/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});


/***/ }),

/***/ 6293:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION = __webpack_require__(7392);
var fails = __webpack_require__(7293);
var global = __webpack_require__(7854);

var $String = global.String;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
  // of course, fail.
  return !$String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});


/***/ }),

/***/ 1400:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var toIntegerOrInfinity = __webpack_require__(9303);

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toIntegerOrInfinity(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),

/***/ 5656:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__(8361);
var requireObjectCoercible = __webpack_require__(4488);

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),

/***/ 9303:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var trunc = __webpack_require__(4758);

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
module.exports = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};


/***/ }),

/***/ 7466:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var toIntegerOrInfinity = __webpack_require__(9303);

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),

/***/ 7908:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var requireObjectCoercible = __webpack_require__(4488);

var $Object = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function (argument) {
  return $Object(requireObjectCoercible(argument));
};


/***/ }),

/***/ 7593:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var call = __webpack_require__(6916);
var isObject = __webpack_require__(111);
var isSymbol = __webpack_require__(2190);
var getMethod = __webpack_require__(8173);
var ordinaryToPrimitive = __webpack_require__(2140);
var wellKnownSymbol = __webpack_require__(5112);

var $TypeError = TypeError;
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function (input, pref) {
  if (!isObject(input) || isSymbol(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call(exoticToPrim, input, pref);
    if (!isObject(result) || isSymbol(result)) return result;
    throw $TypeError("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};


/***/ }),

/***/ 4948:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var toPrimitive = __webpack_require__(7593);
var isSymbol = __webpack_require__(2190);

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};


/***/ }),

/***/ 1694:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var wellKnownSymbol = __webpack_require__(5112);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),

/***/ 6330:
/***/ ((module) => {

var $String = String;

module.exports = function (argument) {
  try {
    return $String(argument);
  } catch (error) {
    return 'Object';
  }
};


/***/ }),

/***/ 9711:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var uncurryThis = __webpack_require__(1702);

var id = 0;
var postfix = Math.random();
var toString = uncurryThis(1.0.toString);

module.exports = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
};


/***/ }),

/***/ 3307:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL = __webpack_require__(6293);

module.exports = NATIVE_SYMBOL
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';


/***/ }),

/***/ 3353:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var DESCRIPTORS = __webpack_require__(9781);
var fails = __webpack_require__(7293);

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
module.exports = DESCRIPTORS && fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype != 42;
});


/***/ }),

/***/ 8053:
/***/ ((module) => {

var $TypeError = TypeError;

module.exports = function (passed, required) {
  if (passed < required) throw $TypeError('Not enough arguments');
  return passed;
};


/***/ }),

/***/ 4811:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var global = __webpack_require__(7854);
var isCallable = __webpack_require__(614);

var WeakMap = global.WeakMap;

module.exports = isCallable(WeakMap) && /native code/.test(String(WeakMap));


/***/ }),

/***/ 5112:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var global = __webpack_require__(7854);
var shared = __webpack_require__(2309);
var hasOwn = __webpack_require__(2597);
var uid = __webpack_require__(9711);
var NATIVE_SYMBOL = __webpack_require__(6293);
var USE_SYMBOL_AS_UID = __webpack_require__(3307);

var Symbol = global.Symbol;
var WellKnownSymbolsStore = shared('wks');
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol['for'] || Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!hasOwn(WellKnownSymbolsStore, name)) {
    WellKnownSymbolsStore[name] = NATIVE_SYMBOL && hasOwn(Symbol, name)
      ? Symbol[name]
      : createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};


/***/ }),

/***/ 9554:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(2109);
var forEach = __webpack_require__(8533);

// `Array.prototype.forEach` method
// https://tc39.es/ecma262/#sec-array.prototype.foreach
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
$({ target: 'Array', proto: true, forced: [].forEach != forEach }, {
  forEach: forEach
});


/***/ }),

/***/ 7658:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(2109);
var toObject = __webpack_require__(7908);
var lengthOfArrayLike = __webpack_require__(6244);
var setArrayLength = __webpack_require__(3658);
var doesNotExceedSafeInteger = __webpack_require__(7207);
var fails = __webpack_require__(7293);

var INCORRECT_TO_LENGTH = fails(function () {
  return [].push.call({ length: 0x100000000 }, 1) !== 4294967297;
});

// V8 and Safari <= 15.4, FF < 23 throws InternalError
// https://bugs.chromium.org/p/v8/issues/detail?id=12681
var properErrorOnNonWritableLength = function () {
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', { writable: false }).push();
  } catch (error) {
    return error instanceof TypeError;
  }
};

var FORCED = INCORRECT_TO_LENGTH || !properErrorOnNonWritableLength();

// `Array.prototype.push` method
// https://tc39.es/ecma262/#sec-array.prototype.push
$({ target: 'Array', proto: true, arity: 1, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  push: function push(item) {
    var O = toObject(this);
    var len = lengthOfArrayLike(O);
    var argCount = arguments.length;
    doesNotExceedSafeInteger(len + argCount);
    for (var i = 0; i < argCount; i++) {
      O[len] = arguments[i];
      len++;
    }
    setArrayLength(O, len);
    return len;
  }
});


/***/ }),

/***/ 7941:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__(2109);
var toObject = __webpack_require__(7908);
var nativeKeys = __webpack_require__(1956);
var fails = __webpack_require__(7293);

var FAILS_ON_PRIMITIVES = fails(function () { nativeKeys(1); });

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  keys: function keys(it) {
    return nativeKeys(toObject(it));
  }
});


/***/ }),

/***/ 1539:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var TO_STRING_TAG_SUPPORT = __webpack_require__(1694);
var defineBuiltIn = __webpack_require__(8052);
var toString = __webpack_require__(288);

// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!TO_STRING_TAG_SUPPORT) {
  defineBuiltIn(Object.prototype, 'toString', toString, { unsafe: true });
}


/***/ }),

/***/ 4747:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var global = __webpack_require__(7854);
var DOMIterables = __webpack_require__(8324);
var DOMTokenListPrototype = __webpack_require__(8509);
var forEach = __webpack_require__(8533);
var createNonEnumerableProperty = __webpack_require__(8880);

var handlePrototype = function (CollectionPrototype) {
  // some Chrome versions have non-configurable methods on DOMTokenList
  if (CollectionPrototype && CollectionPrototype.forEach !== forEach) try {
    createNonEnumerableProperty(CollectionPrototype, 'forEach', forEach);
  } catch (error) {
    CollectionPrototype.forEach = forEach;
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  if (DOMIterables[COLLECTION_NAME]) {
    handlePrototype(global[COLLECTION_NAME] && global[COLLECTION_NAME].prototype);
  }
}

handlePrototype(DOMTokenListPrototype);


/***/ }),

/***/ 6815:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__(2109);
var global = __webpack_require__(7854);
var schedulersFix = __webpack_require__(7152);

var setInterval = schedulersFix(global.setInterval, true);

// Bun / IE9- setInterval additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-setinterval
$({ global: true, bind: true, forced: global.setInterval !== setInterval }, {
  setInterval: setInterval
});


/***/ }),

/***/ 8417:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__(2109);
var global = __webpack_require__(7854);
var schedulersFix = __webpack_require__(7152);

var setTimeout = schedulersFix(global.setTimeout, true);

// Bun / IE9- setTimeout additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-settimeout
$({ global: true, bind: true, forced: global.setTimeout !== setTimeout }, {
  setTimeout: setTimeout
});


/***/ }),

/***/ 2564:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// TODO: Remove this module from `core-js@4` since it's split to modules listed below
__webpack_require__(6815);
__webpack_require__(8417);


/***/ }),

/***/ 3744:
/***/ ((__unused_webpack_module, exports) => {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
// runtime helper for setting properties on components
// in a tree-shakable way
exports.Z = (sfc, props) => {
    const target = sfc.__vccOpts || sfc;
    for (const [key, val] of props) {
        target[key] = val;
    }
    return target;
};


/***/ }),

/***/ 3797:
/***/ ((module) => {

"use strict";
module.exports = require("vue");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	(() => {
/******/ 		__webpack_require__.p = "";
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ entry_lib),
  "loadModalComponents": () => (/* reexport */ loadModalComponents)
});

;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
/* eslint-disable no-var */
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (false) { var getCurrentScript; }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ const setPublicPath = (null);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__(9554);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(1539);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__(4747);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__(7941);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__(7658);
// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__(3797);
// EXTERNAL MODULE: ./node_modules/@gd/colored-icons/dist/colored-icons.common.js
var colored_icons_common = __webpack_require__(6493);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/ModalApp.vue?vue&type=script&setup=true&lang=ts







var _hoisted_1 = {
  "class": "modal-app-wrap"
};


/* harmony default export */ const ModalAppvue_type_script_setup_true_lang_ts = (/*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  __name: 'ModalApp',
  props: ['m', 'l', 's', 'xs', 'size', 'icon', 'iconColor'],
  setup: function setup(__props) {
    var props = __props;
    var classes = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(function () {
      var c = [props.size ? 'modal-prop--' + props.size.toLowerCase() : ''];
      Object.keys(props).forEach(function (key) {
        if (props[key] !== undefined) {
          c.push('modal-prop--' + key);
        }
      });
      return c;
    });
    return function (_ctx, _cache) {
      return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
        "class": (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(["modal-app", classes.value])
      }, [__props.icon ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(colored_icons_common.ColoredIcon), {
        key: 0,
        name: __props.icon,
        color: __props.iconColor || 'orange'
      }, null, 8, ["name", "color"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", _hoisted_1, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default")])], 2);
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/ModalApp.vue?vue&type=script&setup=true&lang=ts
 
;// CONCATENATED MODULE: ./src/components/ModalApp.vue



const __exports__ = ModalAppvue_type_script_setup_true_lang_ts;

/* harmony default export */ const ModalApp = (__exports__);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/ModalLayout.vue?vue&type=template&id=99174a7e

var ModalLayoutvue_type_template_id_99174a7e_hoisted_1 = {
  "class": "modal-layout"
};
function render(_ctx, _cache) {
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", ModalLayoutvue_type_template_id_99174a7e_hoisted_1, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default")]);
}
;// CONCATENATED MODULE: ./src/components/ModalLayout.vue?vue&type=template&id=99174a7e

// EXTERNAL MODULE: ./node_modules/vue-loader/dist/exportHelper.js
var exportHelper = __webpack_require__(3744);
;// CONCATENATED MODULE: ./src/components/ModalLayout.vue

const script = {}

;
const ModalLayout_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(script, [['render',render]])

/* harmony default export */ const ModalLayout = (ModalLayout_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/ModalContent.vue?vue&type=template&id=3c64c8b2

var ModalContentvue_type_template_id_3c64c8b2_hoisted_1 = {
  "class": "modal-content"
};
function ModalContentvue_type_template_id_3c64c8b2_render(_ctx, _cache) {
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", ModalContentvue_type_template_id_3c64c8b2_hoisted_1, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default")]);
}
;// CONCATENATED MODULE: ./src/components/ModalContent.vue?vue&type=template&id=3c64c8b2

;// CONCATENATED MODULE: ./src/components/ModalContent.vue

const ModalContent_script = {}

;
const ModalContent_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(ModalContent_script, [['render',ModalContentvue_type_template_id_3c64c8b2_render]])

/* harmony default export */ const ModalContent = (ModalContent_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/ModalActions.vue?vue&type=template&id=57681182

var ModalActionsvue_type_template_id_57681182_hoisted_1 = {
  "class": "modal-actions"
};
function ModalActionsvue_type_template_id_57681182_render(_ctx, _cache) {
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", ModalActionsvue_type_template_id_57681182_hoisted_1, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default")]);
}
;// CONCATENATED MODULE: ./src/components/ModalActions.vue?vue&type=template&id=57681182

;// CONCATENATED MODULE: ./src/components/ModalActions.vue

const ModalActions_script = {}

;
const ModalActions_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(ModalActions_script, [['render',ModalActionsvue_type_template_id_57681182_render]])

/* harmony default export */ const ModalActions = (ModalActions_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/ModalTitle.vue?vue&type=template&id=6dcf7884

var ModalTitlevue_type_template_id_6dcf7884_hoisted_1 = {
  "class": "modal-title"
};
function ModalTitlevue_type_template_id_6dcf7884_render(_ctx, _cache) {
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", ModalTitlevue_type_template_id_6dcf7884_hoisted_1, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", null, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default")])]);
}
;// CONCATENATED MODULE: ./src/components/ModalTitle.vue?vue&type=template&id=6dcf7884

;// CONCATENATED MODULE: ./src/components/ModalTitle.vue

const ModalTitle_script = {}

;
const ModalTitle_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(ModalTitle_script, [['render',ModalTitlevue_type_template_id_6dcf7884_render]])

/* harmony default export */ const ModalTitle = (ModalTitle_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/ModalDisclaimer.vue?vue&type=template&id=3c9ca1e4

var ModalDisclaimervue_type_template_id_3c9ca1e4_hoisted_1 = {
  "class": "modal-disclaimer base ts0"
};
function ModalDisclaimervue_type_template_id_3c9ca1e4_render(_ctx, _cache) {
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", ModalDisclaimervue_type_template_id_3c9ca1e4_hoisted_1, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default")]);
}
;// CONCATENATED MODULE: ./src/components/ModalDisclaimer.vue?vue&type=template&id=3c9ca1e4

;// CONCATENATED MODULE: ./src/components/ModalDisclaimer.vue

const ModalDisclaimer_script = {}

;
const ModalDisclaimer_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(ModalDisclaimer_script, [['render',ModalDisclaimervue_type_template_id_3c9ca1e4_render]])

/* harmony default export */ const ModalDisclaimer = (ModalDisclaimer_exports_);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.timers.js
var web_timers = __webpack_require__(2564);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/CloseIcon.vue?vue&type=template&id=4a2faf94

var CloseIconvue_type_template_id_4a2faf94_hoisted_1 = {
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 30 30",
  "xml:space": "preserve"
};
var _hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("g", null, [/*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("circle", {
  cx: "15",
  cy: "15",
  r: "15.094",
  style: {
    "fill": "rgb(255, 255, 255)"
  }
}), /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("circle", {
  "class": "circle2",
  cx: "15",
  cy: "15",
  r: "10.166"
})], -1);
var _hoisted_3 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("g", {
  transform: "translate(8,8) scale(0.7)",
  style: {
    "fill": "rgb(255, 255, 255)",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd"
  }
}, [/*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("g", null, [/*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("path", {
  "class": "st1",
  d: "M12.706,10l4.736-4.736c0.744-0.744,0.744-1.962,0-2.706c-0.744-0.744-1.962-0.744-2.706,0L10,7.294\n\t\tL5.264,2.558c-0.744-0.744-1.962-0.744-2.706,0c-0.744,0.744-0.744,1.962,0,2.706L7.294,10l-4.736,4.736\n\t\tc-0.744,0.744-0.744,1.962,0,2.706c0.744,0.744,1.962,0.744,2.706,0L10,12.706l4.736,4.736c0.744,0.744,1.962,0.744,2.706,0\n\t\tc0.744-0.744,0.744-1.962,0-2.706L12.706,10z"
})])], -1);
var _hoisted_4 = [_hoisted_2, _hoisted_3];
function CloseIconvue_type_template_id_4a2faf94_render(_ctx, _cache) {
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("svg", CloseIconvue_type_template_id_4a2faf94_hoisted_1, _hoisted_4);
}
;// CONCATENATED MODULE: ./src/components/CloseIcon.vue?vue&type=template&id=4a2faf94

;// CONCATENATED MODULE: ./src/components/CloseIcon.vue

const CloseIcon_script = {}

;
const CloseIcon_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(CloseIcon_script, [['render',CloseIconvue_type_template_id_4a2faf94_render]])

/* harmony default export */ const CloseIcon = (CloseIcon_exports_);
;// CONCATENATED MODULE: ./src/lib/screenDimension.ts
/**
 * gets the dimensions form the actual window
 *
 * @returns {{w: (number|Number|*), h: (number|Number|*)}}
 */
function getDimension() {
  var ret = {
      w: document.documentElement && document.documentElement.clientWidth || window.innerWidth,
      h: document.documentElement && document.documentElement.clientHeight || window.innerHeight
    },
    dummyNode = document.createElement('div');
  // add remove to force redraw
  // some browsers may ignore workarounds like width=width
  document.body.appendChild(dummyNode);
  document.body.removeChild(dummyNode);
  return {
    w: ret.w,
    h: ret.h
  };
}
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/GdModal.vue?vue&type=script&setup=true&lang=ts



var GdModalvue_type_script_setup_true_lang_ts_hoisted_1 = ["data-qe-id"];



/* harmony default export */ const GdModalvue_type_script_setup_true_lang_ts = (/*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  __name: 'GdModal',
  props: {
    size: String,
    closeButton: Boolean,
    blocked: Boolean,
    // @close needs to be defined as prop - and then we can check if event has been registered or not (replacement of $listeners)
    onClose: Function
  },
  emits: ['closeESC', 'close', 'closeBG'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    // define $emit()
    // @Prop({ default: 'flex' }) size!: string
    // @Prop({ default: () => ({ closeButton: 'gd-modal--close-button' }) })
    // @Prop({ default: () => false }) blocked!: boolean
    var backgroundClick = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(null);
    var backgroundClickWrapper = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(null);
    var qeId = {
      closeButton: ''
    };
    var closeButton = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(true);
    var height = getDimension().h;
    var resizeTimeoutId = -1;
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.onMounted)(function () {
      if (!props.onClose) {
        // hide closebutton if no @close event is set
        closeButton.value = false;
      }
      document.addEventListener('keydown', function (e) {
        if (props.blocked) return;
        if (e.keyCode == 27) {
          emit('closeESC');
        }
      });
      window.addEventListener('resize', onResize);
    });
    function destroyed() {
      window.removeEventListener('resize', onResize);
    }
    var maxHeight = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)({
      get: function get() {
        return height - (height < 300 ? 50 : 100) + 'px';
      }
    });
    function buttonClose() {
      if (!props.blocked) {
        emit('close');
      }
    }
    function backgroundClose(event) {
      if (!props.blocked && backgroundClick.value === event.target || backgroundClickWrapper.value === event.target) {
        emit('closeBG');
      }
    }
    function onResize() {
      clearTimeout(resizeTimeoutId);
      resizeTimeoutId = setTimeout(function () {
        height = getDimension().h;
        clearTimeout(resizeTimeoutId);
      }, 500);
    }
    return function (_ctx, _cache) {
      return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Transition, {
        name: "gd-modal-component"
      }, {
        "default": (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
          return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
            ref_key: "backgroundClick",
            ref: backgroundClick,
            "class": "gd-modal-component-mask",
            onClick: _cache[1] || (_cache[1] = function ($event) {
              return backgroundClose($event);
            })
          }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
            ref_key: "backgroundClickWrapper",
            ref: backgroundClickWrapper,
            "class": "gd-modal-component-wrapper",
            onClick: _cache[0] || (_cache[0] = function ($event) {
              return backgroundClose($event);
            })
          }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
            "class": (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(["gd-modal-component-container", __props.size])
          }, [!__props.blocked && (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(closeButton) ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
            key: 0,
            "data-qe-id": qeId.closeButton,
            "class": "gd-modal-component-close",
            onClick: buttonClose
          }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(CloseIcon)], 8, GdModalvue_type_script_setup_true_lang_ts_hoisted_1)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "modal-top"), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
            "class": "gd-modal-component-body",
            style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)("max-height: ".concat(maxHeight.value))
          }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default")], 4)], 2)], 512)], 512)];
        }),
        _: 3
      });
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/GdModal.vue?vue&type=script&setup=true&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-32.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-32.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-32.use[2]!./node_modules/less-loader/dist/cjs.js??clonedRuleSet-32.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/GdModal.vue?vue&type=style&index=0&id=fbdb45f2&lang=less
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/GdModal.vue?vue&type=style&index=0&id=fbdb45f2&lang=less

;// CONCATENATED MODULE: ./src/components/GdModal.vue



;

const GdModal_exports_ = GdModalvue_type_script_setup_true_lang_ts;

/* harmony default export */ const GdModal = (GdModal_exports_);
;// CONCATENATED MODULE: ./src/main.ts







/**
 * This file is the main entry point for the component export
 */
function loadModalComponents(app) {
  app.component('modal-app', ModalApp);
  app.component('modal-layout', ModalLayout);
  app.component('modal-content', ModalContent);
  app.component('modal-actions', ModalActions);
  app.component('modal-title', ModalTitle);
  app.component('modal-disclaimer', ModalDisclaimer);
}
/* harmony default export */ const main = (GdModal);
;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ const entry_lib = (main);


})();

module.exports = __webpack_exports__;
/******/ })()
;
//# sourceMappingURL=gd-modal.common.js.map